(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7341"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7341"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cuqDd", function(module, exports) {
"use strict";
module.exports = "3.5.3";

});

parcelRegister("67d4r", function(module, exports) {
"use strict";
var $473d8913088a0f53$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $jakgl = parcelRequire("jakgl");
module.exports = function hasNativeSymbols() {
    if (typeof $473d8913088a0f53$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $473d8913088a0f53$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $jakgl();
};

});
parcelRegister("jakgl", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("gc35z", function(module, exports) {
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ var $bca029b5b76df1be$var$Hogan = {};
(function(Hogan) {
    Hogan.Template = function(codeObj, text, compiler, options) {
        codeObj = codeObj || {};
        this.r = codeObj.code || this.r;
        this.c = compiler;
        this.options = options || {};
        this.text = text || "";
        this.partials = codeObj.partials || {};
        this.subs = codeObj.subs || {};
        this.buf = "";
    };
    Hogan.Template.prototype = {
        // render: replaced by generated code.
        r: function(context, partials, indent) {
            return "";
        },
        // variable escaping
        v: hoganEscape,
        // triple stache
        t: coerceToString,
        render: function render(context, partials, indent) {
            return this.ri([
                context
            ], partials || {}, indent);
        },
        // render internal -- a hook for overrides that catches partials too
        ri: function(context, partials, indent) {
            return this.r(context, partials, indent);
        },
        // ensurePartial
        ep: function(symbol, partials) {
            var partial = this.partials[symbol];
            // check to see that if we've instantiated this partial before
            var template = partials[partial.name];
            if (partial.instance && partial.base == template) return partial.instance;
            if (typeof template == "string") {
                if (!this.c) throw new Error("No compiler available.");
                template = this.c.compile(template, this.options);
            }
            if (!template) return null;
            // We use this to check whether the partials dictionary has changed
            this.partials[symbol].base = template;
            if (partial.subs) {
                // Make sure we consider parent template now
                if (!partials.stackText) partials.stackText = {};
                for(key in partial.subs)if (!partials.stackText[key]) partials.stackText[key] = this.activeSub !== undefined && partials.stackText[this.activeSub] ? partials.stackText[this.activeSub] : this.text;
                template = createSpecializedPartial(template, partial.subs, partial.partials, this.stackSubs, this.stackPartials, partials.stackText);
            }
            this.partials[symbol].instance = template;
            return template;
        },
        // tries to find a partial in the current scope and render it
        rp: function(symbol, context, partials, indent) {
            var partial = this.ep(symbol, partials);
            if (!partial) return "";
            return partial.ri(context, partials, indent);
        },
        // render a section
        rs: function(context, partials, section) {
            var tail = context[context.length - 1];
            if (!isArray(tail)) {
                section(context, partials, this);
                return;
            }
            for(var i = 0; i < tail.length; i++){
                context.push(tail[i]);
                section(context, partials, this);
                context.pop();
            }
        },
        // maybe start a section
        s: function(val, ctx, partials, inverted, start, end, tags) {
            var pass;
            if (isArray(val) && val.length === 0) return false;
            if (typeof val == "function") val = this.ms(val, ctx, partials, inverted, start, end, tags);
            pass = !!val;
            if (!inverted && pass && ctx) ctx.push(typeof val == "object" ? val : ctx[ctx.length - 1]);
            return pass;
        },
        // find values with dotted names
        d: function(key1, ctx, partials, returnFound) {
            var found, names = key1.split("."), val = this.f(names[0], ctx, partials, returnFound), doModelGet = this.options.modelGet, cx = null;
            if (key1 === "." && isArray(ctx[ctx.length - 2])) val = ctx[ctx.length - 1];
            else for(var i = 1; i < names.length; i++){
                found = findInScope(names[i], val, doModelGet);
                if (found !== undefined) {
                    cx = val;
                    val = found;
                } else val = "";
            }
            if (returnFound && !val) return false;
            if (!returnFound && typeof val == "function") {
                ctx.push(cx);
                val = this.mv(val, ctx, partials);
                ctx.pop();
            }
            return val;
        },
        // find values with normal names
        f: function(key1, ctx, partials, returnFound) {
            var val = false, v = null, found = false, doModelGet = this.options.modelGet;
            for(var i = ctx.length - 1; i >= 0; i--){
                v = ctx[i];
                val = findInScope(key1, v, doModelGet);
                if (val !== undefined) {
                    found = true;
                    break;
                }
            }
            if (!found) return returnFound ? false : "";
            if (!returnFound && typeof val == "function") val = this.mv(val, ctx, partials);
            return val;
        },
        // higher order templates
        ls: function(func, cx, partials, text, tags) {
            var oldTags = this.options.delimiters;
            this.options.delimiters = tags;
            this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
            this.options.delimiters = oldTags;
            return false;
        },
        // compile text
        ct: function(text, cx, partials) {
            if (this.options.disableLambda) throw new Error("Lambda features disabled.");
            return this.c.compile(text, this.options).render(cx, partials);
        },
        // template result buffering
        b: function(s) {
            this.buf += s;
        },
        fl: function() {
            var r = this.buf;
            this.buf = "";
            return r;
        },
        // method replace section
        ms: function(func, ctx, partials, inverted, start, end, tags) {
            var textSource, cx = ctx[ctx.length - 1], result = func.call(cx);
            if (typeof result == "function") {
                if (inverted) return true;
                else {
                    textSource = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text;
                    return this.ls(result, cx, partials, textSource.substring(start, end), tags);
                }
            }
            return result;
        },
        // method replace variable
        mv: function(func, ctx, partials) {
            var cx = ctx[ctx.length - 1];
            var result = func.call(cx);
            if (typeof result == "function") return this.ct(coerceToString(result.call(cx)), cx, partials);
            return result;
        },
        sub: function(name, context, partials, indent) {
            var f = this.subs[name];
            if (f) {
                this.activeSub = name;
                f(context, partials, this, indent);
                this.activeSub = false;
            }
        }
    };
    //Find a key in an object
    function findInScope(key1, scope, doModelGet) {
        var val;
        if (scope && typeof scope == "object") {
            if (scope[key1] !== undefined) val = scope[key1];
            else if (doModelGet && scope.get && typeof scope.get == "function") val = scope.get(key1);
        }
        return val;
    }
    function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
        function PartialTemplate() {}
        PartialTemplate.prototype = instance;
        function Substitutions() {}
        Substitutions.prototype = instance.subs;
        var key1;
        var partial = new PartialTemplate();
        partial.subs = new Substitutions();
        partial.subsText = {}; //hehe. substext.
        partial.buf = "";
        stackSubs = stackSubs || {};
        partial.stackSubs = stackSubs;
        partial.subsText = stackText;
        for(key1 in subs)if (!stackSubs[key1]) stackSubs[key1] = subs[key1];
        for(key1 in stackSubs)partial.subs[key1] = stackSubs[key1];
        stackPartials = stackPartials || {};
        partial.stackPartials = stackPartials;
        for(key1 in partials)if (!stackPartials[key1]) stackPartials[key1] = partials[key1];
        for(key1 in stackPartials)partial.partials[key1] = stackPartials[key1];
        return partial;
    }
    var rAmp = /&/g, rLt = /</g, rGt = />/g, rApos = /\'/g, rQuot = /\"/g, hChars = /[&<>\"\']/;
    function coerceToString(val) {
        return String(val === null || val === undefined ? "" : val);
    }
    function hoganEscape(str) {
        str = coerceToString(str);
        return hChars.test(str) ? str.replace(rAmp, "&amp;").replace(rLt, "&lt;").replace(rGt, "&gt;").replace(rApos, "&#39;").replace(rQuot, "&quot;") : str;
    }
    var isArray = Array.isArray || function(a) {
        return Object.prototype.toString.call(a) === "[object Array]";
    };
})(module.exports);

});

var $f527039beb4b4151$exports = {};
(function(global, factory) {
    $f527039beb4b4151$exports = factory();
})($f527039beb4b4151$exports, function() {
    "use strict";
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    // Thanks @stimulus:
    // https://github.com/stimulusjs/stimulus/blob/master/packages/%40stimulus/core/src/application.ts
    function domReady() {
        return new Promise((resolve)=>{
            if (document.readyState == "loading") document.addEventListener("DOMContentLoaded", resolve);
            else resolve();
        });
    }
    function arrayUnique(array) {
        return Array.from(new Set(array));
    }
    function isTesting() {
        return navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom");
    }
    function checkedAttrLooseCompare(valueA, valueB) {
        return valueA == valueB;
    }
    function warnIfMalformedTemplate(el, directive) {
        if (el.tagName.toLowerCase() !== "template") console.warn(`Alpine: [${directive}] directive should only be added to <template> tags. See https://github.com/alpinejs/alpine#${directive}`);
        else if (el.content.childElementCount !== 1) console.warn(`Alpine: <template> tag with [${directive}] encountered with an unexpected number of root elements. Make sure <template> has a single root element. `);
    }
    function kebabCase(subject) {
        return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
    }
    function camelCase(subject) {
        return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
    }
    function walk(el, callback) {
        if (callback(el) === false) return;
        let node = el.firstElementChild;
        while(node){
            walk(node, callback);
            node = node.nextElementSibling;
        }
    }
    function debounce(func, wait) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function later() {
                timeout = null;
                func.apply(context, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    const handleError = (el, expression, error)=>{
        console.warn(`Alpine Error: "${error}"\n\nExpression: "${expression}"\nElement:`, el);
        if (!isTesting()) {
            Object.assign(error, {
                el: el,
                expression: expression
            });
            throw error;
        }
    };
    function tryCatch(cb, { el: el, expression: expression }) {
        try {
            const value = cb();
            return value instanceof Promise ? value.catch((e)=>handleError(el, expression, e)) : value;
        } catch (e) {
            handleError(el, expression, e);
        }
    }
    function saferEval(el, expression, dataContext, additionalHelperVariables = {}) {
        return tryCatch(()=>{
            if (typeof expression === "function") return expression.call(dataContext);
            return new Function([
                "$data",
                ...Object.keys(additionalHelperVariables)
            ], `var __alpine_result; with($data) { __alpine_result = ${expression} }; return __alpine_result`)(dataContext, ...Object.values(additionalHelperVariables));
        }, {
            el: el,
            expression: expression
        });
    }
    function saferEvalNoReturn(el, expression, dataContext, additionalHelperVariables = {}) {
        return tryCatch(()=>{
            if (typeof expression === "function") return Promise.resolve(expression.call(dataContext, additionalHelperVariables["$event"]));
            let AsyncFunction = Function;
            /* MODERN-ONLY:START */ AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
            /* MODERN-ONLY:END */ // For the cases when users pass only a function reference to the caller: `x-on:click="foo"`
            // Where "foo" is a function. Also, we'll pass the function the event instance when we call it.
            if (Object.keys(dataContext).includes(expression)) {
                let methodReference = new Function([
                    "dataContext",
                    ...Object.keys(additionalHelperVariables)
                ], `with(dataContext) { return ${expression} }`)(dataContext, ...Object.values(additionalHelperVariables));
                if (typeof methodReference === "function") return Promise.resolve(methodReference.call(dataContext, additionalHelperVariables["$event"]));
                else return Promise.resolve();
            }
            return Promise.resolve(new AsyncFunction([
                "dataContext",
                ...Object.keys(additionalHelperVariables)
            ], `with(dataContext) { ${expression} }`)(dataContext, ...Object.values(additionalHelperVariables)));
        }, {
            el: el,
            expression: expression
        });
    }
    const xAttrRE = /^x-(on|bind|data|text|html|model|if|for|show|cloak|transition|ref|spread)\b/;
    function isXAttr(attr) {
        const name = replaceAtAndColonWithStandardSyntax(attr.name);
        return xAttrRE.test(name);
    }
    function getXAttrs(el, component, type) {
        let directives = Array.from(el.attributes).filter(isXAttr).map(parseHtmlAttribute); // Get an object of directives from x-spread.
        let spreadDirective = directives.filter((directive)=>directive.type === "spread")[0];
        if (spreadDirective) {
            let spreadObject = saferEval(el, spreadDirective.expression, component.$data); // Add x-spread directives to the pile of existing directives.
            directives = directives.concat(Object.entries(spreadObject).map(([name, value])=>parseHtmlAttribute({
                    name: name,
                    value: value
                })));
        }
        if (type) return directives.filter((i)=>i.type === type);
        return sortDirectives(directives);
    }
    function sortDirectives(directives) {
        let directiveOrder = [
            "bind",
            "model",
            "show",
            "catch-all"
        ];
        return directives.sort((a, b)=>{
            let typeA = directiveOrder.indexOf(a.type) === -1 ? "catch-all" : a.type;
            let typeB = directiveOrder.indexOf(b.type) === -1 ? "catch-all" : b.type;
            return directiveOrder.indexOf(typeA) - directiveOrder.indexOf(typeB);
        });
    }
    function parseHtmlAttribute({ name: name, value: value }) {
        const normalizedName = replaceAtAndColonWithStandardSyntax(name);
        const typeMatch = normalizedName.match(xAttrRE);
        const valueMatch = normalizedName.match(/:([a-zA-Z0-9\-:]+)/);
        const modifiers = normalizedName.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value
        };
    }
    function isBooleanAttr(attrName) {
        // As per HTML spec table https://html.spec.whatwg.org/multipage/indices.html#attributes-3:boolean-attribute
        // Array roughly ordered by estimated usage
        const booleanAttributes = [
            "disabled",
            "checked",
            "required",
            "readonly",
            "hidden",
            "open",
            "selected",
            "autofocus",
            "itemscope",
            "multiple",
            "novalidate",
            "allowfullscreen",
            "allowpaymentrequest",
            "formnovalidate",
            "autoplay",
            "controls",
            "loop",
            "muted",
            "playsinline",
            "default",
            "ismap",
            "reversed",
            "async",
            "defer",
            "nomodule"
        ];
        return booleanAttributes.includes(attrName);
    }
    function replaceAtAndColonWithStandardSyntax(name) {
        if (name.startsWith("@")) return name.replace("@", "x-on:");
        else if (name.startsWith(":")) return name.replace(":", "x-bind:");
        return name;
    }
    function convertClassStringToArray(classList, filterFn = Boolean) {
        return classList.split(" ").filter(filterFn);
    }
    const TRANSITION_TYPE_IN = "in";
    const TRANSITION_TYPE_OUT = "out";
    const TRANSITION_CANCELLED = "cancelled";
    function transitionIn(el, show, reject, component, forceSkip = false) {
        // We don't want to transition on the initial page load.
        if (forceSkip) return show();
        if (el.__x_transition && el.__x_transition.type === TRANSITION_TYPE_IN) // there is already a similar transition going on, this was probably triggered by
        // a change in a different property, let's just leave the previous one doing its job
        return;
        const attrs = getXAttrs(el, component, "transition");
        const showAttr = getXAttrs(el, component, "show")[0]; // If this is triggered by a x-show.transition.
        if (showAttr && showAttr.modifiers.includes("transition")) {
            let modifiers = showAttr.modifiers; // If x-show.transition.out, we'll skip the "in" transition.
            if (modifiers.includes("out") && !modifiers.includes("in")) return show();
            const settingBothSidesOfTransition = modifiers.includes("in") && modifiers.includes("out"); // If x-show.transition.in...out... only use "in" related modifiers for this transition.
            modifiers = settingBothSidesOfTransition ? modifiers.filter((i, index)=>index < modifiers.indexOf("out")) : modifiers;
            transitionHelperIn(el, modifiers, show, reject); // Otherwise, we can assume x-transition:enter.
        } else if (attrs.some((attr)=>[
                "enter",
                "enter-start",
                "enter-end"
            ].includes(attr.value))) transitionClassesIn(el, component, attrs, show, reject);
        else // If neither, just show that damn thing.
        show();
    }
    function transitionOut(el, hide, reject, component, forceSkip = false) {
        // We don't want to transition on the initial page load.
        if (forceSkip) return hide();
        if (el.__x_transition && el.__x_transition.type === TRANSITION_TYPE_OUT) // there is already a similar transition going on, this was probably triggered by
        // a change in a different property, let's just leave the previous one doing its job
        return;
        const attrs = getXAttrs(el, component, "transition");
        const showAttr = getXAttrs(el, component, "show")[0];
        if (showAttr && showAttr.modifiers.includes("transition")) {
            let modifiers = showAttr.modifiers;
            if (modifiers.includes("in") && !modifiers.includes("out")) return hide();
            const settingBothSidesOfTransition = modifiers.includes("in") && modifiers.includes("out");
            modifiers = settingBothSidesOfTransition ? modifiers.filter((i, index)=>index > modifiers.indexOf("out")) : modifiers;
            transitionHelperOut(el, modifiers, settingBothSidesOfTransition, hide, reject);
        } else if (attrs.some((attr)=>[
                "leave",
                "leave-start",
                "leave-end"
            ].includes(attr.value))) transitionClassesOut(el, component, attrs, hide, reject);
        else hide();
    }
    function transitionHelperIn(el, modifiers, showCallback, reject) {
        // Default values inspired by: https://material.io/design/motion/speed.html#duration
        const styleValues = {
            duration: modifierValue(modifiers, "duration", 150),
            origin: modifierValue(modifiers, "origin", "center"),
            first: {
                opacity: 0,
                scale: modifierValue(modifiers, "scale", 95)
            },
            second: {
                opacity: 1,
                scale: 100
            }
        };
        transitionHelper(el, modifiers, showCallback, ()=>{}, reject, styleValues, TRANSITION_TYPE_IN);
    }
    function transitionHelperOut(el, modifiers, settingBothSidesOfTransition, hideCallback, reject) {
        // Make the "out" transition .5x slower than the "in". (Visually better)
        // HOWEVER, if they explicitly set a duration for the "out" transition,
        // use that.
        const duration = settingBothSidesOfTransition ? modifierValue(modifiers, "duration", 150) : modifierValue(modifiers, "duration", 150) / 2;
        const styleValues = {
            duration: duration,
            origin: modifierValue(modifiers, "origin", "center"),
            first: {
                opacity: 1,
                scale: 100
            },
            second: {
                opacity: 0,
                scale: modifierValue(modifiers, "scale", 95)
            }
        };
        transitionHelper(el, modifiers, ()=>{}, hideCallback, reject, styleValues, TRANSITION_TYPE_OUT);
    }
    function modifierValue(modifiers, key, fallback) {
        // If the modifier isn't present, use the default.
        if (modifiers.indexOf(key) === -1) return fallback; // If it IS present, grab the value after it: x-show.transition.duration.500ms
        const rawValue = modifiers[modifiers.indexOf(key) + 1];
        if (!rawValue) return fallback;
        if (key === "scale") {
            // Check if the very next value is NOT a number and return the fallback.
            // If x-show.transition.scale, we'll use the default scale value.
            // That is how a user opts out of the opacity transition.
            if (!isNumeric(rawValue)) return fallback;
        }
        if (key === "duration") {
            // Support x-show.transition.duration.500ms && duration.500
            let match = rawValue.match(/([0-9]+)ms/);
            if (match) return match[1];
        }
        if (key === "origin") {
            // Support chaining origin directions: x-show.transition.top.right
            if ([
                "top",
                "right",
                "left",
                "center",
                "bottom"
            ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
                rawValue,
                modifiers[modifiers.indexOf(key) + 2]
            ].join(" ");
        }
        return rawValue;
    }
    function transitionHelper(el, modifiers, hook1, hook2, reject, styleValues, type) {
        // clear the previous transition if exists to avoid caching the wrong styles
        if (el.__x_transition) el.__x_transition.cancel && el.__x_transition.cancel();
         // If the user set these style values, we'll put them back when we're done with them.
        const opacityCache = el.style.opacity;
        const transformCache = el.style.transform;
        const transformOriginCache = el.style.transformOrigin; // If no modifiers are present: x-show.transition, we'll default to both opacity and scale.
        const noModifiers = !modifiers.includes("opacity") && !modifiers.includes("scale");
        const transitionOpacity = noModifiers || modifiers.includes("opacity");
        const transitionScale = noModifiers || modifiers.includes("scale"); // These are the explicit stages of a transition (same stages for in and for out).
        // This way you can get a birds eye view of the hooks, and the differences
        // between them.
        const stages = {
            start () {
                if (transitionOpacity) el.style.opacity = styleValues.first.opacity;
                if (transitionScale) el.style.transform = `scale(${styleValues.first.scale / 100})`;
            },
            during () {
                if (transitionScale) el.style.transformOrigin = styleValues.origin;
                el.style.transitionProperty = [
                    transitionOpacity ? `opacity` : ``,
                    transitionScale ? `transform` : ``
                ].join(" ").trim();
                el.style.transitionDuration = `${styleValues.duration / 1000}s`;
                el.style.transitionTimingFunction = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
            },
            show () {
                hook1();
            },
            end () {
                if (transitionOpacity) el.style.opacity = styleValues.second.opacity;
                if (transitionScale) el.style.transform = `scale(${styleValues.second.scale / 100})`;
            },
            hide () {
                hook2();
            },
            cleanup () {
                if (transitionOpacity) el.style.opacity = opacityCache;
                if (transitionScale) el.style.transform = transformCache;
                if (transitionScale) el.style.transformOrigin = transformOriginCache;
                el.style.transitionProperty = null;
                el.style.transitionDuration = null;
                el.style.transitionTimingFunction = null;
            }
        };
        transition(el, stages, type, reject);
    }
    const ensureStringExpression = (expression, el, component)=>{
        return typeof expression === "function" ? component.evaluateReturnExpression(el, expression) : expression;
    };
    function transitionClassesIn(el, component, directives, showCallback, reject) {
        const enter = convertClassStringToArray(ensureStringExpression((directives.find((i)=>i.value === "enter") || {
            expression: ""
        }).expression, el, component));
        const enterStart = convertClassStringToArray(ensureStringExpression((directives.find((i)=>i.value === "enter-start") || {
            expression: ""
        }).expression, el, component));
        const enterEnd = convertClassStringToArray(ensureStringExpression((directives.find((i)=>i.value === "enter-end") || {
            expression: ""
        }).expression, el, component));
        transitionClasses(el, enter, enterStart, enterEnd, showCallback, ()=>{}, TRANSITION_TYPE_IN, reject);
    }
    function transitionClassesOut(el, component, directives, hideCallback, reject) {
        const leave = convertClassStringToArray(ensureStringExpression((directives.find((i)=>i.value === "leave") || {
            expression: ""
        }).expression, el, component));
        const leaveStart = convertClassStringToArray(ensureStringExpression((directives.find((i)=>i.value === "leave-start") || {
            expression: ""
        }).expression, el, component));
        const leaveEnd = convertClassStringToArray(ensureStringExpression((directives.find((i)=>i.value === "leave-end") || {
            expression: ""
        }).expression, el, component));
        transitionClasses(el, leave, leaveStart, leaveEnd, ()=>{}, hideCallback, TRANSITION_TYPE_OUT, reject);
    }
    function transitionClasses(el, classesDuring, classesStart, classesEnd, hook1, hook2, type, reject) {
        // clear the previous transition if exists to avoid caching the wrong classes
        if (el.__x_transition) el.__x_transition.cancel && el.__x_transition.cancel();
        const originalClasses = el.__x_original_classes || [];
        const stages = {
            start () {
                el.classList.add(...classesStart);
            },
            during () {
                el.classList.add(...classesDuring);
            },
            show () {
                hook1();
            },
            end () {
                // Don't remove classes that were in the original class attribute.
                el.classList.remove(...classesStart.filter((i)=>!originalClasses.includes(i)));
                el.classList.add(...classesEnd);
            },
            hide () {
                hook2();
            },
            cleanup () {
                el.classList.remove(...classesDuring.filter((i)=>!originalClasses.includes(i)));
                el.classList.remove(...classesEnd.filter((i)=>!originalClasses.includes(i)));
            }
        };
        transition(el, stages, type, reject);
    }
    function transition(el, stages, type, reject) {
        const finish = once(()=>{
            stages.hide(); // Adding an "isConnected" check, in case the callback
            // removed the element from the DOM.
            if (el.isConnected) stages.cleanup();
            delete el.__x_transition;
        });
        el.__x_transition = {
            // Set transition type so we can avoid clearing transition if the direction is the same
            type: type,
            // create a callback for the last stages of the transition so we can call it
            // from different point and early terminate it. Once will ensure that function
            // is only called one time.
            cancel: once(()=>{
                reject(TRANSITION_CANCELLED);
                finish();
            }),
            finish: finish,
            // This store the next animation frame so we can cancel it
            nextFrame: null
        };
        stages.start();
        stages.during();
        el.__x_transition.nextFrame = requestAnimationFrame(()=>{
            // Note: Safari's transitionDuration property will list out comma separated transition durations
            // for every single transition property. Let's grab the first one and call it a day.
            let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1000;
            if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1000;
            stages.show();
            el.__x_transition.nextFrame = requestAnimationFrame(()=>{
                stages.end();
                setTimeout(el.__x_transition.finish, duration);
            });
        });
    }
    function isNumeric(subject) {
        return !Array.isArray(subject) && !isNaN(subject);
    } // Thanks @vuejs
    // https://github.com/vuejs/vue/blob/4de4649d9637262a9b007720b59f80ac72a5620c/src/shared/util.js
    function once(callback) {
        let called = false;
        return function() {
            if (!called) {
                called = true;
                callback.apply(this, arguments);
            }
        };
    }
    function handleForDirective(component, templateEl, expression, initialUpdate, extraVars) {
        warnIfMalformedTemplate(templateEl, "x-for");
        let iteratorNames = typeof expression === "function" ? parseForExpression(component.evaluateReturnExpression(templateEl, expression)) : parseForExpression(expression);
        let items = evaluateItemsAndReturnEmptyIfXIfIsPresentAndFalseOnElement(component, templateEl, iteratorNames, extraVars); // As we walk the array, we'll also walk the DOM (updating/creating as we go).
        let currentEl = templateEl;
        items.forEach((item, index)=>{
            let iterationScopeVariables = getIterationScopeVariables(iteratorNames, item, index, items, extraVars());
            let currentKey = generateKeyForIteration(component, templateEl, index, iterationScopeVariables);
            let nextEl = lookAheadForMatchingKeyedElementAndMoveItIfFound(currentEl.nextElementSibling, currentKey); // If we haven't found a matching key, insert the element at the current position.
            if (!nextEl) {
                nextEl = addElementInLoopAfterCurrentEl(templateEl, currentEl); // And transition it in if it's not the first page load.
                transitionIn(nextEl, ()=>{}, ()=>{}, component, initialUpdate);
                nextEl.__x_for = iterationScopeVariables;
                component.initializeElements(nextEl, ()=>nextEl.__x_for); // Otherwise update the element we found.
            } else {
                // Temporarily remove the key indicator to allow the normal "updateElements" to work.
                delete nextEl.__x_for_key;
                nextEl.__x_for = iterationScopeVariables;
                component.updateElements(nextEl, ()=>nextEl.__x_for);
            }
            currentEl = nextEl;
            currentEl.__x_for_key = currentKey;
        });
        removeAnyLeftOverElementsFromPreviousUpdate(currentEl, component);
    } // This was taken from VueJS 2.* core. Thanks Vue!
    function parseForExpression(expression) {
        let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
        let stripParensRE = /^\(|\)$/g;
        let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
        let inMatch = String(expression).match(forAliasRE);
        if (!inMatch) return;
        let res = {};
        res.items = inMatch[2].trim();
        let item = inMatch[1].trim().replace(stripParensRE, "");
        let iteratorMatch = item.match(forIteratorRE);
        if (iteratorMatch) {
            res.item = item.replace(forIteratorRE, "").trim();
            res.index = iteratorMatch[1].trim();
            if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
        } else res.item = item;
        return res;
    }
    function getIterationScopeVariables(iteratorNames, item, index, items, extraVars) {
        // We must create a new object, so each iteration has a new scope
        let scopeVariables = extraVars ? _objectSpread2({}, extraVars) : {};
        scopeVariables[iteratorNames.item] = item;
        if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
        if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
        return scopeVariables;
    }
    function generateKeyForIteration(component, el, index, iterationScopeVariables) {
        let bindKeyAttribute = getXAttrs(el, component, "bind").filter((attr)=>attr.value === "key")[0]; // If the dev hasn't specified a key, just return the index of the iteration.
        if (!bindKeyAttribute) return index;
        return component.evaluateReturnExpression(el, bindKeyAttribute.expression, ()=>iterationScopeVariables);
    }
    function evaluateItemsAndReturnEmptyIfXIfIsPresentAndFalseOnElement(component, el, iteratorNames, extraVars) {
        let ifAttribute = getXAttrs(el, component, "if")[0];
        if (ifAttribute && !component.evaluateReturnExpression(el, ifAttribute.expression)) return [];
        let items = component.evaluateReturnExpression(el, iteratorNames.items, extraVars); // This adds support for the `i in n` syntax.
        if (isNumeric(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        return items;
    }
    function addElementInLoopAfterCurrentEl(templateEl, currentEl) {
        let clone = document.importNode(templateEl.content, true);
        currentEl.parentElement.insertBefore(clone, currentEl.nextElementSibling);
        return currentEl.nextElementSibling;
    }
    function lookAheadForMatchingKeyedElementAndMoveItIfFound(nextEl, currentKey) {
        if (!nextEl) return; // If we are already past the x-for generated elements, we don't need to look ahead.
        if (nextEl.__x_for_key === undefined) return; // If the the key's DO match, no need to look ahead.
        if (nextEl.__x_for_key === currentKey) return nextEl; // If they don't, we'll look ahead for a match.
        // If we find it, we'll move it to the current position in the loop.
        let tmpNextEl = nextEl;
        while(tmpNextEl){
            if (tmpNextEl.__x_for_key === currentKey) return tmpNextEl.parentElement.insertBefore(tmpNextEl, nextEl);
            tmpNextEl = tmpNextEl.nextElementSibling && tmpNextEl.nextElementSibling.__x_for_key !== undefined ? tmpNextEl.nextElementSibling : false;
        }
    }
    function removeAnyLeftOverElementsFromPreviousUpdate(currentEl, component) {
        var nextElementFromOldLoop = currentEl.nextElementSibling && currentEl.nextElementSibling.__x_for_key !== undefined ? currentEl.nextElementSibling : false;
        while(nextElementFromOldLoop){
            let nextElementFromOldLoopImmutable = nextElementFromOldLoop;
            let nextSibling = nextElementFromOldLoop.nextElementSibling;
            transitionOut(nextElementFromOldLoop, ()=>{
                nextElementFromOldLoopImmutable.remove();
            }, ()=>{}, component);
            nextElementFromOldLoop = nextSibling && nextSibling.__x_for_key !== undefined ? nextSibling : false;
        }
    }
    function handleAttributeBindingDirective(component, el, attrName, expression, extraVars, attrType, modifiers) {
        var value = component.evaluateReturnExpression(el, expression, extraVars);
        if (attrName === "value") {
            if (Alpine.ignoreFocusedForValueBinding && document.activeElement.isSameNode(el)) return; // If nested model key is undefined, set the default value to empty string.
            if (value === undefined && String(expression).match(/\./)) value = "";
            if (el.type === "radio") {
                // Set radio value from x-bind:value, if no "value" attribute exists.
                // If there are any initial state values, radio will have a correct
                // "checked" value since x-bind:value is processed before x-model.
                if (el.attributes.value === undefined && attrType === "bind") el.value = value;
                else if (attrType !== "bind") el.checked = checkedAttrLooseCompare(el.value, value);
            } else if (el.type === "checkbox") {
                // If we are explicitly binding a string to the :value, set the string,
                // If the value is a boolean, leave it alone, it will be set to "on"
                // automatically.
                if (typeof value !== "boolean" && ![
                    null,
                    undefined
                ].includes(value) && attrType === "bind") el.value = String(value);
                else if (attrType !== "bind") {
                    if (Array.isArray(value)) // I'm purposely not using Array.includes here because it's
                    // strict, and because of Numeric/String mis-casting, I
                    // want the "includes" to be "fuzzy".
                    el.checked = value.some((val)=>checkedAttrLooseCompare(val, el.value));
                    else el.checked = !!value;
                }
            } else if (el.tagName === "SELECT") updateSelect(el, value);
            else {
                if (el.value === value) return;
                el.value = value;
            }
        } else if (attrName === "class") {
            if (Array.isArray(value)) {
                const originalClasses = el.__x_original_classes || [];
                el.setAttribute("class", arrayUnique(originalClasses.concat(value)).join(" "));
            } else if (typeof value === "object") {
                // Sorting the keys / class names by their boolean value will ensure that
                // anything that evaluates to `false` and needs to remove classes is run first.
                const keysSortedByBooleanValue = Object.keys(value).sort((a, b)=>value[a] - value[b]);
                keysSortedByBooleanValue.forEach((classNames)=>{
                    if (value[classNames]) convertClassStringToArray(classNames).forEach((className)=>el.classList.add(className));
                    else convertClassStringToArray(classNames).forEach((className)=>el.classList.remove(className));
                });
            } else {
                const originalClasses = el.__x_original_classes || [];
                const newClasses = value ? convertClassStringToArray(value) : [];
                el.setAttribute("class", arrayUnique(originalClasses.concat(newClasses)).join(" "));
            }
        } else {
            attrName = modifiers.includes("camel") ? camelCase(attrName) : attrName; // If an attribute's bound value is null, undefined or false, remove the attribute
            if ([
                null,
                undefined,
                false
            ].includes(value)) el.removeAttribute(attrName);
            else isBooleanAttr(attrName) ? setIfChanged(el, attrName, attrName) : setIfChanged(el, attrName, value);
        }
    }
    function setIfChanged(el, attrName, value) {
        if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
    }
    function updateSelect(el, value) {
        const arrayWrappedValue = [].concat(value).map((value)=>{
            return value + "";
        });
        Array.from(el.options).forEach((option)=>{
            option.selected = arrayWrappedValue.includes(option.value || option.text);
        });
    }
    function handleTextDirective(el, output, expression) {
        // If nested model key is undefined, set the default value to empty string.
        if (output === undefined && String(expression).match(/\./)) output = "";
        el.textContent = output;
    }
    function handleHtmlDirective(component, el, expression, extraVars) {
        el.innerHTML = component.evaluateReturnExpression(el, expression, extraVars);
    }
    function handleShowDirective(component, el, value, modifiers, initialUpdate = false) {
        const hide = ()=>{
            el.style.display = "none";
            el.__x_is_shown = false;
        };
        const show = ()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
            el.__x_is_shown = true;
        };
        if (initialUpdate === true) {
            if (value) show();
            else hide();
            return;
        }
        const handle = (resolve, reject)=>{
            if (value) {
                if (el.style.display === "none" || el.__x_transition) transitionIn(el, ()=>{
                    show();
                }, reject, component);
                resolve(()=>{});
            } else if (el.style.display !== "none") transitionOut(el, ()=>{
                resolve(()=>{
                    hide();
                });
            }, reject, component);
            else resolve(()=>{});
        }; // The working of x-show is a bit complex because we need to
        // wait for any child transitions to finish before hiding
        // some element. Also, this has to be done recursively.
        // If x-show.immediate, foregoe the waiting.
        if (modifiers.includes("immediate")) {
            handle((finish)=>finish(), ()=>{});
            return;
        } // x-show is encountered during a DOM tree walk. If an element
        // we encounter is NOT a child of another x-show element we
        // can execute the previous x-show stack (if one exists).
        if (component.showDirectiveLastElement && !component.showDirectiveLastElement.contains(el)) component.executeAndClearRemainingShowDirectiveStack();
        component.showDirectiveStack.push(handle);
        component.showDirectiveLastElement = el;
    }
    function handleIfDirective(component, el, expressionResult, initialUpdate, extraVars) {
        warnIfMalformedTemplate(el, "x-if");
        const elementHasAlreadyBeenAdded = el.nextElementSibling && el.nextElementSibling.__x_inserted_me === true;
        if (expressionResult && (!elementHasAlreadyBeenAdded || el.__x_transition)) {
            const clone = document.importNode(el.content, true);
            el.parentElement.insertBefore(clone, el.nextElementSibling);
            transitionIn(el.nextElementSibling, ()=>{}, ()=>{}, component, initialUpdate);
            component.initializeElements(el.nextElementSibling, extraVars);
            el.nextElementSibling.__x_inserted_me = true;
        } else if (!expressionResult && elementHasAlreadyBeenAdded) transitionOut(el.nextElementSibling, ()=>{
            el.nextElementSibling.remove();
        }, ()=>{}, component, initialUpdate);
    }
    function registerListener(component, el, event, modifiers, expression, extraVars = {}) {
        const options = {
            passive: modifiers.includes("passive")
        };
        if (modifiers.includes("camel")) event = camelCase(event);
        let handler, listenerTarget;
        if (modifiers.includes("away")) {
            listenerTarget = document;
            handler = (e)=>{
                // Don't do anything if the click came from the element or within it.
                if (el.contains(e.target)) return; // Don't do anything if this element isn't currently visible.
                if (el.offsetWidth < 1 && el.offsetHeight < 1) return; // Now that we are sure the element is visible, AND the click
                // is from outside it, let's run the expression.
                runListenerHandler(component, expression, e, extraVars);
                if (modifiers.includes("once")) document.removeEventListener(event, handler, options);
            };
        } else {
            listenerTarget = modifiers.includes("window") ? window : modifiers.includes("document") ? document : el;
            handler = (e)=>{
                // Remove this global event handler if the element that declared it
                // has been removed. It's now stale.
                if (listenerTarget === window || listenerTarget === document) {
                    if (!document.body.contains(el)) {
                        listenerTarget.removeEventListener(event, handler, options);
                        return;
                    }
                }
                if (isKeyEvent(event)) {
                    if (isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
                }
                if (modifiers.includes("prevent")) e.preventDefault();
                if (modifiers.includes("stop")) e.stopPropagation(); // If the .self modifier isn't present, or if it is present and
                // the target element matches the element we are registering the
                // event on, run the handler
                if (!modifiers.includes("self") || e.target === el) {
                    const returnValue = runListenerHandler(component, expression, e, extraVars);
                    returnValue.then((value)=>{
                        if (value === false) e.preventDefault();
                        else if (modifiers.includes("once")) listenerTarget.removeEventListener(event, handler, options);
                    });
                }
            };
        }
        if (modifiers.includes("debounce")) {
            let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
            let wait = isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
            handler = debounce(handler, wait);
        }
        listenerTarget.addEventListener(event, handler, options);
    }
    function runListenerHandler(component, expression, e, extraVars) {
        return component.evaluateCommandExpression(e.target, expression, ()=>{
            return _objectSpread2(_objectSpread2({}, extraVars()), {}, {
                "$event": e
            });
        });
    }
    function isKeyEvent(event) {
        return [
            "keydown",
            "keyup"
        ].includes(event);
    }
    function isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
        let keyModifiers = modifiers.filter((i)=>{
            return ![
                "window",
                "document",
                "prevent",
                "stop"
            ].includes(i);
        });
        if (keyModifiers.includes("debounce")) {
            let debounceIndex = keyModifiers.indexOf("debounce");
            keyModifiers.splice(debounceIndex, isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
        } // If no modifier is specified, we'll call it a press.
        if (keyModifiers.length === 0) return false; // If one is passed, AND it matches the key pressed, we'll call it a press.
        if (keyModifiers.length === 1 && keyModifiers[0] === keyToModifier(e.key)) return false; // The user is listening for key combinations.
        const systemKeyModifiers = [
            "ctrl",
            "shift",
            "alt",
            "meta",
            "cmd",
            "super"
        ];
        const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
        keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
        if (selectedSystemKeyModifiers.length > 0) {
            const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
                // Alias "cmd" and "super" to "meta"
                if (modifier === "cmd" || modifier === "super") modifier = "meta";
                return e[`${modifier}Key`];
            }); // If all the modifiers selected are pressed, ...
            if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
                // AND the remaining key is pressed as well. It's a press.
                if (keyModifiers[0] === keyToModifier(e.key)) return false;
            }
        } // We'll call it NOT a valid keypress.
        return true;
    }
    function keyToModifier(key) {
        switch(key){
            case "/":
                return "slash";
            case " ":
            case "Spacebar":
                return "space";
            default:
                return key && kebabCase(key);
        }
    }
    function registerModelListener(component, el, modifiers, expression, extraVars) {
        // If the element we are binding to is a select, a radio, or checkbox
        // we'll listen for the change event instead of the "input" event.
        var event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
        const listenerExpression = `${expression} = rightSideOfExpression($event, ${expression})`;
        registerListener(component, el, event, modifiers, listenerExpression, ()=>{
            return _objectSpread2(_objectSpread2({}, extraVars()), {}, {
                rightSideOfExpression: generateModelAssignmentFunction(el, modifiers, expression)
            });
        });
    }
    function generateModelAssignmentFunction(el, modifiers, expression) {
        if (el.type === "radio") // Radio buttons only work properly when they share a name attribute.
        // People might assume we take care of that for them, because
        // they already set a shared "x-model" attribute.
        {
            if (!el.hasAttribute("name")) el.setAttribute("name", expression);
        }
        return (event, currentValue)=>{
            // Check for event.detail due to an issue where IE11 handles other events as a CustomEvent.
            if (event instanceof CustomEvent && event.detail) return event.detail;
            else if (el.type === "checkbox") {
                // If the data we are binding to is an array, toggle its value inside the array.
                if (Array.isArray(currentValue)) {
                    const newValue = modifiers.includes("number") ? safeParseNumber(event.target.value) : event.target.value;
                    return event.target.checked ? currentValue.concat([
                        newValue
                    ]) : currentValue.filter((el)=>!checkedAttrLooseCompare(el, newValue));
                } else return event.target.checked;
            } else if (el.tagName.toLowerCase() === "select" && el.multiple) return modifiers.includes("number") ? Array.from(event.target.selectedOptions).map((option)=>{
                const rawValue = option.value || option.text;
                return safeParseNumber(rawValue);
            }) : Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
            else {
                const rawValue = event.target.value;
                return modifiers.includes("number") ? safeParseNumber(rawValue) : modifiers.includes("trim") ? rawValue.trim() : rawValue;
            }
        };
    }
    function safeParseNumber(rawValue) {
        const number = rawValue ? parseFloat(rawValue) : null;
        return isNumeric(number) ? number : rawValue;
    }
    /**
   * Copyright (C) 2017 salesforce.com, inc.
   */ const { isArray: isArray } = Array;
    const { getPrototypeOf: getPrototypeOf, create: ObjectCreate, defineProperty: ObjectDefineProperty, defineProperties: ObjectDefineProperties, isExtensible: isExtensible, getOwnPropertyDescriptor: getOwnPropertyDescriptor, getOwnPropertyNames: getOwnPropertyNames, getOwnPropertySymbols: getOwnPropertySymbols, preventExtensions: preventExtensions, hasOwnProperty: hasOwnProperty } = Object;
    const { push: ArrayPush, concat: ArrayConcat, map: ArrayMap } = Array.prototype;
    function isUndefined(obj) {
        return obj === undefined;
    }
    function isFunction(obj) {
        return typeof obj === "function";
    }
    function isObject(obj) {
        return typeof obj === "object";
    }
    const proxyToValueMap = new WeakMap();
    function registerProxy(proxy, value) {
        proxyToValueMap.set(proxy, value);
    }
    const unwrap = (replicaOrAny)=>proxyToValueMap.get(replicaOrAny) || replicaOrAny;
    function wrapValue(membrane, value) {
        return membrane.valueIsObservable(value) ? membrane.getProxy(value) : value;
    }
    /**
   * Unwrap property descriptors will set value on original descriptor
   * We only need to unwrap if value is specified
   * @param descriptor external descrpitor provided to define new property on original value
   */ function unwrapDescriptor(descriptor) {
        if (hasOwnProperty.call(descriptor, "value")) descriptor.value = unwrap(descriptor.value);
        return descriptor;
    }
    function lockShadowTarget(membrane, shadowTarget, originalTarget) {
        const targetKeys = ArrayConcat.call(getOwnPropertyNames(originalTarget), getOwnPropertySymbols(originalTarget));
        targetKeys.forEach((key)=>{
            let descriptor = getOwnPropertyDescriptor(originalTarget, key);
            // We do not need to wrap the descriptor if configurable
            // Because we can deal with wrapping it when user goes through
            // Get own property descriptor. There is also a chance that this descriptor
            // could change sometime in the future, so we can defer wrapping
            // until we need to
            if (!descriptor.configurable) descriptor = wrapDescriptor(membrane, descriptor, wrapValue);
            ObjectDefineProperty(shadowTarget, key, descriptor);
        });
        preventExtensions(shadowTarget);
    }
    class ReactiveProxyHandler {
        constructor(membrane, value){
            this.originalTarget = value;
            this.membrane = membrane;
        }
        get(shadowTarget, key) {
            const { originalTarget: originalTarget, membrane: membrane } = this;
            const value = originalTarget[key];
            const { valueObserved: valueObserved } = membrane;
            valueObserved(originalTarget, key);
            return membrane.getProxy(value);
        }
        set(shadowTarget, key, value) {
            const { originalTarget: originalTarget, membrane: { valueMutated: valueMutated } } = this;
            const oldValue = originalTarget[key];
            if (oldValue !== value) {
                originalTarget[key] = value;
                valueMutated(originalTarget, key);
            } else if (key === "length" && isArray(originalTarget)) // fix for issue #236: push will add the new index, and by the time length
            // is updated, the internal length is already equal to the new length value
            // therefore, the oldValue is equal to the value. This is the forking logic
            // to support this use case.
            valueMutated(originalTarget, key);
            return true;
        }
        deleteProperty(shadowTarget, key) {
            const { originalTarget: originalTarget, membrane: { valueMutated: valueMutated } } = this;
            delete originalTarget[key];
            valueMutated(originalTarget, key);
            return true;
        }
        apply(shadowTarget, thisArg, argArray) {
        /* No op */ }
        construct(target, argArray, newTarget) {
        /* No op */ }
        has(shadowTarget, key) {
            const { originalTarget: originalTarget, membrane: { valueObserved: valueObserved } } = this;
            valueObserved(originalTarget, key);
            return key in originalTarget;
        }
        ownKeys(shadowTarget) {
            const { originalTarget: originalTarget } = this;
            return ArrayConcat.call(getOwnPropertyNames(originalTarget), getOwnPropertySymbols(originalTarget));
        }
        isExtensible(shadowTarget) {
            const shadowIsExtensible = isExtensible(shadowTarget);
            if (!shadowIsExtensible) return shadowIsExtensible;
            const { originalTarget: originalTarget, membrane: membrane } = this;
            const targetIsExtensible = isExtensible(originalTarget);
            if (!targetIsExtensible) lockShadowTarget(membrane, shadowTarget, originalTarget);
            return targetIsExtensible;
        }
        setPrototypeOf(shadowTarget, prototype) {}
        getPrototypeOf(shadowTarget) {
            const { originalTarget: originalTarget } = this;
            return getPrototypeOf(originalTarget);
        }
        getOwnPropertyDescriptor(shadowTarget, key) {
            const { originalTarget: originalTarget, membrane: membrane } = this;
            const { valueObserved: valueObserved } = this.membrane;
            // keys looked up via hasOwnProperty need to be reactive
            valueObserved(originalTarget, key);
            let desc = getOwnPropertyDescriptor(originalTarget, key);
            if (isUndefined(desc)) return desc;
            const shadowDescriptor = getOwnPropertyDescriptor(shadowTarget, key);
            if (!isUndefined(shadowDescriptor)) return shadowDescriptor;
            // Note: by accessing the descriptor, the key is marked as observed
            // but access to the value, setter or getter (if available) cannot observe
            // mutations, just like regular methods, in which case we just do nothing.
            desc = wrapDescriptor(membrane, desc, wrapValue);
            if (!desc.configurable) // If descriptor from original target is not configurable,
            // We must copy the wrapped descriptor over to the shadow target.
            // Otherwise, proxy will throw an invariant error.
            // This is our last chance to lock the value.
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/handler/getOwnPropertyDescriptor#Invariants
            ObjectDefineProperty(shadowTarget, key, desc);
            return desc;
        }
        preventExtensions(shadowTarget) {
            const { originalTarget: originalTarget, membrane: membrane } = this;
            lockShadowTarget(membrane, shadowTarget, originalTarget);
            preventExtensions(originalTarget);
            return true;
        }
        defineProperty(shadowTarget, key, descriptor) {
            const { originalTarget: originalTarget, membrane: membrane } = this;
            const { valueMutated: valueMutated } = membrane;
            const { configurable: configurable } = descriptor;
            // We have to check for value in descriptor
            // because Object.freeze(proxy) calls this method
            // with only { configurable: false, writeable: false }
            // Additionally, method will only be called with writeable:false
            // if the descriptor has a value, as opposed to getter/setter
            // So we can just check if writable is present and then see if
            // value is present. This eliminates getter and setter descriptors
            if (hasOwnProperty.call(descriptor, "writable") && !hasOwnProperty.call(descriptor, "value")) {
                const originalDescriptor = getOwnPropertyDescriptor(originalTarget, key);
                descriptor.value = originalDescriptor.value;
            }
            ObjectDefineProperty(originalTarget, key, unwrapDescriptor(descriptor));
            if (configurable === false) ObjectDefineProperty(shadowTarget, key, wrapDescriptor(membrane, descriptor, wrapValue));
            valueMutated(originalTarget, key);
            return true;
        }
    }
    function wrapReadOnlyValue(membrane, value) {
        return membrane.valueIsObservable(value) ? membrane.getReadOnlyProxy(value) : value;
    }
    class ReadOnlyHandler {
        constructor(membrane, value){
            this.originalTarget = value;
            this.membrane = membrane;
        }
        get(shadowTarget, key) {
            const { membrane: membrane, originalTarget: originalTarget } = this;
            const value = originalTarget[key];
            const { valueObserved: valueObserved } = membrane;
            valueObserved(originalTarget, key);
            return membrane.getReadOnlyProxy(value);
        }
        set(shadowTarget, key, value) {
            return false;
        }
        deleteProperty(shadowTarget, key) {
            return false;
        }
        apply(shadowTarget, thisArg, argArray) {
        /* No op */ }
        construct(target, argArray, newTarget) {
        /* No op */ }
        has(shadowTarget, key) {
            const { originalTarget: originalTarget, membrane: { valueObserved: valueObserved } } = this;
            valueObserved(originalTarget, key);
            return key in originalTarget;
        }
        ownKeys(shadowTarget) {
            const { originalTarget: originalTarget } = this;
            return ArrayConcat.call(getOwnPropertyNames(originalTarget), getOwnPropertySymbols(originalTarget));
        }
        setPrototypeOf(shadowTarget, prototype) {}
        getOwnPropertyDescriptor(shadowTarget, key) {
            const { originalTarget: originalTarget, membrane: membrane } = this;
            const { valueObserved: valueObserved } = membrane;
            // keys looked up via hasOwnProperty need to be reactive
            valueObserved(originalTarget, key);
            let desc = getOwnPropertyDescriptor(originalTarget, key);
            if (isUndefined(desc)) return desc;
            const shadowDescriptor = getOwnPropertyDescriptor(shadowTarget, key);
            if (!isUndefined(shadowDescriptor)) return shadowDescriptor;
            // Note: by accessing the descriptor, the key is marked as observed
            // but access to the value or getter (if available) cannot be observed,
            // just like regular methods, in which case we just do nothing.
            desc = wrapDescriptor(membrane, desc, wrapReadOnlyValue);
            if (hasOwnProperty.call(desc, "set")) desc.set = undefined; // readOnly membrane does not allow setters
            if (!desc.configurable) // If descriptor from original target is not configurable,
            // We must copy the wrapped descriptor over to the shadow target.
            // Otherwise, proxy will throw an invariant error.
            // This is our last chance to lock the value.
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy/handler/getOwnPropertyDescriptor#Invariants
            ObjectDefineProperty(shadowTarget, key, desc);
            return desc;
        }
        preventExtensions(shadowTarget) {
            return false;
        }
        defineProperty(shadowTarget, key, descriptor) {
            return false;
        }
    }
    function createShadowTarget(value) {
        let shadowTarget = undefined;
        if (isArray(value)) shadowTarget = [];
        else if (isObject(value)) shadowTarget = {};
        return shadowTarget;
    }
    const ObjectDotPrototype = Object.prototype;
    function defaultValueIsObservable(value) {
        // intentionally checking for null
        if (value === null) return false;
        // treat all non-object types, including undefined, as non-observable values
        if (typeof value !== "object") return false;
        if (isArray(value)) return true;
        const proto = getPrototypeOf(value);
        return proto === ObjectDotPrototype || proto === null || getPrototypeOf(proto) === null;
    }
    const defaultValueObserved = (obj, key)=>{
    /* do nothing */ };
    const defaultValueMutated = (obj, key)=>{
    /* do nothing */ };
    const defaultValueDistortion = (value)=>value;
    function wrapDescriptor(membrane, descriptor, getValue) {
        const { set: set, get: get } = descriptor;
        if (hasOwnProperty.call(descriptor, "value")) descriptor.value = getValue(membrane, descriptor.value);
        else {
            if (!isUndefined(get)) descriptor.get = function() {
                // invoking the original getter with the original target
                return getValue(membrane, get.call(unwrap(this)));
            };
            if (!isUndefined(set)) descriptor.set = function(value) {
                // At this point we don't have a clear indication of whether
                // or not a valid mutation will occur, we don't have the key,
                // and we are not sure why and how they are invoking this setter.
                // Nevertheless we preserve the original semantics by invoking the
                // original setter with the original target and the unwrapped value
                set.call(unwrap(this), membrane.unwrapProxy(value));
            };
        }
        return descriptor;
    }
    class ReactiveMembrane {
        constructor(options){
            this.valueDistortion = defaultValueDistortion;
            this.valueMutated = defaultValueMutated;
            this.valueObserved = defaultValueObserved;
            this.valueIsObservable = defaultValueIsObservable;
            this.objectGraph = new WeakMap();
            if (!isUndefined(options)) {
                const { valueDistortion: valueDistortion, valueMutated: valueMutated, valueObserved: valueObserved, valueIsObservable: valueIsObservable } = options;
                this.valueDistortion = isFunction(valueDistortion) ? valueDistortion : defaultValueDistortion;
                this.valueMutated = isFunction(valueMutated) ? valueMutated : defaultValueMutated;
                this.valueObserved = isFunction(valueObserved) ? valueObserved : defaultValueObserved;
                this.valueIsObservable = isFunction(valueIsObservable) ? valueIsObservable : defaultValueIsObservable;
            }
        }
        getProxy(value) {
            const unwrappedValue = unwrap(value);
            const distorted = this.valueDistortion(unwrappedValue);
            if (this.valueIsObservable(distorted)) {
                const o = this.getReactiveState(unwrappedValue, distorted);
                // when trying to extract the writable version of a readonly
                // we return the readonly.
                return o.readOnly === value ? value : o.reactive;
            }
            return distorted;
        }
        getReadOnlyProxy(value) {
            value = unwrap(value);
            const distorted = this.valueDistortion(value);
            if (this.valueIsObservable(distorted)) return this.getReactiveState(value, distorted).readOnly;
            return distorted;
        }
        unwrapProxy(p) {
            return unwrap(p);
        }
        getReactiveState(value, distortedValue) {
            const { objectGraph: objectGraph } = this;
            let reactiveState = objectGraph.get(distortedValue);
            if (reactiveState) return reactiveState;
            const membrane = this;
            reactiveState = {
                get reactive () {
                    const reactiveHandler = new ReactiveProxyHandler(membrane, distortedValue);
                    // caching the reactive proxy after the first time it is accessed
                    const proxy = new Proxy(createShadowTarget(distortedValue), reactiveHandler);
                    registerProxy(proxy, value);
                    ObjectDefineProperty(this, "reactive", {
                        value: proxy
                    });
                    return proxy;
                },
                get readOnly () {
                    const readOnlyHandler = new ReadOnlyHandler(membrane, distortedValue);
                    // caching the readOnly proxy after the first time it is accessed
                    const proxy = new Proxy(createShadowTarget(distortedValue), readOnlyHandler);
                    registerProxy(proxy, value);
                    ObjectDefineProperty(this, "readOnly", {
                        value: proxy
                    });
                    return proxy;
                }
            };
            objectGraph.set(distortedValue, reactiveState);
            return reactiveState;
        }
    }
    /** version: 0.26.0 */ function wrap(data, mutationCallback) {
        let membrane = new ReactiveMembrane({
            valueMutated (target, key) {
                mutationCallback(target, key);
            }
        });
        return {
            data: membrane.getProxy(data),
            membrane: membrane
        };
    }
    function unwrap$1(membrane, observable) {
        let unwrappedData = membrane.unwrapProxy(observable);
        let copy = {};
        Object.keys(unwrappedData).forEach((key)=>{
            if ([
                "$el",
                "$refs",
                "$nextTick",
                "$watch"
            ].includes(key)) return;
            copy[key] = unwrappedData[key];
        });
        return copy;
    }
    class Component {
        constructor(el, componentForClone = null){
            this.$el = el;
            const dataAttr = this.$el.getAttribute("x-data");
            const dataExpression = dataAttr === "" ? "{}" : dataAttr;
            const initExpression = this.$el.getAttribute("x-init");
            let dataExtras = {
                $el: this.$el
            };
            let canonicalComponentElementReference = componentForClone ? componentForClone.$el : this.$el;
            Object.entries(Alpine.magicProperties).forEach(([name, callback])=>{
                Object.defineProperty(dataExtras, `$${name}`, {
                    get: function get() {
                        return callback(canonicalComponentElementReference);
                    }
                });
            });
            this.unobservedData = componentForClone ? componentForClone.getUnobservedData() : saferEval(el, dataExpression, dataExtras);
            // Construct a Proxy-based observable. This will be used to handle reactivity.
            let { membrane: membrane, data: data } = this.wrapDataInObservable(this.unobservedData);
            this.$data = data;
            this.membrane = membrane; // After making user-supplied data methods reactive, we can now add
            // our magic properties to the original data for access.
            this.unobservedData.$el = this.$el;
            this.unobservedData.$refs = this.getRefsProxy();
            this.nextTickStack = [];
            this.unobservedData.$nextTick = (callback)=>{
                this.nextTickStack.push(callback);
            };
            this.watchers = {};
            this.unobservedData.$watch = (property, callback)=>{
                if (!this.watchers[property]) this.watchers[property] = [];
                this.watchers[property].push(callback);
            };
            /* MODERN-ONLY:START */ // We remove this piece of code from the legacy build.
            // In IE11, we have already defined our helpers at this point.
            // Register custom magic properties.
            Object.entries(Alpine.magicProperties).forEach(([name, callback])=>{
                Object.defineProperty(this.unobservedData, `$${name}`, {
                    get: function get() {
                        return callback(canonicalComponentElementReference, this.$el);
                    }
                });
            });
            /* MODERN-ONLY:END */ this.showDirectiveStack = [];
            this.showDirectiveLastElement;
            componentForClone || Alpine.onBeforeComponentInitializeds.forEach((callback)=>callback(this));
            var initReturnedCallback; // If x-init is present AND we aren't cloning (skip x-init on clone)
            if (initExpression && !componentForClone) {
                // We want to allow data manipulation, but not trigger DOM updates just yet.
                // We haven't even initialized the elements with their Alpine bindings. I mean c'mon.
                this.pauseReactivity = true;
                initReturnedCallback = this.evaluateReturnExpression(this.$el, initExpression);
                this.pauseReactivity = false;
            } // Register all our listeners and set all our attribute bindings.
            // If we're cloning a component, the third parameter ensures no duplicate
            // event listeners are registered (the mutation observer will take care of them)
            this.initializeElements(this.$el, ()=>{}, componentForClone); // Use mutation observer to detect new elements being added within this component at run-time.
            // Alpine's just so darn flexible amirite?
            this.listenForNewElementsToInitialize();
            if (typeof initReturnedCallback === "function") // Run the callback returned from the "x-init" hook to allow the user to do stuff after
            // Alpine's got it's grubby little paws all over everything.
            initReturnedCallback.call(this.$data);
            componentForClone || setTimeout(()=>{
                Alpine.onComponentInitializeds.forEach((callback)=>callback(this));
            }, 0);
        }
        getUnobservedData() {
            return unwrap$1(this.membrane, this.$data);
        }
        wrapDataInObservable(data) {
            var self = this;
            let updateDom = debounce(function() {
                self.updateElements(self.$el);
            }, 0);
            return wrap(data, (target, key)=>{
                if (self.watchers[key]) // If there's a watcher for this specific key, run it.
                self.watchers[key].forEach((callback)=>callback(target[key]));
                else if (Array.isArray(target)) // Arrays are special cases, if any of the items change, we consider the array as mutated.
                Object.keys(self.watchers).forEach((fullDotNotationKey)=>{
                    let dotNotationParts = fullDotNotationKey.split("."); // Ignore length mutations since they would result in duplicate calls.
                    // For example, when calling push, we would get a mutation for the item's key
                    // and a second mutation for the length property.
                    if (key === "length") return;
                    dotNotationParts.reduce((comparisonData, part)=>{
                        if (Object.is(target, comparisonData[part])) self.watchers[fullDotNotationKey].forEach((callback)=>callback(target));
                        return comparisonData[part];
                    }, self.unobservedData);
                });
                else // Let's walk through the watchers with "dot-notation" (foo.bar) and see
                // if this mutation fits any of them.
                Object.keys(self.watchers).filter((i)=>i.includes(".")).forEach((fullDotNotationKey)=>{
                    let dotNotationParts = fullDotNotationKey.split("."); // If this dot-notation watcher's last "part" doesn't match the current
                    // key, then skip it early for performance reasons.
                    if (key !== dotNotationParts[dotNotationParts.length - 1]) return; // Now, walk through the dot-notation "parts" recursively to find
                    // a match, and call the watcher if one's found.
                    dotNotationParts.reduce((comparisonData, part)=>{
                        if (Object.is(target, comparisonData)) // Run the watchers.
                        self.watchers[fullDotNotationKey].forEach((callback)=>callback(target[key]));
                        return comparisonData[part];
                    }, self.unobservedData);
                });
                 // Don't react to data changes for cases like the `x-created` hook.
                if (self.pauseReactivity) return;
                updateDom();
            });
        }
        walkAndSkipNestedComponents(el, callback, initializeComponentCallback = ()=>{}) {
            walk(el, (el)=>{
                // We've hit a component.
                if (el.hasAttribute("x-data")) // If it's not the current one.
                {
                    if (!el.isSameNode(this.$el)) {
                        // Initialize it if it's not.
                        if (!el.__x) initializeComponentCallback(el); // Now we'll let that sub-component deal with itself.
                        return false;
                    }
                }
                return callback(el);
            });
        }
        initializeElements(rootEl, extraVars = ()=>{}, componentForClone = false) {
            this.walkAndSkipNestedComponents(rootEl, (el)=>{
                // Don't touch spawns from for loop
                if (el.__x_for_key !== undefined) return false; // Don't touch spawns from if directives
                if (el.__x_inserted_me !== undefined) return false;
                this.initializeElement(el, extraVars, componentForClone ? false : true);
            }, (el)=>{
                if (!componentForClone) el.__x = new Component(el);
            });
            this.executeAndClearRemainingShowDirectiveStack();
            this.executeAndClearNextTickStack(rootEl);
        }
        initializeElement(el, extraVars, shouldRegisterListeners = true) {
            // To support class attribute merging, we have to know what the element's
            // original class attribute looked like for reference.
            if (el.hasAttribute("class") && getXAttrs(el, this).length > 0) el.__x_original_classes = convertClassStringToArray(el.getAttribute("class"));
            shouldRegisterListeners && this.registerListeners(el, extraVars);
            this.resolveBoundAttributes(el, true, extraVars);
        }
        updateElements(rootEl, extraVars = ()=>{}) {
            this.walkAndSkipNestedComponents(rootEl, (el)=>{
                // Don't touch spawns from for loop (and check if the root is actually a for loop in a parent, don't skip it.)
                if (el.__x_for_key !== undefined && !el.isSameNode(this.$el)) return false;
                this.updateElement(el, extraVars);
            }, (el)=>{
                el.__x = new Component(el);
            });
            this.executeAndClearRemainingShowDirectiveStack();
            this.executeAndClearNextTickStack(rootEl);
        }
        executeAndClearNextTickStack(el) {
            // Skip spawns from alpine directives
            if (el === this.$el && this.nextTickStack.length > 0) // We run the tick stack after the next frame to allow any
            // running transitions to pass the initial show stage.
            requestAnimationFrame(()=>{
                while(this.nextTickStack.length > 0)this.nextTickStack.shift()();
            });
        }
        executeAndClearRemainingShowDirectiveStack() {
            // The goal here is to start all the x-show transitions
            // and build a nested promise chain so that elements
            // only hide when the children are finished hiding.
            this.showDirectiveStack.reverse().map((handler)=>{
                return new Promise((resolve, reject)=>{
                    handler(resolve, reject);
                });
            }).reduce((promiseChain, promise)=>{
                return promiseChain.then(()=>{
                    return promise.then((finishElement)=>{
                        finishElement();
                    });
                });
            }, Promise.resolve(()=>{})).catch((e)=>{
                if (e !== TRANSITION_CANCELLED) throw e;
            }); // We've processed the handler stack. let's clear it.
            this.showDirectiveStack = [];
            this.showDirectiveLastElement = undefined;
        }
        updateElement(el, extraVars) {
            this.resolveBoundAttributes(el, false, extraVars);
        }
        registerListeners(el, extraVars) {
            getXAttrs(el, this).forEach(({ type: type, value: value, modifiers: modifiers, expression: expression })=>{
                switch(type){
                    case "on":
                        registerListener(this, el, value, modifiers, expression, extraVars);
                        break;
                    case "model":
                        registerModelListener(this, el, modifiers, expression, extraVars);
                        break;
                }
            });
        }
        resolveBoundAttributes(el, initialUpdate = false, extraVars) {
            let attrs = getXAttrs(el, this);
            attrs.forEach(({ type: type, value: value, modifiers: modifiers, expression: expression })=>{
                switch(type){
                    case "model":
                        handleAttributeBindingDirective(this, el, "value", expression, extraVars, type, modifiers);
                        break;
                    case "bind":
                        // The :key binding on an x-for is special, ignore it.
                        if (el.tagName.toLowerCase() === "template" && value === "key") return;
                        handleAttributeBindingDirective(this, el, value, expression, extraVars, type, modifiers);
                        break;
                    case "text":
                        var output = this.evaluateReturnExpression(el, expression, extraVars);
                        handleTextDirective(el, output, expression);
                        break;
                    case "html":
                        handleHtmlDirective(this, el, expression, extraVars);
                        break;
                    case "show":
                        var output = this.evaluateReturnExpression(el, expression, extraVars);
                        handleShowDirective(this, el, output, modifiers, initialUpdate);
                        break;
                    case "if":
                        // If this element also has x-for on it, don't process x-if.
                        // We will let the "x-for" directive handle the "if"ing.
                        if (attrs.some((i)=>i.type === "for")) return;
                        var output = this.evaluateReturnExpression(el, expression, extraVars);
                        handleIfDirective(this, el, output, initialUpdate, extraVars);
                        break;
                    case "for":
                        handleForDirective(this, el, expression, initialUpdate, extraVars);
                        break;
                    case "cloak":
                        el.removeAttribute("x-cloak");
                        break;
                }
            });
        }
        evaluateReturnExpression(el, expression, extraVars = ()=>{}) {
            return saferEval(el, expression, this.$data, _objectSpread2(_objectSpread2({}, extraVars()), {}, {
                $dispatch: this.getDispatchFunction(el)
            }));
        }
        evaluateCommandExpression(el, expression, extraVars = ()=>{}) {
            return saferEvalNoReturn(el, expression, this.$data, _objectSpread2(_objectSpread2({}, extraVars()), {}, {
                $dispatch: this.getDispatchFunction(el)
            }));
        }
        getDispatchFunction(el) {
            return (event, detail = {})=>{
                el.dispatchEvent(new CustomEvent(event, {
                    detail: detail,
                    bubbles: true
                }));
            };
        }
        listenForNewElementsToInitialize() {
            const targetNode = this.$el;
            const observerOptions = {
                childList: true,
                attributes: true,
                subtree: true
            };
            const observer = new MutationObserver((mutations)=>{
                for(let i = 0; i < mutations.length; i++){
                    // Filter out mutations triggered from child components.
                    const closestParentComponent = mutations[i].target.closest("[x-data]");
                    if (!(closestParentComponent && closestParentComponent.isSameNode(this.$el))) continue;
                    if (mutations[i].type === "attributes" && mutations[i].attributeName === "x-data") {
                        const xAttr = mutations[i].target.getAttribute("x-data") || "{}";
                        const rawData = saferEval(this.$el, xAttr, {
                            $el: this.$el
                        });
                        Object.keys(rawData).forEach((key)=>{
                            if (this.$data[key] !== rawData[key]) this.$data[key] = rawData[key];
                        });
                    }
                    if (mutations[i].addedNodes.length > 0) mutations[i].addedNodes.forEach((node)=>{
                        if (node.nodeType !== 1 || node.__x_inserted_me) return;
                        if (node.matches("[x-data]") && !node.__x) {
                            node.__x = new Component(node);
                            return;
                        }
                        this.initializeElements(node);
                    });
                }
            });
            observer.observe(targetNode, observerOptions);
        }
        getRefsProxy() {
            var self = this;
            var refObj = {};
            // One of the goals of this is to not hold elements in memory, but rather re-evaluate
            // the DOM when the system needs something from it. This way, the framework is flexible and
            // friendly to outside DOM changes from libraries like Vue/Livewire.
            // For this reason, I'm using an "on-demand" proxy to fake a "$refs" object.
            return new Proxy(refObj, {
                get (object, property) {
                    if (property === "$isAlpineProxy") return true;
                    var ref; // We can't just query the DOM because it's hard to filter out refs in
                    // nested components.
                    self.walkAndSkipNestedComponents(self.$el, (el)=>{
                        if (el.hasAttribute("x-ref") && el.getAttribute("x-ref") === property) ref = el;
                    });
                    return ref;
                }
            });
        }
    }
    const Alpine = {
        version: "2.8.2",
        pauseMutationObserver: false,
        magicProperties: {},
        onComponentInitializeds: [],
        onBeforeComponentInitializeds: [],
        ignoreFocusedForValueBinding: false,
        start: async function start() {
            if (!isTesting()) await domReady();
            this.discoverComponents((el)=>{
                this.initializeComponent(el);
            }); // It's easier and more performant to just support Turbolinks than listen
            // to MutationObserver mutations at the document level.
            document.addEventListener("turbolinks:load", ()=>{
                this.discoverUninitializedComponents((el)=>{
                    this.initializeComponent(el);
                });
            });
            this.listenForNewUninitializedComponentsAtRunTime();
        },
        discoverComponents: function discoverComponents(callback) {
            const rootEls = document.querySelectorAll("[x-data]");
            rootEls.forEach((rootEl)=>{
                callback(rootEl);
            });
        },
        discoverUninitializedComponents: function discoverUninitializedComponents(callback, el = null) {
            const rootEls = (el || document).querySelectorAll("[x-data]");
            Array.from(rootEls).filter((el)=>el.__x === undefined).forEach((rootEl)=>{
                callback(rootEl);
            });
        },
        listenForNewUninitializedComponentsAtRunTime: function listenForNewUninitializedComponentsAtRunTime() {
            const targetNode = document.querySelector("body");
            const observerOptions = {
                childList: true,
                attributes: true,
                subtree: true
            };
            const observer = new MutationObserver((mutations)=>{
                if (this.pauseMutationObserver) return;
                for(let i = 0; i < mutations.length; i++)if (mutations[i].addedNodes.length > 0) mutations[i].addedNodes.forEach((node)=>{
                    // Discard non-element nodes (like line-breaks)
                    if (node.nodeType !== 1) return; // Discard any changes happening within an existing component.
                    // They will take care of themselves.
                    if (node.parentElement && node.parentElement.closest("[x-data]")) return;
                    this.discoverUninitializedComponents((el)=>{
                        this.initializeComponent(el);
                    }, node.parentElement);
                });
            });
            observer.observe(targetNode, observerOptions);
        },
        initializeComponent: function initializeComponent(el) {
            if (!el.__x) // Wrap in a try/catch so that we don't prevent other components
            // from initializing when one component contains an error.
            try {
                el.__x = new Component(el);
            } catch (error) {
                setTimeout(()=>{
                    throw error;
                }, 0);
            }
        },
        clone: function clone(component, newEl) {
            if (!newEl.__x) newEl.__x = new Component(newEl, component);
        },
        addMagicProperty: function addMagicProperty(name, callback) {
            this.magicProperties[name] = callback;
        },
        onComponentInitialized: function onComponentInitialized(callback) {
            this.onComponentInitializeds.push(callback);
        },
        onBeforeComponentInitialized: function onBeforeComponentInitialized(callback) {
            this.onBeforeComponentInitializeds.push(callback);
        }
    };
    if (!isTesting()) {
        window.Alpine = Alpine;
        if (window.deferLoadingAlpine) window.deferLoadingAlpine(function() {
            window.Alpine.start();
        });
        else window.Alpine.start();
    }
    return Alpine;
});


var $fda0a82cede31420$exports = {};
/*! algoliasearch-lite.umd.js | 4.10.2 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript */ !function(e, t) {
    $fda0a82cede31420$exports = t();
}($fda0a82cede31420$exports, function() {
    "use strict";
    function e(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function t(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, n);
        }
        return r;
    }
    function r(r) {
        for(var n = 1; n < arguments.length; n++){
            var o = null != arguments[n] ? arguments[n] : {};
            n % 2 ? t(Object(o), !0).forEach(function(t) {
                e(r, t, o[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(o)) : t(Object(o)).forEach(function(e) {
                Object.defineProperty(r, e, Object.getOwnPropertyDescriptor(o, e));
            });
        }
        return r;
    }
    function n(e, t) {
        if (null == e) return {};
        var r, n, o = function(e, t) {
            if (null == e) return {};
            var r, n, o = {}, a = Object.keys(e);
            for(n = 0; n < a.length; n++)r = a[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
            return o;
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for(n = 0; n < a.length; n++)r = a[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
        return o;
    }
    function o(e, t) {
        return function(e) {
            if (Array.isArray(e)) return e;
        }(e) || function(e, t) {
            if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
            var r = [], n = !0, o = !1, a = void 0;
            try {
                for(var u, i = e[Symbol.iterator](); !(n = (u = i.next()).done) && (r.push(u.value), !t || r.length !== t); n = !0);
            } catch (e) {
                o = !0, a = e;
            } finally{
                try {
                    n || null == i.return || i.return();
                } finally{
                    if (o) throw a;
                }
            }
            return r;
        }(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
    }
    function a(e) {
        return function(e) {
            if (Array.isArray(e)) {
                for(var t = 0, r = new Array(e.length); t < e.length; t++)r[t] = e[t];
                return r;
            }
        }(e) || function(e) {
            if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
    }
    function u(e) {
        var t, r = "algoliasearch-client-js-".concat(e.key), n = function() {
            return void 0 === t && (t = e.localStorage || window.localStorage), t;
        }, a = function() {
            return JSON.parse(n().getItem(r) || "{}");
        };
        return {
            get: function(e, t) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                };
                return Promise.resolve().then(function() {
                    var r = JSON.stringify(e), n = a()[r];
                    return Promise.all([
                        n || t(),
                        void 0 !== n
                    ]);
                }).then(function(e) {
                    var t = o(e, 2), n = t[0], a = t[1];
                    return Promise.all([
                        n,
                        a || r.miss(n)
                    ]);
                }).then(function(e) {
                    return o(e, 1)[0];
                });
            },
            set: function(e, t) {
                return Promise.resolve().then(function() {
                    var o = a();
                    return o[JSON.stringify(e)] = t, n().setItem(r, JSON.stringify(o)), t;
                });
            },
            delete: function(e) {
                return Promise.resolve().then(function() {
                    var t = a();
                    delete t[JSON.stringify(e)], n().setItem(r, JSON.stringify(t));
                });
            },
            clear: function() {
                return Promise.resolve().then(function() {
                    n().removeItem(r);
                });
            }
        };
    }
    function i(e) {
        var t = a(e.caches), r = t.shift();
        return void 0 === r ? {
            get: function(e, t) {
                var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                }, n = t();
                return n.then(function(e) {
                    return Promise.all([
                        e,
                        r.miss(e)
                    ]);
                }).then(function(e) {
                    return o(e, 1)[0];
                });
            },
            set: function(e, t) {
                return Promise.resolve(t);
            },
            delete: function(e) {
                return Promise.resolve();
            },
            clear: function() {
                return Promise.resolve();
            }
        } : {
            get: function(e, n) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                };
                return r.get(e, n, o).catch(function() {
                    return i({
                        caches: t
                    }).get(e, n, o);
                });
            },
            set: function(e, n) {
                return r.set(e, n).catch(function() {
                    return i({
                        caches: t
                    }).set(e, n);
                });
            },
            delete: function(e) {
                return r.delete(e).catch(function() {
                    return i({
                        caches: t
                    }).delete(e);
                });
            },
            clear: function() {
                return r.clear().catch(function() {
                    return i({
                        caches: t
                    }).clear();
                });
            }
        };
    }
    function s() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            serializable: !0
        }, t = {};
        return {
            get: function(r, n) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
                    miss: function() {
                        return Promise.resolve();
                    }
                }, a = JSON.stringify(r);
                if (a in t) return Promise.resolve(e.serializable ? JSON.parse(t[a]) : t[a]);
                var u = n(), i = o && o.miss || function() {
                    return Promise.resolve();
                };
                return u.then(function(e) {
                    return i(e);
                }).then(function() {
                    return u;
                });
            },
            set: function(r, n) {
                return t[JSON.stringify(r)] = e.serializable ? JSON.stringify(n) : n, Promise.resolve(n);
            },
            delete: function(e) {
                return delete t[JSON.stringify(e)], Promise.resolve();
            },
            clear: function() {
                return t = {}, Promise.resolve();
            }
        };
    }
    function c(e) {
        for(var t = e.length - 1; t > 0; t--){
            var r = Math.floor(Math.random() * (t + 1)), n = e[t];
            e[t] = e[r], e[r] = n;
        }
        return e;
    }
    function l(e, t) {
        return t ? (Object.keys(t).forEach(function(r) {
            e[r] = t[r](e);
        }), e) : e;
    }
    function f(e) {
        for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
        var o = 0;
        return e.replace(/%s/g, function() {
            return encodeURIComponent(r[o++]);
        });
    }
    var h = {
        WithinQueryParameters: 0,
        WithinHeaders: 1
    };
    function d(e, t) {
        var r = e || {}, n = r.data || {};
        return Object.keys(r).forEach(function(e) {
            -1 === [
                "timeout",
                "headers",
                "queryParameters",
                "data",
                "cacheable"
            ].indexOf(e) && (n[e] = r[e]);
        }), {
            data: Object.entries(n).length > 0 ? n : void 0,
            timeout: r.timeout || t,
            headers: r.headers || {},
            queryParameters: r.queryParameters || {},
            cacheable: r.cacheable
        };
    }
    var m = {
        Read: 1,
        Write: 2,
        Any: 3
    }, p = 1, v = 2, y = 3;
    function g(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p;
        return r(r({}, e), {}, {
            status: t,
            lastUpdate: Date.now()
        });
    }
    function b(e) {
        return "string" == typeof e ? {
            protocol: "https",
            url: e,
            accept: m.Any
        } : {
            protocol: e.protocol || "https",
            url: e.url,
            accept: e.accept || m.Any
        };
    }
    var O = "GET", P = "POST";
    function q(e, t) {
        return Promise.all(t.map(function(t) {
            return e.get(t, function() {
                return Promise.resolve(g(t));
            });
        })).then(function(e) {
            var r = e.filter(function(e) {
                return function(e) {
                    return e.status === p || Date.now() - e.lastUpdate > 12e4;
                }(e);
            }), n = e.filter(function(e) {
                return function(e) {
                    return e.status === y && Date.now() - e.lastUpdate <= 12e4;
                }(e);
            }), o = [].concat(a(r), a(n));
            return {
                getTimeout: function(e, t) {
                    return (0 === n.length && 0 === e ? 1 : n.length + 3 + e) * t;
                },
                statelessHosts: o.length > 0 ? o.map(function(e) {
                    return b(e);
                }) : t
            };
        });
    }
    function j(e, t, n, o) {
        var u = [], i = function(e, t) {
            if (e.method === O || void 0 === e.data && void 0 === t.data) return;
            var n = Array.isArray(e.data) ? e.data : r(r({}, e.data), t.data);
            return JSON.stringify(n);
        }(n, o), s = function(e, t) {
            var n = r(r({}, e.headers), t.headers), o = {};
            return Object.keys(n).forEach(function(e) {
                var t = n[e];
                o[e.toLowerCase()] = t;
            }), o;
        }(e, o), c = n.method, l = n.method !== O ? {} : r(r({}, n.data), o.data), f = r(r(r({
            "x-algolia-agent": e.userAgent.value
        }, e.queryParameters), l), o.queryParameters), h = 0, d = function t(r, a) {
            var l = r.pop();
            if (void 0 === l) throw {
                name: "RetryError",
                message: "Unreachable hosts - your application id may be incorrect. If the error persists, contact support@algolia.com.",
                transporterStackTrace: A(u)
            };
            var d = {
                data: i,
                headers: s,
                method: c,
                url: S(l, n.path, f),
                connectTimeout: a(h, e.timeouts.connect),
                responseTimeout: a(h, o.timeout)
            }, m = function(e) {
                var t = {
                    request: d,
                    response: e,
                    host: l,
                    triesLeft: r.length
                };
                return u.push(t), t;
            }, p = {
                onSuccess: function(e) {
                    return function(e) {
                        try {
                            return JSON.parse(e.content);
                        } catch (t) {
                            throw function(e, t) {
                                return {
                                    name: "DeserializationError",
                                    message: e,
                                    response: t
                                };
                            }(t.message, e);
                        }
                    }(e);
                },
                onRetry: function(n) {
                    var o = m(n);
                    return n.isTimedOut && h++, Promise.all([
                        e.logger.info("Retryable failure", x(o)),
                        e.hostsCache.set(l, g(l, n.isTimedOut ? y : v))
                    ]).then(function() {
                        return t(r, a);
                    });
                },
                onFail: function(e) {
                    throw m(e), function(e, t) {
                        var r = e.content, n = e.status, o = r;
                        try {
                            o = JSON.parse(r).message;
                        } catch (e) {}
                        return function(e, t, r) {
                            return {
                                name: "ApiError",
                                message: e,
                                status: t,
                                transporterStackTrace: r
                            };
                        }(o, n, t);
                    }(e, A(u));
                }
            };
            return e.requester.send(d).then(function(e) {
                return function(e, t) {
                    return function(e) {
                        var t = e.status;
                        return e.isTimedOut || function(e) {
                            var t = e.isTimedOut, r = e.status;
                            return !t && 0 == ~~r;
                        }(e) || 2 != ~~(t / 100) && 4 != ~~(t / 100);
                    }(e) ? t.onRetry(e) : 2 == ~~(e.status / 100) ? t.onSuccess(e) : t.onFail(e);
                }(e, p);
            });
        };
        return q(e.hostsCache, t).then(function(e) {
            return d(a(e.statelessHosts).reverse(), e.getTimeout);
        });
    }
    function w(e) {
        var t = {
            value: "Algolia for JavaScript (".concat(e, ")"),
            add: function(e) {
                var r = "; ".concat(e.segment).concat(void 0 !== e.version ? " (".concat(e.version, ")") : "");
                return -1 === t.value.indexOf(r) && (t.value = "".concat(t.value).concat(r)), t;
            }
        };
        return t;
    }
    function S(e, t, r) {
        var n = T(r), o = "".concat(e.protocol, "://").concat(e.url, "/").concat("/" === t.charAt(0) ? t.substr(1) : t);
        return n.length && (o += "?".concat(n)), o;
    }
    function T(e) {
        return Object.keys(e).map(function(t) {
            var r;
            return f("%s=%s", t, (r = e[t], "[object Object]" === Object.prototype.toString.call(r) || "[object Array]" === Object.prototype.toString.call(r) ? JSON.stringify(e[t]) : e[t]));
        }).join("&");
    }
    function A(e) {
        return e.map(function(e) {
            return x(e);
        });
    }
    function x(e) {
        var t = e.request.headers["x-algolia-api-key"] ? {
            "x-algolia-api-key": "*****"
        } : {};
        return r(r({}, e), {}, {
            request: r(r({}, e.request), {}, {
                headers: r(r({}, e.request.headers), t)
            })
        });
    }
    var N = function(e) {
        var t = e.appId, n = function(e, t, r) {
            var n = {
                "x-algolia-api-key": r,
                "x-algolia-application-id": t
            };
            return {
                headers: function() {
                    return e === h.WithinHeaders ? n : {};
                },
                queryParameters: function() {
                    return e === h.WithinQueryParameters ? n : {};
                }
            };
        }(void 0 !== e.authMode ? e.authMode : h.WithinHeaders, t, e.apiKey), a = function(e) {
            var t = e.hostsCache, r = e.logger, n = e.requester, a = e.requestsCache, u = e.responsesCache, i = e.timeouts, s = e.userAgent, c = e.hosts, l = e.queryParameters, f = {
                hostsCache: t,
                logger: r,
                requester: n,
                requestsCache: a,
                responsesCache: u,
                timeouts: i,
                userAgent: s,
                headers: e.headers,
                queryParameters: l,
                hosts: c.map(function(e) {
                    return b(e);
                }),
                read: function(e, t) {
                    var r = d(t, f.timeouts.read), n = function() {
                        return j(f, f.hosts.filter(function(e) {
                            return 0 != (e.accept & m.Read);
                        }), e, r);
                    };
                    if (!0 !== (void 0 !== r.cacheable ? r.cacheable : e.cacheable)) return n();
                    var a = {
                        request: e,
                        mappedRequestOptions: r,
                        transporter: {
                            queryParameters: f.queryParameters,
                            headers: f.headers
                        }
                    };
                    return f.responsesCache.get(a, function() {
                        return f.requestsCache.get(a, function() {
                            return f.requestsCache.set(a, n()).then(function(e) {
                                return Promise.all([
                                    f.requestsCache.delete(a),
                                    e
                                ]);
                            }, function(e) {
                                return Promise.all([
                                    f.requestsCache.delete(a),
                                    Promise.reject(e)
                                ]);
                            }).then(function(e) {
                                var t = o(e, 2);
                                t[0];
                                return t[1];
                            });
                        });
                    }, {
                        miss: function(e) {
                            return f.responsesCache.set(a, e);
                        }
                    });
                },
                write: function(e, t) {
                    return j(f, f.hosts.filter(function(e) {
                        return 0 != (e.accept & m.Write);
                    }), e, d(t, f.timeouts.write));
                }
            };
            return f;
        }(r(r({
            hosts: [
                {
                    url: "".concat(t, "-dsn.algolia.net"),
                    accept: m.Read
                },
                {
                    url: "".concat(t, ".algolia.net"),
                    accept: m.Write
                }
            ].concat(c([
                {
                    url: "".concat(t, "-1.algolianet.com")
                },
                {
                    url: "".concat(t, "-2.algolianet.com")
                },
                {
                    url: "".concat(t, "-3.algolianet.com")
                }
            ]))
        }, e), {}, {
            headers: r(r(r({}, n.headers()), {
                "content-type": "application/x-www-form-urlencoded"
            }), e.headers),
            queryParameters: r(r({}, n.queryParameters()), e.queryParameters)
        }));
        return l({
            transporter: a,
            appId: t,
            addAlgoliaAgent: function(e, t) {
                a.userAgent.add({
                    segment: e,
                    version: t
                });
            },
            clearCache: function() {
                return Promise.all([
                    a.requestsCache.clear(),
                    a.responsesCache.clear()
                ]).then(function() {});
            }
        }, e.methods);
    }, C = function(e) {
        return function(t) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = {
                transporter: e.transporter,
                appId: e.appId,
                indexName: t
            };
            return l(n, r.methods);
        };
    }, k = function(e) {
        return function(t, n) {
            var o = t.map(function(e) {
                return r(r({}, e), {}, {
                    params: T(e.params || {})
                });
            });
            return e.transporter.read({
                method: P,
                path: "1/indexes/*/queries",
                data: {
                    requests: o
                },
                cacheable: !0
            }, n);
        };
    }, J = function(e) {
        return function(t, o) {
            return Promise.all(t.map(function(t) {
                var a = t.params, u = a.facetName, i = a.facetQuery, s = n(a, [
                    "facetName",
                    "facetQuery"
                ]);
                return C(e)(t.indexName, {
                    methods: {
                        searchForFacetValues: F
                    }
                }).searchForFacetValues(u, i, r(r({}, o), s));
            }));
        };
    }, E = function(e) {
        return function(t, r, n) {
            return e.transporter.read({
                method: P,
                path: f("1/answers/%s/prediction", e.indexName),
                data: {
                    query: t,
                    queryLanguages: r
                },
                cacheable: !0
            }, n);
        };
    }, I = function(e) {
        return function(t, r) {
            return e.transporter.read({
                method: P,
                path: f("1/indexes/%s/query", e.indexName),
                data: {
                    query: t
                },
                cacheable: !0
            }, r);
        };
    }, F = function(e) {
        return function(t, r, n) {
            return e.transporter.read({
                method: P,
                path: f("1/indexes/%s/facets/%s/query", e.indexName, t),
                data: {
                    facetQuery: r
                },
                cacheable: !0
            }, n);
        };
    }, R = 1, D = 2, W = 3;
    function H(e, t, n) {
        var o, a = {
            appId: e,
            apiKey: t,
            timeouts: {
                connect: 1,
                read: 2,
                write: 30
            },
            requester: {
                send: function(e) {
                    return new Promise(function(t) {
                        var r = new XMLHttpRequest;
                        r.open(e.method, e.url, !0), Object.keys(e.headers).forEach(function(t) {
                            return r.setRequestHeader(t, e.headers[t]);
                        });
                        var n, o = function(e, n) {
                            return setTimeout(function() {
                                r.abort(), t({
                                    status: 0,
                                    content: n,
                                    isTimedOut: !0
                                });
                            }, 1e3 * e);
                        }, a = o(e.connectTimeout, "Connection timeout");
                        r.onreadystatechange = function() {
                            r.readyState > r.OPENED && void 0 === n && (clearTimeout(a), n = o(e.responseTimeout, "Socket timeout"));
                        }, r.onerror = function() {
                            0 === r.status && (clearTimeout(a), clearTimeout(n), t({
                                content: r.responseText || "Network request failed",
                                status: r.status,
                                isTimedOut: !1
                            }));
                        }, r.onload = function() {
                            clearTimeout(a), clearTimeout(n), t({
                                content: r.responseText,
                                status: r.status,
                                isTimedOut: !1
                            });
                        }, r.send(e.data);
                    });
                }
            },
            logger: (o = W, {
                debug: function(e, t) {
                    return R >= o && console.debug(e, t), Promise.resolve();
                },
                info: function(e, t) {
                    return D >= o && console.info(e, t), Promise.resolve();
                },
                error: function(e, t) {
                    return console.error(e, t), Promise.resolve();
                }
            }),
            responsesCache: s(),
            requestsCache: s({
                serializable: !1
            }),
            hostsCache: i({
                caches: [
                    u({
                        key: "".concat("4.10.2", "-").concat(e)
                    }),
                    s()
                ]
            }),
            userAgent: w("4.10.2").add({
                segment: "Browser",
                version: "lite"
            }),
            authMode: h.WithinQueryParameters
        };
        return N(r(r(r({}, a), n), {}, {
            methods: {
                search: k,
                searchForFacetValues: J,
                multipleQueries: k,
                multipleSearchForFacetValues: J,
                initIndex: function(e) {
                    return function(t) {
                        return C(e)(t, {
                            methods: {
                                search: I,
                                searchForFacetValues: F,
                                findAnswers: E
                            }
                        });
                    };
                }
            }
        }));
    }
    return H.version = "4.10.2", H;
});


var $ee3ec914d550de31$exports = {};
"use strict";
var $768eefe947cb3bad$exports = {};
"use strict";
var $d068995a46348d48$exports = {};
"use strict";
var $6a944a0326502a59$exports = {};
"use strict";
function $6a944a0326502a59$var$clone(value) {
    if (typeof value === "object" && value !== null) return $6a944a0326502a59$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $6a944a0326502a59$var$isObjectOrArrayOrFunction(value) {
    return typeof value === "function" || Array.isArray(value) || Object.prototype.toString.call(value) === "[object Object]";
}
function $6a944a0326502a59$var$_merge(target, source) {
    if (target === source) return target;
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key)) continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== "undefined" && typeof sourceVal === "undefined") continue;
        if ($6a944a0326502a59$var$isObjectOrArrayOrFunction(targetVal) && $6a944a0326502a59$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $6a944a0326502a59$var$_merge(targetVal, sourceVal);
        else target[key] = $6a944a0326502a59$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $6a944a0326502a59$var$merge(target) {
    if (!$6a944a0326502a59$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($6a944a0326502a59$var$isObjectOrArrayOrFunction(source)) $6a944a0326502a59$var$_merge(target, source);
    }
    return target;
}
$6a944a0326502a59$exports = $6a944a0326502a59$var$merge;


var $7e871dea2293385c$exports = {};
"use strict";
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
$7e871dea2293385c$exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};


var $51756cc605422836$exports = {};
"use strict";
function $51756cc605422836$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
$51756cc605422836$exports = $51756cc605422836$var$intersection;


var $0d997803be7900b2$exports = {};
"use strict";
// @MAJOR can be replaced by native Array#find when we change support
$0d997803be7900b2$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
};


var $ff881da7c329b2dd$exports = {};
"use strict";
function $ff881da7c329b2dd$var$valToNumber(v) {
    if (typeof v === "number") return v;
    else if (typeof v === "string") return parseFloat(v);
    else if (Array.isArray(v)) return v.map($ff881da7c329b2dd$var$valToNumber);
    throw new Error("The value should be a number, a parsable string or an array of those.");
}
$ff881da7c329b2dd$exports = $ff881da7c329b2dd$var$valToNumber;


var $337bf59c6f823cc1$exports = {};
"use strict";
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $337bf59c6f823cc1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$337bf59c6f823cc1$exports = $337bf59c6f823cc1$var$_objectWithoutPropertiesLoose;


var $76eabdbb9e99b509$exports = {};
"use strict";
function $76eabdbb9e99b509$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
$76eabdbb9e99b509$exports = $76eabdbb9e99b509$var$objectHasKeys;


var $7375924082c46a12$exports = {};
"use strict";
$7375924082c46a12$exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};


var $211eeac7b6bdaecf$exports = {};
"use strict";



var $211eeac7b6bdaecf$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($211eeac7b6bdaecf$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = "" + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $7e871dea2293385c$exports({}, mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $211eeac7b6bdaecf$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = "" + value;
        return $211eeac7b6bdaecf$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error("toggleRefinement should be used with a value");
        if ($211eeac7b6bdaecf$var$lib.isRefined(refinementList, attribute, value)) return $211eeac7b6bdaecf$var$lib.removeRefinement(refinementList, attribute, value);
        return $211eeac7b6bdaecf$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            if (!$76eabdbb9e99b509$exports(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === "string") return $337bf59c6f823cc1$exports(refinementList, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean}
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = !!refinementList[attribute] && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = "" + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
$211eeac7b6bdaecf$exports = $211eeac7b6bdaecf$var$lib;


/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 */ function $d068995a46348d48$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $d068995a46348d48$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $d068995a46348d48$var$findArray(array, searchedValue) {
    return $0d997803be7900b2$exports(array, function(currentValue) {
        return $d068995a46348d48$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $d068995a46348d48$var$SearchParameters(newParameters) {
    var params = newParameters ? $d068995a46348d48$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$7375924082c46a12$exports(params.userToken)) console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}");
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $d068995a46348d48$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $d068995a46348d48$var$SearchParameters.PARAMETERS = Object.keys(new $d068995a46348d48$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $d068995a46348d48$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not reparse numbers in SearchParameters, they ought to be parsed already
    if (partialState instanceof $d068995a46348d48$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        "aroundPrecision",
        "aroundRadius",
        "getRankingInfo",
        "minWordSizefor2Typos",
        "minWordSizefor1Typo",
        "page",
        "maxValuesPerFacet",
        "distinct",
        "minimumAroundRadius",
        "hitsPerPage",
        "minProximity"
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === "string") {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === "string") return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === "string") return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $6a944a0326502a59$exports({}, partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $d068995a46348d48$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $d068995a46348d48$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $d068995a46348d48$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $76eabdbb9e99b509$exports(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($76eabdbb9e99b509$exports(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$d068995a46348d48$var$SearchParameters.prototype = {
    constructor: $d068995a46348d48$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters}
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $211eeac7b6bdaecf$exports.clearRefinement(this.facetsRefinements, attribute, "conjunctiveFacet"),
            facetsExcludes: $211eeac7b6bdaecf$exports.clearRefinement(this.facetsExcludes, attribute, "exclude"),
            disjunctiveFacetsRefinements: $211eeac7b6bdaecf$exports.clearRefinement(this.disjunctiveFacetsRefinements, attribute, "disjunctiveFacet"),
            hierarchicalFacetsRefinements: $211eeac7b6bdaecf$exports.clearRefinement(this.hierarchicalFacetsRefinements, attribute, "hierarchicalFacet")
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters}
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters}
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters}
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters}
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters}
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters}
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters}
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters}
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters}
   * @example
   * // for price = 50 or 40
   * searchparameter.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * searchparameter.addNumericRefinement('size', '=', 38);
   * searchparameter.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, v) {
        var value = $ff881da7c329b2dd$exports(v);
        if (this.isNumericRefined(attribute, operator, value)) return this;
        var mod = $6a944a0326502a59$exports({}, this.numericRefinements);
        mod[attribute] = $6a944a0326502a59$exports({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(value);
        } else mod[attribute][operator] = [
            value
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters}
   */ removeNumericRefinement: function(attribute, operator, paramValue) {
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $d068995a46348d48$var$isEqualNumericRefinement(value.val, $ff881da7c329b2dd$exports(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>}
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$76eabdbb9e99b509$exports(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === "string") return $337bf59c6f823cc1$exports(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, "numeric");
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters}
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters}
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters}
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + hierarchicalFacet.name + "`");
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters}
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($211eeac7b6bdaecf$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $211eeac7b6bdaecf$exports.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters}
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($211eeac7b6bdaecf$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $211eeac7b6bdaecf$exports.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters}
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if ($211eeac7b6bdaecf$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $211eeac7b6bdaecf$exports.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters}
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters}
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters}
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters}
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters}
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$211eeac7b6bdaecf$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $211eeac7b6bdaecf$exports.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters}
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$211eeac7b6bdaecf$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $211eeac7b6bdaecf$exports.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters}
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if (!$211eeac7b6bdaecf$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $211eeac7b6bdaecf$exports.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters}
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters}
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters}
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error("Cannot refine the undeclared facet " + facet + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters}
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsRefinements: $211eeac7b6bdaecf$exports.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters}
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsExcludes: $211eeac7b6bdaecf$exports.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters}
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $211eeac7b6bdaecf$exports.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters}
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration");
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $7e871dea2293385c$exports({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + " is already refined.");
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $7e871dea2293385c$exports({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $7e871dea2293385c$exports({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters}
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean}
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean}
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean}
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $211eeac7b6bdaecf$exports.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $211eeac7b6bdaecf$exports.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean}
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $211eeac7b6bdaecf$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean}
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return !!this.numericRefinements[attribute];
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $ff881da7c329b2dd$exports(value);
        var isAttributeValueDefined = $d068995a46348d48$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean}
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]}
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $51756cc605422836$exports(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets());
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]}
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        var self = this;
        return $51756cc605422836$exports(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        }));
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]}
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        "index",
        "facets",
        "disjunctiveFacets",
        "facetsRefinements",
        "facetsExcludes",
        "disjunctiveFacetsRefinements",
        "numericRefinements",
        "tagRefinements",
        "hierarchicalFacets",
        "hierarchicalFacetsRefinements"
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $d068995a46348d48$var$SearchParameters.validate(this, params);
        if (error) throw error;
        var self = this;
        var nextWithNumbers = $d068995a46348d48$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $337bf59c6f823cc1$exports(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            "isRefined:desc",
            "name:asc"
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || " > ";
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === "boolean") return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $0d997803be7900b2$exports(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ $d068995a46348d48$exports = $d068995a46348d48$var$SearchParameters;


var $8010139e6e6eb84d$exports = {};
"use strict";


var $ad0b52bde4727546$exports = {};
"use strict";
function $ad0b52bde4727546$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 */ function $ad0b52bde4727546$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $ad0b52bde4727546$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === "desc") return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
$ad0b52bde4727546$exports = $ad0b52bde4727546$var$orderBy;


var $357644167ba4704f$exports = {};
"use strict";
$357644167ba4704f$exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};



var $e5bfee02b2f39765$exports = {};
"use strict";
// @MAJOR can be replaced by native Array#findIndex when we change support
$e5bfee02b2f39765$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};


var $d9bb5031b2973ef7$exports = {};
"use strict";

/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ $d9bb5031b2973ef7$exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(":");
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(":");
        var matchingDefault = $0d997803be7900b2$exports(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};


var $0c05200c28816a6a$exports = {};
"use strict";
$0c05200c28816a6a$exports = $0c05200c28816a6a$var$generateTrees;



function $0c05200c28816a6a$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || "";
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $d9bb5031b2973ef7$exports(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $0c05200c28816a6a$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $0c05200c28816a6a$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $0d997803be7900b2$exports(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $0c05200c28816a6a$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $ad0b52bde4727546$exports(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $0c05200c28816a6a$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
function $0c05200c28816a6a$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $0c05200c28816a6a$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}


/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * @param {string[]} attributes
 */ function $8010139e6e6eb84d$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $8010139e6e6eb84d$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets
 * @param {string} hierarchicalAttributeName
 */ function $8010139e6e6eb84d$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $0d997803be7900b2$exports(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
/*eslint-disable */ /**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ /*eslint-enable */ function $8010139e6e6eb84d$var$SearchResults(state, results) {
    var mainSubResponse = results[0];
    this._rawResults = results;
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   *  - `value` : the value of the facet highlighted (html)
   *  - `matchLevel`: full, partial or none depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @member {number}
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $8010139e6e6eb84d$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $8010139e6e6eb84d$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $8010139e6e6eb84d$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $e5bfee02b2f39765$exports(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $8010139e6e6eb84d$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $8010139e6e6eb84d$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $357644167ba4704f$exports(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $e5bfee02b2f39765$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $e5bfee02b2f39765$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = $6a944a0326502a59$exports({}, self.hierarchicalFacets[position][attributeIndex].data, facetResults);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $7e871dea2293385c$exports({}, facetResults, dataFromMainRequest),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $8010139e6e6eb84d$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf(refinementValue) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some root level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position = $e5bfee02b2f39765$exports(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            var attributeIndex = $e5bfee02b2f39765$exports(self.hierarchicalFacets[position], function(f) {
                return f.attribute === dfacet;
            });
            // previous refinements and no results so not able to find it
            if (attributeIndex === -1) return;
            // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
            // then the disjunctive values will be `beers` (count: 100),
            // but we do not want to display
            //   | beers (100)
            //     > IPA (5)
            // We want
            //   | beers (5)
            //     > IPA (5)
            var defaultData = {};
            if (currentRefinement.length > 0) {
                var root = currentRefinement[0].split(separator)[0];
                defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
            }
            self.hierarchicalFacets[position][attributeIndex].data = $7e871dea2293385c$exports(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
        });
        nextDisjunctiveResult++;
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainSubResponse.facets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($0c05200c28816a6a$exports(state));
    /**
   * @type {Array}
   */ this.facets = $357644167ba4704f$exports(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $357644167ba4704f$exports(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $8010139e6e6eb84d$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $0d997803be7900b2$exports(this.facets, predicate) || $0d997803be7900b2$exports(this.disjunctiveFacets, predicate) || $0d997803be7900b2$exports(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $8010139e6e6eb84d$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $0d997803be7900b2$exports(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            return {
                name: name,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, name),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $0d997803be7900b2$exports(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            return {
                name: name,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, name)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) return $0d997803be7900b2$exports(results.hierarchicalFacets, predicate);
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 */ function $8010139e6e6eb84d$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $8010139e6e6eb84d$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $7e871dea2293385c$exports({
        data: sortedChildren
    }, node);
    return newNode;
}
$8010139e6e6eb84d$var$SearchResults.DEFAULT_SORT = [
    "isRefined:desc",
    "count:desc",
    "name:asc"
];
function $8010139e6e6eb84d$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array}
 */ function $8010139e6e6eb84d$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        if (reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else remainingFacets.push(item);
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === "hidden") return orderedFacets;
    else if (sortRemainingBy === "alpha") ordering = [
        [
            "path",
            "name"
        ],
        [
            "asc",
            "asc"
        ]
    ];
    else ordering = [
        [
            "count"
        ],
        [
            "desc"
        ]
    ];
    return orderedFacets.concat($ad0b52bde4727546$exports(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering=}
 */ function $8010139e6e6eb84d$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $8010139e6e6eb84d$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $8010139e6e6eb84d$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $7e871dea2293385c$exports({}, opts, {
        sortBy: $8010139e6e6eb84d$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $8010139e6e6eb84d$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $8010139e6e6eb84d$var$getFacetOrdering(results, facetName);
            if (Boolean(facetOrdering)) return $8010139e6e6eb84d$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $d9bb5031b2973ef7$exports(options.sortBy, $8010139e6e6eb84d$var$SearchResults.DEFAULT_SORT);
            return $ad0b52bde4727546$exports(data, order[0], order[1]);
        } else if (typeof options.sortBy === "function") return $8010139e6e6eb84d$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $8010139e6e6eb84d$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $8010139e6e6eb84d$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $8010139e6e6eb84d$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName
 */ function $8010139e6e6eb84d$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $0d997803be7900b2$exports(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $8010139e6e6eb84d$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($8010139e6e6eb84d$var$getRefinement(state, "facet", attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($8010139e6e6eb84d$var$getRefinement(state, "exclude", attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($8010139e6e6eb84d$var$getRefinement(state, "disjunctive", attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($8010139e6e6eb84d$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: "numeric",
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: "tag",
            attributeName: "_tags",
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {*} state
 * @param {*} type
 * @param {string} attributeName
 * @param {*} name
 * @param {Facet[]} resultsFacets
 */ function $8010139e6e6eb84d$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $0d997803be7900b2$exports(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {*} state
 * @param {string} attributeName
 * @param {*} name
 * @param {Facet[]} resultsFacets
 */ function $8010139e6e6eb84d$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $0d997803be7900b2$exports(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $0d997803be7900b2$exports(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || "";
    return {
        type: "hierarchical",
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
$8010139e6e6eb84d$exports = $8010139e6e6eb84d$var$SearchResults;


var $1471d29dbd734cc1$exports = {};
"use strict";
var $6e41fae856809c3e$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $6e41fae856809c3e$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
$6e41fae856809c3e$exports = $6e41fae856809c3e$var$EventEmitter;
// Backwards-compat with node 0.10.x
$6e41fae856809c3e$var$EventEmitter.EventEmitter = $6e41fae856809c3e$var$EventEmitter;
$6e41fae856809c3e$var$EventEmitter.prototype._events = undefined;
$6e41fae856809c3e$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$6e41fae856809c3e$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$6e41fae856809c3e$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$6e41fae856809c3e$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError("n must be a positive number");
    this._maxListeners = n;
    return this;
};
$6e41fae856809c3e$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === "error") {
        if (!this._events.error || $6e41fae856809c3e$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($6e41fae856809c3e$var$isUndefined(handler)) return false;
    if ($6e41fae856809c3e$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($6e41fae856809c3e$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$6e41fae856809c3e$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$6e41fae856809c3e$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit("newListener", type, $6e41fae856809c3e$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($6e41fae856809c3e$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($6e41fae856809c3e$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$6e41fae856809c3e$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $6e41fae856809c3e$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === "function") // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$6e41fae856809c3e$var$EventEmitter.prototype.on = $6e41fae856809c3e$var$EventEmitter.prototype.addListener;
$6e41fae856809c3e$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$6e41fae856809c3e$var$isFunction(listener)) throw TypeError("listener must be a function");
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$6e41fae856809c3e$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$6e41fae856809c3e$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $6e41fae856809c3e$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    } else if ($6e41fae856809c3e$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    }
    return this;
};
$6e41fae856809c3e$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($6e41fae856809c3e$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$6e41fae856809c3e$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($6e41fae856809c3e$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$6e41fae856809c3e$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($6e41fae856809c3e$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$6e41fae856809c3e$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $6e41fae856809c3e$var$isFunction(arg) {
    return typeof arg === "function";
}
function $6e41fae856809c3e$var$isNumber(arg) {
    return typeof arg === "number";
}
function $6e41fae856809c3e$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $6e41fae856809c3e$var$isUndefined(arg) {
    return arg === void 0;
}


var $6c5f62d9fb265ff7$exports = {};
"use strict";
function $6c5f62d9fb265ff7$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
$6c5f62d9fb265ff7$exports = $6c5f62d9fb265ff7$var$inherits;


/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 */ function $1471d29dbd734cc1$var$DerivedHelper(mainHelper, fn) {
    this.main = mainHelper;
    this.fn = fn;
    this.lastResults = null;
}
$6c5f62d9fb265ff7$exports($1471d29dbd734cc1$var$DerivedHelper, $6e41fae856809c3e$exports.EventEmitter);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $1471d29dbd734cc1$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$1471d29dbd734cc1$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$1471d29dbd734cc1$exports = $1471d29dbd734cc1$var$DerivedHelper;


var $d976dca2f29a8c83$exports = {};
"use strict";

var $d976dca2f29a8c83$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $d976dca2f29a8c83$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $d976dca2f29a8c83$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // maybe more to get the root level of hierarchical facets when activated
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            // if we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get the root values
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) queries.push({
                indexName: index,
                params: $d976dca2f29a8c83$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet, true)
            });
        });
        return queries;
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @return {object.<string, any>}
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($d976dca2f29a8c83$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state));
        var facetFilters = $d976dca2f29a8c83$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $d976dca2f29a8c83$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $d976dca2f29a8c83$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            facets: facets,
            tagFilters: tagFilters
        };
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $6a944a0326502a59$exports({}, state.getQueryParams(), additionalParams);
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object}
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $d976dca2f29a8c83$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $d976dca2f29a8c83$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $d976dca2f29a8c83$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 1,
            page: 0,
            attributesToRetrieve: [],
            attributesToHighlight: [],
            attributesToSnippet: [],
            tagFilters: tagFilters,
            analytics: false,
            clickAnalytics: false
        };
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $d976dca2f29a8c83$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $6a944a0326502a59$exports({}, state.getQueryParams(), additionalParams);
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending
   * @private
   * @return {string}
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(",");
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {string} [facet] if set, the current disjunctive facet
   * @return {array.<string>}
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.forEach(function(facetValue) {
                facetFilters.push(facetName + ":" + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.forEach(function(facetValue) {
                facetFilters.push(facetName + ":-" + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.forEach(function(facetValue) {
                orFilters.push(facetName + ":" + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ":" + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || "";
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === "number") searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $6a944a0326502a59$exports({}, $d976dca2f29a8c83$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters);
    }
};
$d976dca2f29a8c83$exports = $d976dca2f29a8c83$var$requestBuilder;








var $cuqDd = parcelRequire("cuqDd");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 */ function $768eefe947cb3bad$var$AlgoliaSearchHelper(client, index, options) {
    if (typeof client.addAlgoliaAgent === "function") client.addAlgoliaAgent("JS Helper (" + $cuqDd + ")");
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $d068995a46348d48$exports.make(opts);
    this.lastResults = null;
    this._queryId = 0;
    this._lastQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
}
$6c5f62d9fb265ff7$exports($768eefe947cb3bad$var$AlgoliaSearchHelper, $6e41fae856809c3e$exports.EventEmitter);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper}
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $d976dca2f29a8c83$exports._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [callback] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $d976dca2f29a8c83$exports._getQueries(tempState.index, tempState);
    var self = this;
    this._currentNbQueries++;
    this.emit("searchOnce", {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(null, new $8010139e6e6eb84d$exports(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        return {
            content: new $8010139e6e6eb84d$exports(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $6a944a0326502a59$exports({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $337bf59c6f823cc1$exports($d976dca2f29a8c83$exports._getHitsSearchParams(derivedState), [
            "attributesToSnippet",
            "hitsPerPage",
            "restrictSearchableAttributes",
            "snippetEllipsisText" // FIXME remove this line once the engine is fixed.
        ])
    });
    var errorMessage = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
    if (typeof this.client.initIndex !== "function") throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== "function") throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === "function";
    if (!clientHasSFFV && typeof this.client.initIndex !== "function") throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $d976dca2f29a8c83$exports.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    var self = this;
    this.emit("searchForFacetValues", {
        state: state,
        facet: facet,
        query: query
    });
    var searchForFacetValuesPromise = clientHasSFFV ? this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]) : this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.value) : state.isFacetRefined(facet, f.value);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper}
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper}
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper}
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper}
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper}
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 */ function $768eefe947cb3bad$var$setCurrentPage(page) {
    if (page < 0) throw new Error("Page requested below 0.");
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.setCurrentPage = $768eefe947cb3bad$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.setPage = $768eefe947cb3bad$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper}
 * @fires change
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $d068995a46348d48$exports.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper}
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $d068995a46348d48$exports(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($76eabdbb9e99b509$exports(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
   * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string}
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $768eefe947cb3bad$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.getCurrentPage = $768eefe947cb3bad$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.getPage = $768eefe947cb3bad$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "conjunctive"
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "exclude"
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "disjunctive"
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: "numeric"
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @return {undefined}
 * @fires search
 * @fires result
 * @fires error
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $d976dca2f29a8c83$exports._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit("search", {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = $d976dca2f29a8c83$exports._getQueries(derivedState.index, derivedState);
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit("search", {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>}
 *  state state used for to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // FIXME remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
    var results = content.results.slice();
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        var formattedResponse = helper.lastResults = new $8010139e6e6eb84d$exports(state, specificResults);
        helper.emit("result", {
            results: formattedResponse,
            state: state
        });
    });
};
$768eefe947cb3bad$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
};
$768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$768eefe947cb3bad$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit("change", {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    this.client.clearCache && this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === "function") newClient.addAlgoliaAgent("JS Helper (" + $cuqDd + ")");
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @return {DerivedHelper}
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.derive = function(fn) {
    var derivedHelper = new $1471d29dbd734cc1$exports(this, fn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @return {undefined}
 * @throws Error
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error("Derived helper already detached");
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $768eefe947cb3bad$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ $768eefe947cb3bad$exports = $768eefe947cb3bad$var$AlgoliaSearchHelper;




/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @return {AlgoliaSearchHelper}
 */ function $ee3ec914d550de31$var$algoliasearchHelper(client, index, opts) {
    return new $768eefe947cb3bad$exports(client, index, opts);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $ee3ec914d550de31$var$algoliasearchHelper.version = (parcelRequire("cuqDd"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $ee3ec914d550de31$var$algoliasearchHelper.AlgoliaSearchHelper = $768eefe947cb3bad$exports;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $ee3ec914d550de31$var$algoliasearchHelper.SearchParameters = $d068995a46348d48$exports;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $ee3ec914d550de31$var$algoliasearchHelper.SearchResults = $8010139e6e6eb84d$exports;
$ee3ec914d550de31$exports = $ee3ec914d550de31$var$algoliasearchHelper;




var $222bd44957f3ca8f$export$110679b26359d23d = function createDocumentationLink(_ref) {
    var name = _ref.name, _ref$connector = _ref.connector, connector = _ref$connector === void 0 ? false : _ref$connector;
    return [
        "https://www.algolia.com/doc/api-reference/widgets/",
        name,
        "/js/",
        connector ? "#connector" : ""
    ].join("");
};
var $222bd44957f3ca8f$export$2fde5bffc340821e = function createDocumentationMessageGenerator() {
    for(var _len = arguments.length, widgets = new Array(_len), _key = 0; _key < _len; _key++)widgets[_key] = arguments[_key];
    var links = widgets.map(function(widget) {
        return $222bd44957f3ca8f$export$110679b26359d23d(widget);
    }).join(", ");
    return function(message) {
        return [
            message,
            "See documentation: ".concat(links)
        ].filter(Boolean).join("\n\n");
    };
};

// We aren't using the native `Array.prototype.findIndex` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `findIndex` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.findIndex` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
function $de3ac0ee47474fd1$var$findIndex(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
}
var $de3ac0ee47474fd1$export$2e2bcd8739ae039 = $de3ac0ee47474fd1$var$findIndex;


function $23f14a556c3a59a3$var$uniq(array) {
    return array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
}
var $23f14a556c3a59a3$export$2e2bcd8739ae039 = $23f14a556c3a59a3$var$uniq;


function $e7f56a23dffa4649$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e7f56a23dffa4649$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e7f56a23dffa4649$var$ownKeys(Object(source), true).forEach(function(key) {
            $e7f56a23dffa4649$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e7f56a23dffa4649$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e7f56a23dffa4649$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e7f56a23dffa4649$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e7f56a23dffa4649$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e7f56a23dffa4649$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e7f56a23dffa4649$var$mergeWithRest = function mergeWithRest(left, right) {
    var facets = right.facets, disjunctiveFacets = right.disjunctiveFacets, facetsRefinements = right.facetsRefinements, facetsExcludes = right.facetsExcludes, disjunctiveFacetsRefinements = right.disjunctiveFacetsRefinements, numericRefinements = right.numericRefinements, tagRefinements = right.tagRefinements, hierarchicalFacets = right.hierarchicalFacets, hierarchicalFacetsRefinements = right.hierarchicalFacetsRefinements, ruleContexts = right.ruleContexts, rest = $e7f56a23dffa4649$var$_objectWithoutProperties(right, [
        "facets",
        "disjunctiveFacets",
        "facetsRefinements",
        "facetsExcludes",
        "disjunctiveFacetsRefinements",
        "numericRefinements",
        "tagRefinements",
        "hierarchicalFacets",
        "hierarchicalFacetsRefinements",
        "ruleContexts"
    ]);
    return left.setQueryParameters(rest);
}; // Merge facets
var $e7f56a23dffa4649$var$mergeFacets = function mergeFacets(left, right) {
    return right.facets.reduce(function(_, name) {
        return _.addFacet(name);
    }, left);
};
var $e7f56a23dffa4649$var$mergeDisjunctiveFacets = function mergeDisjunctiveFacets(left, right) {
    return right.disjunctiveFacets.reduce(function(_, name) {
        return _.addDisjunctiveFacet(name);
    }, left);
};
var $e7f56a23dffa4649$var$mergeHierarchicalFacets = function mergeHierarchicalFacets(left, right) {
    return left.setQueryParameters({
        hierarchicalFacets: right.hierarchicalFacets.reduce(function(facets, facet) {
            var index = (0, $de3ac0ee47474fd1$export$2e2bcd8739ae039)(facets, function(_) {
                return _.name === facet.name;
            });
            if (index === -1) return facets.concat(facet);
            var nextFacets = facets.slice();
            nextFacets.splice(index, 1, facet);
            return nextFacets;
        }, left.hierarchicalFacets)
    });
}; // Merge facet refinements
var $e7f56a23dffa4649$var$mergeTagRefinements = function mergeTagRefinements(left, right) {
    return right.tagRefinements.reduce(function(_, value) {
        return _.addTagRefinement(value);
    }, left);
};
var $e7f56a23dffa4649$var$mergeFacetRefinements = function mergeFacetRefinements(left, right) {
    return left.setQueryParameters({
        facetsRefinements: $e7f56a23dffa4649$var$_objectSpread($e7f56a23dffa4649$var$_objectSpread({}, left.facetsRefinements), right.facetsRefinements)
    });
};
var $e7f56a23dffa4649$var$mergeFacetsExcludes = function mergeFacetsExcludes(left, right) {
    return left.setQueryParameters({
        facetsExcludes: $e7f56a23dffa4649$var$_objectSpread($e7f56a23dffa4649$var$_objectSpread({}, left.facetsExcludes), right.facetsExcludes)
    });
};
var $e7f56a23dffa4649$var$mergeDisjunctiveFacetsRefinements = function mergeDisjunctiveFacetsRefinements(left, right) {
    return left.setQueryParameters({
        disjunctiveFacetsRefinements: $e7f56a23dffa4649$var$_objectSpread($e7f56a23dffa4649$var$_objectSpread({}, left.disjunctiveFacetsRefinements), right.disjunctiveFacetsRefinements)
    });
};
var $e7f56a23dffa4649$var$mergeNumericRefinements = function mergeNumericRefinements(left, right) {
    return left.setQueryParameters({
        numericRefinements: $e7f56a23dffa4649$var$_objectSpread($e7f56a23dffa4649$var$_objectSpread({}, left.numericRefinements), right.numericRefinements)
    });
};
var $e7f56a23dffa4649$var$mergeHierarchicalFacetsRefinements = function mergeHierarchicalFacetsRefinements(left, right) {
    return left.setQueryParameters({
        hierarchicalFacetsRefinements: $e7f56a23dffa4649$var$_objectSpread($e7f56a23dffa4649$var$_objectSpread({}, left.hierarchicalFacetsRefinements), right.hierarchicalFacetsRefinements)
    });
};
var $e7f56a23dffa4649$var$mergeRuleContexts = function mergeRuleContexts(left, right) {
    var ruleContexts = (0, $23f14a556c3a59a3$export$2e2bcd8739ae039)([].concat(left.ruleContexts).concat(right.ruleContexts).filter(Boolean));
    if (ruleContexts.length > 0) return left.setQueryParameters({
        ruleContexts: ruleContexts
    });
    return left;
};
var $e7f56a23dffa4649$var$merge = function merge() {
    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++)parameters[_key] = arguments[_key];
    return parameters.reduce(function(left, right) {
        var hierarchicalFacetsRefinementsMerged = $e7f56a23dffa4649$var$mergeHierarchicalFacetsRefinements(left, right);
        var hierarchicalFacetsMerged = $e7f56a23dffa4649$var$mergeHierarchicalFacets(hierarchicalFacetsRefinementsMerged, right);
        var tagRefinementsMerged = $e7f56a23dffa4649$var$mergeTagRefinements(hierarchicalFacetsMerged, right);
        var numericRefinementsMerged = $e7f56a23dffa4649$var$mergeNumericRefinements(tagRefinementsMerged, right);
        var disjunctiveFacetsRefinementsMerged = $e7f56a23dffa4649$var$mergeDisjunctiveFacetsRefinements(numericRefinementsMerged, right);
        var facetsExcludesMerged = $e7f56a23dffa4649$var$mergeFacetsExcludes(disjunctiveFacetsRefinementsMerged, right);
        var facetRefinementsMerged = $e7f56a23dffa4649$var$mergeFacetRefinements(facetsExcludesMerged, right);
        var disjunctiveFacetsMerged = $e7f56a23dffa4649$var$mergeDisjunctiveFacets(facetRefinementsMerged, right);
        var ruleContextsMerged = $e7f56a23dffa4649$var$mergeRuleContexts(disjunctiveFacetsMerged, right);
        var facetsMerged = $e7f56a23dffa4649$var$mergeFacets(ruleContextsMerged, right);
        return $e7f56a23dffa4649$var$mergeWithRest(facetsMerged, right);
    });
};
var $e7f56a23dffa4649$export$2e2bcd8739ae039 = $e7f56a23dffa4649$var$merge;

var $0c813b757d4833a7$var$resolveSearchParameters = function resolveSearchParameters(current) {
    var parent = current.getParent();
    var states = [
        current.getHelper().state
    ];
    while(parent !== null){
        states = [
            parent.getHelper().state
        ].concat(states);
        parent = parent.getParent();
    }
    return states;
};
var $0c813b757d4833a7$export$2e2bcd8739ae039 = $0c813b757d4833a7$var$resolveSearchParameters;


function $6147dba0b024d6d3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6147dba0b024d6d3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6147dba0b024d6d3$var$ownKeys(Object(source), true).forEach(function(key) {
            $6147dba0b024d6d3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6147dba0b024d6d3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6147dba0b024d6d3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6147dba0b024d6d3$var$_toConsumableArray(arr) {
    return $6147dba0b024d6d3$var$_arrayWithoutHoles(arr) || $6147dba0b024d6d3$var$_iterableToArray(arr) || $6147dba0b024d6d3$var$_unsupportedIterableToArray(arr) || $6147dba0b024d6d3$var$_nonIterableSpread();
}
function $6147dba0b024d6d3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6147dba0b024d6d3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6147dba0b024d6d3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6147dba0b024d6d3$var$_arrayLikeToArray(o, minLen);
}
function $6147dba0b024d6d3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $6147dba0b024d6d3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6147dba0b024d6d3$var$_arrayLikeToArray(arr);
}
function $6147dba0b024d6d3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6147dba0b024d6d3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6147dba0b024d6d3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6147dba0b024d6d3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6147dba0b024d6d3$var$withUsage = (0, $222bd44957f3ca8f$export$2fde5bffc340821e)({
    name: "index-widget"
});
function $6147dba0b024d6d3$export$a9c9a0d43506297d(widget) {
    return widget.$$type === "ais.index";
}
/**
 * This is the same content as helper._change / setState, but allowing for extra
 * UiState to be synchronized.
 * see: https://github.com/algolia/algoliasearch-helper-js/blob/6b835ffd07742f2d6b314022cce6848f5cfecd4a/src/algoliasearch.helper.js#L1311-L1324
 */ function $6147dba0b024d6d3$var$privateHelperSetState(helper, _ref) {
    var state = _ref.state, isPageReset = _ref.isPageReset, _uiState = _ref._uiState;
    if (state !== helper.state) {
        helper.state = state;
        helper.emit("change", {
            state: helper.state,
            results: helper.lastResults,
            isPageReset: isPageReset,
            _uiState: _uiState
        });
    }
}
function $6147dba0b024d6d3$var$getLocalWidgetsUiState(widgets, widgetStateOptions) {
    var initialUiState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return widgets.reduce(function(uiState, widget) {
        if ($6147dba0b024d6d3$export$a9c9a0d43506297d(widget)) return uiState;
        if (!widget.getWidgetUiState && !widget.getWidgetState) return uiState;
        if (widget.getWidgetUiState) return widget.getWidgetUiState(uiState, widgetStateOptions);
        return widget.getWidgetState(uiState, widgetStateOptions);
    }, initialUiState);
}
function $6147dba0b024d6d3$var$getLocalWidgetsSearchParameters(widgets, widgetSearchParametersOptions) {
    var initialSearchParameters = widgetSearchParametersOptions.initialSearchParameters, rest = $6147dba0b024d6d3$var$_objectWithoutProperties(widgetSearchParametersOptions, [
        "initialSearchParameters"
    ]);
    return widgets.filter(function(widget) {
        return !$6147dba0b024d6d3$export$a9c9a0d43506297d(widget);
    }).reduce(function(state, widget) {
        if (!widget.getWidgetSearchParameters) return state;
        return widget.getWidgetSearchParameters(state, rest);
    }, initialSearchParameters);
}
function $6147dba0b024d6d3$var$resetPageFromWidgets(widgets) {
    var indexWidgets = widgets.filter($6147dba0b024d6d3$export$a9c9a0d43506297d);
    if (indexWidgets.length === 0) return;
    indexWidgets.forEach(function(widget) {
        var widgetHelper = widget.getHelper();
        $6147dba0b024d6d3$var$privateHelperSetState(widgetHelper, {
            state: widgetHelper.state.resetPage(),
            isPageReset: true
        });
        $6147dba0b024d6d3$var$resetPageFromWidgets(widget.getWidgets());
    });
}
function $6147dba0b024d6d3$var$resolveScopedResultsFromWidgets(widgets) {
    var indexWidgets = widgets.filter($6147dba0b024d6d3$export$a9c9a0d43506297d);
    return indexWidgets.reduce(function(scopedResults, current) {
        return scopedResults.concat.apply(scopedResults, [
            {
                indexId: current.getIndexId(),
                results: current.getResults(),
                helper: current.getHelper()
            }
        ].concat($6147dba0b024d6d3$var$_toConsumableArray($6147dba0b024d6d3$var$resolveScopedResultsFromWidgets(current.getWidgets()))));
    }, []);
}
var $6147dba0b024d6d3$var$index = function index(widgetParams) {
    if (widgetParams === undefined || widgetParams.indexName === undefined) throw new Error($6147dba0b024d6d3$var$withUsage("The `indexName` option is required."));
    var indexName = widgetParams.indexName, _widgetParams$indexId = widgetParams.indexId, indexId = _widgetParams$indexId === void 0 ? indexName : _widgetParams$indexId;
    var localWidgets = [];
    var localUiState = {};
    var localInstantSearchInstance = null;
    var localParent = null;
    var helper = null;
    var derivedHelper = null;
    return {
        $$type: "ais.index",
        $$widgetType: "ais.index",
        getIndexName: function getIndexName() {
            return indexName;
        },
        getIndexId: function getIndexId() {
            return indexId;
        },
        getHelper: function getHelper() {
            return helper;
        },
        getResults: function getResults() {
            return derivedHelper && derivedHelper.lastResults;
        },
        getScopedResults: function getScopedResults() {
            var widgetParent = this.getParent(); // If the widget is the root, we consider itself as the only sibling.
            var widgetSiblings = widgetParent ? widgetParent.getWidgets() : [
                this
            ];
            return $6147dba0b024d6d3$var$resolveScopedResultsFromWidgets(widgetSiblings);
        },
        getParent: function getParent() {
            return localParent;
        },
        createURL: function createURL(nextState) {
            return localInstantSearchInstance._createURL($6147dba0b024d6d3$var$_defineProperty({}, indexId, $6147dba0b024d6d3$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: nextState,
                helper: helper
            })));
        },
        getWidgets: function getWidgets() {
            return localWidgets;
        },
        addWidgets: function addWidgets(widgets) {
            var _this = this;
            if (!Array.isArray(widgets)) throw new Error($6147dba0b024d6d3$var$withUsage("The `addWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.init !== "function" && typeof widget.render !== "function";
            })) throw new Error($6147dba0b024d6d3$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
            localWidgets = localWidgets.concat(widgets);
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                $6147dba0b024d6d3$var$privateHelperSetState(helper, {
                    state: $6147dba0b024d6d3$var$getLocalWidgetsSearchParameters(localWidgets, {
                        uiState: localUiState,
                        initialSearchParameters: helper.state
                    }),
                    _uiState: localUiState
                }); // We compute the render state before calling `init` in a separate loop
                // to construct the whole render state object that is then passed to
                // `init`.
                widgets.forEach(function(widget) {
                    if (widget.getRenderState) {
                        var renderState = widget.getRenderState(localInstantSearchInstance.renderState[_this.getIndexId()] || {}, {
                            uiState: localInstantSearchInstance._initialUiState,
                            helper: _this.getHelper(),
                            parent: _this,
                            instantSearchInstance: localInstantSearchInstance,
                            state: helper.state,
                            renderState: localInstantSearchInstance.renderState,
                            templatesConfig: localInstantSearchInstance.templatesConfig,
                            createURL: _this.createURL,
                            scopedResults: [],
                            searchMetadata: {
                                isSearchStalled: localInstantSearchInstance._isSearchStalled
                            }
                        });
                        $6147dba0b024d6d3$var$storeRenderState({
                            renderState: renderState,
                            instantSearchInstance: localInstantSearchInstance,
                            parent: _this
                        });
                    }
                });
                widgets.forEach(function(widget) {
                    if (widget.init) widget.init({
                        helper: helper,
                        parent: _this,
                        uiState: localInstantSearchInstance._initialUiState,
                        instantSearchInstance: localInstantSearchInstance,
                        state: helper.state,
                        renderState: localInstantSearchInstance.renderState,
                        templatesConfig: localInstantSearchInstance.templatesConfig,
                        createURL: _this.createURL,
                        scopedResults: [],
                        searchMetadata: {
                            isSearchStalled: localInstantSearchInstance._isSearchStalled
                        }
                    });
                });
                localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        removeWidgets: function removeWidgets(widgets) {
            var _this2 = this;
            if (!Array.isArray(widgets)) throw new Error($6147dba0b024d6d3$var$withUsage("The `removeWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.dispose !== "function";
            })) throw new Error($6147dba0b024d6d3$var$withUsage("The widget definition expects a `dispose` method."));
            localWidgets = localWidgets.filter(function(widget) {
                return widgets.indexOf(widget) === -1;
            });
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                var nextState = widgets.reduce(function(state, widget) {
                    // the `dispose` method exists at this point we already assert it
                    var next = widget.dispose({
                        helper: helper,
                        state: state,
                        parent: _this2
                    });
                    return next || state;
                }, helper.state);
                localUiState = $6147dba0b024d6d3$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: nextState,
                    helper: helper
                });
                helper.setState($6147dba0b024d6d3$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: localUiState,
                    initialSearchParameters: nextState
                }));
                if (localWidgets.length) localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        init: function init(_ref2) {
            var _this3 = this;
            var instantSearchInstance = _ref2.instantSearchInstance, parent = _ref2.parent, uiState = _ref2.uiState;
            if (helper !== null) // helper is already initialized, therefore we do not need to set up
            // any listeners
            return;
            localInstantSearchInstance = instantSearchInstance;
            localParent = parent;
            localUiState = uiState[indexId] || {}; // The `mainHelper` is already defined at this point. The instance is created
            // inside InstantSearch at the `start` method, which occurs before the `init`
            // step.
            var mainHelper = instantSearchInstance.mainHelper;
            var parameters = $6147dba0b024d6d3$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: localUiState,
                initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($ee3ec914d550de31$exports))).SearchParameters({
                    index: indexName
                })
            }); // This Helper is only used for state management we do not care about the
            // `searchClient`. Only the "main" Helper created at the `InstantSearch`
            // level is aware of the client.
            helper = (0, (/*@__PURE__*/$parcel$interopDefault($ee3ec914d550de31$exports)))({}, parameters.index, parameters); // We forward the call to `search` to the "main" instance of the Helper
            // which is responsible for managing the queries (it's the only one that is
            // aware of the `searchClient`).
            helper.search = function() {
                if (instantSearchInstance.onStateChange) {
                    instantSearchInstance.onStateChange({
                        uiState: instantSearchInstance.mainIndex.getWidgetUiState({}),
                        setUiState: instantSearchInstance.setUiState.bind(instantSearchInstance)
                    }); // We don't trigger a search when controlled because it becomes the
                    // responsibility of `setUiState`.
                    return mainHelper;
                }
                return mainHelper.search();
            };
            helper.searchWithoutTriggeringOnStateChange = function() {
                return mainHelper.search();
            }; // We use the same pattern for the `searchForFacetValues`.
            helper.searchForFacetValues = function(facetName, facetValue, maxFacetHits, userState) {
                var state = helper.state.setQueryParameters(userState);
                return mainHelper.searchForFacetValues(facetName, facetValue, maxFacetHits, state);
            };
            derivedHelper = mainHelper.derive(function() {
                return (0, $e7f56a23dffa4649$export$2e2bcd8739ae039).apply(void 0, $6147dba0b024d6d3$var$_toConsumableArray((0, $0c813b757d4833a7$export$2e2bcd8739ae039)(_this3)));
            }); // Subscribe to the Helper state changes for the page before widgets
            // are initialized. This behavior mimics the original one of the Helper.
            // It makes sense to replicate it at the `init` step. We have another
            // listener on `change` below, once `init` is done.
            helper.on("change", function(_ref3) {
                var isPageReset = _ref3.isPageReset;
                if (isPageReset) $6147dba0b024d6d3$var$resetPageFromWidgets(localWidgets);
            });
            derivedHelper.on("search", function() {
                // The index does not manage the "staleness" of the search. This is the
                // responsibility of the main instance. It does not make sense to manage
                // it at the index level because it's either: all of them or none of them
                // that are stalled. The queries are performed into a single network request.
                instantSearchInstance.scheduleStalledRender();
            });
            derivedHelper.on("result", function(_ref4) {
                var results = _ref4.results;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender(); // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastResults, which it used to in pre-federated
                // search behavior.
                helper.lastResults = results;
            }); // We compute the render state before calling `init` in a separate loop
            // to construct the whole render state object that is then passed to
            // `init`.
            localWidgets.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this3.getIndexId()] || {}, {
                        uiState: uiState,
                        helper: helper,
                        parent: _this3,
                        instantSearchInstance: instantSearchInstance,
                        state: helper.state,
                        renderState: instantSearchInstance.renderState,
                        templatesConfig: instantSearchInstance.templatesConfig,
                        createURL: _this3.createURL,
                        scopedResults: [],
                        searchMetadata: {
                            isSearchStalled: instantSearchInstance._isSearchStalled
                        }
                    });
                    $6147dba0b024d6d3$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this3
                    });
                }
            });
            localWidgets.forEach(function(widget) {
                if (widget.init) widget.init({
                    uiState: uiState,
                    helper: helper,
                    parent: _this3,
                    instantSearchInstance: instantSearchInstance,
                    state: helper.state,
                    renderState: instantSearchInstance.renderState,
                    templatesConfig: instantSearchInstance.templatesConfig,
                    createURL: _this3.createURL,
                    scopedResults: [],
                    searchMetadata: {
                        isSearchStalled: instantSearchInstance._isSearchStalled
                    }
                });
            }); // Subscribe to the Helper state changes for the `uiState` once widgets
            // are initialized. Until the first render, state changes are part of the
            // configuration step. This is mainly for backward compatibility with custom
            // widgets. When the subscription happens before the `init` step, the (static)
            // configuration of the widget is pushed in the URL. That's what we want to avoid.
            // https://github.com/algolia/instantsearch.js/pull/994/commits/4a672ae3fd78809e213de0368549ef12e9dc9454
            helper.on("change", function(event) {
                var state = event.state;
                var _uiState = event._uiState;
                localUiState = $6147dba0b024d6d3$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: state,
                    helper: helper
                }, _uiState || {}); // We don't trigger an internal change when controlled because it
                // becomes the responsibility of `setUiState`.
                if (!instantSearchInstance.onStateChange) instantSearchInstance.onInternalStateChange();
            });
        },
        render: function render(_ref5) {
            var _this4 = this;
            var instantSearchInstance = _ref5.instantSearchInstance;
            if (!this.getResults()) return;
            localWidgets.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this4.getIndexId()] || {}, {
                        helper: _this4.getHelper(),
                        parent: _this4,
                        instantSearchInstance: instantSearchInstance,
                        results: _this4.getResults(),
                        scopedResults: _this4.getScopedResults(),
                        state: _this4.getResults()._state,
                        renderState: instantSearchInstance.renderState,
                        templatesConfig: instantSearchInstance.templatesConfig,
                        createURL: _this4.createURL,
                        searchMetadata: {
                            isSearchStalled: instantSearchInstance._isSearchStalled
                        }
                    });
                    $6147dba0b024d6d3$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this4
                    });
                }
            });
            localWidgets.forEach(function(widget) {
                // At this point, all the variables used below are set. Both `helper`
                // and `derivedHelper` have been created at the `init` step. The attribute
                // `lastResults` might be `null` though. It's possible that a stalled render
                // happens before the result e.g with a dynamically added index the request might
                // be delayed. The render is triggered for the complete tree but some parts do
                // not have results yet.
                if (widget.render) widget.render({
                    helper: helper,
                    parent: _this4,
                    instantSearchInstance: instantSearchInstance,
                    results: _this4.getResults(),
                    scopedResults: _this4.getScopedResults(),
                    state: _this4.getResults()._state,
                    renderState: instantSearchInstance.renderState,
                    templatesConfig: instantSearchInstance.templatesConfig,
                    createURL: _this4.createURL,
                    searchMetadata: {
                        isSearchStalled: instantSearchInstance._isSearchStalled
                    }
                });
            });
        },
        dispose: function dispose() {
            var _this5 = this;
            localWidgets.forEach(function(widget) {
                if (widget.dispose) // The dispose function is always called once the instance is started
                // (it's an effect of `removeWidgets`). The index is initialized and
                // the Helper is available. We don't care about the return value of
                // `dispose` because the index is removed. We can't call `removeWidgets`
                // because we want to keep the widgets on the instance, to allow idempotent
                // operations on `add` & `remove`.
                widget.dispose({
                    helper: helper,
                    state: helper.state,
                    parent: _this5
                });
            });
            localInstantSearchInstance = null;
            localParent = null;
            helper.removeAllListeners();
            helper = null;
            derivedHelper.detach();
            derivedHelper = null;
        },
        getWidgetUiState: function getWidgetUiState(uiState) {
            return localWidgets.filter($6147dba0b024d6d3$export$a9c9a0d43506297d).reduce(function(previousUiState, innerIndex) {
                return innerIndex.getWidgetUiState(previousUiState);
            }, $6147dba0b024d6d3$var$_objectSpread($6147dba0b024d6d3$var$_objectSpread({}, uiState), {}, $6147dba0b024d6d3$var$_defineProperty({}, this.getIndexId(), localUiState)));
        },
        getWidgetState: function getWidgetState(uiState) {
            return this.getWidgetUiState(uiState);
        },
        getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
            var uiState = _ref6.uiState;
            return $6147dba0b024d6d3$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: uiState,
                initialSearchParameters: searchParameters
            });
        },
        refreshUiState: function refreshUiState() {
            localUiState = $6147dba0b024d6d3$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: this.getHelper().state,
                helper: this.getHelper()
            });
        }
    };
};
var $6147dba0b024d6d3$export$2e2bcd8739ae039 = $6147dba0b024d6d3$var$index;
function $6147dba0b024d6d3$var$storeRenderState(_ref7) {
    var renderState = _ref7.renderState, instantSearchInstance = _ref7.instantSearchInstance, parent = _ref7.parent;
    var parentIndexName = parent ? parent.getIndexId() : instantSearchInstance.mainIndex.getIndexId();
    instantSearchInstance.renderState = $6147dba0b024d6d3$var$_objectSpread($6147dba0b024d6d3$var$_objectSpread({}, instantSearchInstance.renderState), {}, $6147dba0b024d6d3$var$_defineProperty({}, parentIndexName, $6147dba0b024d6d3$var$_objectSpread($6147dba0b024d6d3$var$_objectSpread({}, instantSearchInstance.renderState[parentIndexName]), renderState)));
}


var $4fbe7e4363b97af8$export$2e2bcd8739ae039 = "4.24.1";


var $9426e41dc741124c$var$NAMESPACE = "ais";
var $9426e41dc741124c$export$d8556a2a8f973135 = function component(componentName) {
    return function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, descendantName = _ref.descendantName, modifierName = _ref.modifierName;
        var descendent = descendantName ? "-".concat(descendantName) : "";
        var modifier = modifierName ? "--".concat(modifierName) : "";
        return "".concat($9426e41dc741124c$var$NAMESPACE, "-").concat(componentName).concat(descendent).concat(modifier);
    };
};


function $7f5b3005d0607e06$var$getPropertyByPath(object, path) {
    var parts = Array.isArray(path) ? path : path.split(".");
    return parts.reduce(function(current, key) {
        return current && current[key];
    }, object);
}
var $7f5b3005d0607e06$export$2e2bcd8739ae039 = $7f5b3005d0607e06$var$getPropertyByPath;

/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/escape.js
 */ // Used to map characters to HTML entities.
var $76f9465f068352b6$var$htmlEscapes = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
}; // Used to match HTML entities and HTML characters.
var $76f9465f068352b6$var$regexUnescapedHtml = /[&<>"']/g;
var $76f9465f068352b6$var$regexHasUnescapedHtml = RegExp($76f9465f068352b6$var$regexUnescapedHtml.source);
/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 */ function $76f9465f068352b6$var$escape(value) {
    return value && $76f9465f068352b6$var$regexHasUnescapedHtml.test(value) ? value.replace($76f9465f068352b6$var$regexUnescapedHtml, function(character) {
        return $76f9465f068352b6$var$htmlEscapes[character];
    }) : value;
}
var $76f9465f068352b6$export$2e2bcd8739ae039 = $76f9465f068352b6$var$escape;


function $d8ab6142373ab1f1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d8ab6142373ab1f1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d8ab6142373ab1f1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d8ab6142373ab1f1$var$_typeof(obj);
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/master/isPlainObject.js
 */ function $d8ab6142373ab1f1$var$getTag(value) {
    if (value === null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
function $d8ab6142373ab1f1$var$isObjectLike(value) {
    return $d8ab6142373ab1f1$var$_typeof(value) === "object" && value !== null;
}
/**
 * Checks if `value` is a plain object.
 *
 * A plain object is an object created by the `Object`
 * constructor or with a `[[Prototype]]` of `null`.
 */ function $d8ab6142373ab1f1$var$isPlainObject(value) {
    if (!$d8ab6142373ab1f1$var$isObjectLike(value) || $d8ab6142373ab1f1$var$getTag(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    var proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}
var $d8ab6142373ab1f1$export$2e2bcd8739ae039 = $d8ab6142373ab1f1$var$isPlainObject;


function $b85debef0921786f$var$_extends() {
    $b85debef0921786f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b85debef0921786f$var$_extends.apply(this, arguments);
}
function $b85debef0921786f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b85debef0921786f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b85debef0921786f$var$ownKeys(Object(source), true).forEach(function(key) {
            $b85debef0921786f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b85debef0921786f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b85debef0921786f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b85debef0921786f$export$1e7338a8952eaf35 = {
    highlightPreTag: "__ais-highlight__",
    highlightPostTag: "__/ais-highlight__"
};
var $b85debef0921786f$export$62e796b7905e8e6b = {
    highlightPreTag: "<mark>",
    highlightPostTag: "</mark>"
};
function $b85debef0921786f$var$replaceTagsAndEscape(value) {
    return (0, $76f9465f068352b6$export$2e2bcd8739ae039)(value).replace(new RegExp($b85debef0921786f$export$1e7338a8952eaf35.highlightPreTag, "g"), $b85debef0921786f$export$62e796b7905e8e6b.highlightPreTag).replace(new RegExp($b85debef0921786f$export$1e7338a8952eaf35.highlightPostTag, "g"), $b85debef0921786f$export$62e796b7905e8e6b.highlightPostTag);
}
function $b85debef0921786f$var$recursiveEscape(input) {
    if ((0, $d8ab6142373ab1f1$export$2e2bcd8739ae039)(input) && typeof input.value !== "string") return Object.keys(input).reduce(function(acc, key) {
        return $b85debef0921786f$var$_objectSpread($b85debef0921786f$var$_objectSpread({}, acc), {}, $b85debef0921786f$var$_defineProperty({}, key, $b85debef0921786f$var$recursiveEscape(input[key])));
    }, {});
    if (Array.isArray(input)) return input.map($b85debef0921786f$var$recursiveEscape);
    return $b85debef0921786f$var$_objectSpread($b85debef0921786f$var$_objectSpread({}, input), {}, {
        value: $b85debef0921786f$var$replaceTagsAndEscape(input.value)
    });
}
function $b85debef0921786f$export$9adb036445aab889(hits) {
    if (hits.__escaped === undefined) {
        // We don't override the value on hit because it will mutate the raw results
        // instead we make a shallow copy and we assign the escaped values on it.
        hits = hits.map(function(_ref) {
            var hit = $b85debef0921786f$var$_extends({}, _ref);
            if (hit._highlightResult) hit._highlightResult = $b85debef0921786f$var$recursiveEscape(hit._highlightResult);
            if (hit._snippetResult) hit._snippetResult = $b85debef0921786f$var$recursiveEscape(hit._snippetResult);
            return hit;
        });
        hits.__escaped = true;
    }
    return hits;
}
function $b85debef0921786f$export$9ae2e822836b2e1a(facetHits) {
    return facetHits.map(function(h) {
        return $b85debef0921786f$var$_objectSpread($b85debef0921786f$var$_objectSpread({}, h), {}, {
            highlighted: $b85debef0921786f$var$replaceTagsAndEscape(h.highlighted)
        });
    });
}


var $9b3d6101ae46038b$var$suit = (0, $9426e41dc741124c$export$d8556a2a8f973135)("Highlight");
function $9b3d6101ae46038b$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var _ref2 = (0, $7f5b3005d0607e06$export$2e2bcd8739ae039)(hit._highlightResult, attribute) || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value; // cx is not used, since it would be bundled as a dependency for Vue & Angular
    var className = $9b3d6101ae46038b$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $b85debef0921786f$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $b85debef0921786f$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}

function $3fe0a367fb335f83$export$44b4521aa38272f2(payload) {
    return btoa(encodeURIComponent(JSON.stringify(payload)));
}
function $3fe0a367fb335f83$export$706ea24b0964bee9(payload) {
    return JSON.parse(decodeURIComponent(atob(payload)));
}


function $1df60413cb0e41e0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1df60413cb0e41e0$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1df60413cb0e41e0$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1df60413cb0e41e0$var$_typeof(obj);
}
function $1df60413cb0e41e0$export$cbcfede36ce7ab2e(domElement) {
    var method = domElement.getAttribute("data-insights-method");
    var serializedPayload = domElement.getAttribute("data-insights-payload");
    if (typeof serializedPayload !== "string") throw new Error("The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.");
    try {
        var payload = (0, $3fe0a367fb335f83$export$706ea24b0964bee9)(serializedPayload);
        return {
            method: method,
            payload: payload
        };
    } catch (error) {
        throw new Error("The insights helper was unable to parse `data-insights-payload`.");
    }
}
function $1df60413cb0e41e0$export$75ec42bbd0a5e7d6(domElement) {
    return domElement.hasAttribute("data-insights-method");
}
function $1df60413cb0e41e0$export$a3453cc0ced8b97c(_ref) {
    var method = _ref.method, payload = _ref.payload;
    if ($1df60413cb0e41e0$var$_typeof(payload) !== "object") throw new Error("The insights helper expects the payload to be an object.");
    var serializedPayload;
    try {
        serializedPayload = (0, $3fe0a367fb335f83$export$44b4521aa38272f2)(payload);
    } catch (error) {
        throw new Error("Could not JSON serialize the payload object.");
    }
    return 'data-insights-method="'.concat(method, '" data-insights-payload="').concat(serializedPayload, '"');
}
function $1df60413cb0e41e0$export$2e2bcd8739ae039(method, payload) {
    return $1df60413cb0e41e0$export$a3453cc0ced8b97c({
        method: method,
        payload: payload
    });
}


function $3b4f89083d3f02d4$export$2e2bcd8739ae039(parts) {
    var highlightPreTag = (0, $b85debef0921786f$export$62e796b7905e8e6b).highlightPreTag, highlightPostTag = (0, $b85debef0921786f$export$62e796b7905e8e6b).highlightPostTag;
    return parts.map(function(part) {
        return part.isHighlighted ? highlightPreTag + part.value + highlightPostTag : part.value;
    }).join("");
}


function $4e31c65f190d3452$export$2e2bcd8739ae039(highlightedValue) {
    var highlightPostTag = (0, $b85debef0921786f$export$62e796b7905e8e6b).highlightPostTag, highlightPreTag = (0, $b85debef0921786f$export$62e796b7905e8e6b).highlightPreTag;
    var splitByPreTag = highlightedValue.split(highlightPreTag);
    var firstValue = splitByPreTag.shift();
    var elements = !firstValue ? [] : [
        {
            value: firstValue,
            isHighlighted: false
        }
    ];
    splitByPreTag.forEach(function(split) {
        var splitByPostTag = split.split(highlightPostTag);
        elements.push({
            value: splitByPostTag[0],
            isHighlighted: true
        });
        if (splitByPostTag[1] !== "") elements.push({
            value: splitByPostTag[1],
            isHighlighted: false
        });
    });
    return elements;
}

/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/unescape.js
 */ // Used to map HTML entities to characters.
var $86a08a3d644bb7b8$var$htmlEscapes = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
}; // Used to match HTML entities and HTML characters.
var $86a08a3d644bb7b8$var$regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var $86a08a3d644bb7b8$var$regexHasEscapedHtml = RegExp($86a08a3d644bb7b8$var$regexEscapedHtml.source);
function $86a08a3d644bb7b8$export$2e2bcd8739ae039(value) {
    return value && $86a08a3d644bb7b8$var$regexHasEscapedHtml.test(value) ? value.replace($86a08a3d644bb7b8$var$regexEscapedHtml, function(character) {
        return $86a08a3d644bb7b8$var$htmlEscapes[character];
    }) : value;
}


var $879472aa329a3461$var$hasAlphanumeric = new RegExp(/\w/i);
function $879472aa329a3461$export$2e2bcd8739ae039(parts, i) {
    var _parts, _parts2;
    var current = parts[i];
    var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
    var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;
    if (!$879472aa329a3461$var$hasAlphanumeric.test((0, $86a08a3d644bb7b8$export$2e2bcd8739ae039)(current.value)) && isPreviousHighlighted === isNextHighlighted) return isPreviousHighlighted;
    return current.isHighlighted;
}


function $e45d31768e45609d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e45d31768e45609d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e45d31768e45609d$var$ownKeys(Object(source), true).forEach(function(key) {
            $e45d31768e45609d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e45d31768e45609d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e45d31768e45609d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e45d31768e45609d$export$2e2bcd8739ae039(parts) {
    if (!parts.some(function(part) {
        return part.isHighlighted;
    })) return parts.map(function(part) {
        return $e45d31768e45609d$var$_objectSpread($e45d31768e45609d$var$_objectSpread({}, part), {}, {
            isHighlighted: false
        });
    });
    return parts.map(function(part, i) {
        return $e45d31768e45609d$var$_objectSpread($e45d31768e45609d$var$_objectSpread({}, part), {}, {
            isHighlighted: !(0, $879472aa329a3461$export$2e2bcd8739ae039)(parts, i)
        });
    });
}



var $5fcd46e7a4c7b597$var$suit = (0, $9426e41dc741124c$export$d8556a2a8f973135)("ReverseHighlight");
function $5fcd46e7a4c7b597$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var _ref2 = (0, $7f5b3005d0607e06$export$2e2bcd8739ae039)(hit._highlightResult, attribute) || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value; // cx is not used, since it would be bundled as a dependency for Vue & Angular
    var className = $5fcd46e7a4c7b597$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $3b4f89083d3f02d4$export$2e2bcd8739ae039)((0, $e45d31768e45609d$export$2e2bcd8739ae039)((0, $4e31c65f190d3452$export$2e2bcd8739ae039)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $b85debef0921786f$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $b85debef0921786f$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



var $444305048c174754$var$suit = (0, $9426e41dc741124c$export$d8556a2a8f973135)("ReverseSnippet");
function $444305048c174754$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var _ref2 = (0, $7f5b3005d0607e06$export$2e2bcd8739ae039)(hit._snippetResult, attribute) || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value; // cx is not used, since it would be bundled as a dependency for Vue & Angular
    var className = $444305048c174754$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $3b4f89083d3f02d4$export$2e2bcd8739ae039)((0, $e45d31768e45609d$export$2e2bcd8739ae039)((0, $4e31c65f190d3452$export$2e2bcd8739ae039)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $b85debef0921786f$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $b85debef0921786f$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



var $a2695bd0541b6249$var$suit = (0, $9426e41dc741124c$export$d8556a2a8f973135)("Snippet");
function $a2695bd0541b6249$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var _ref2 = (0, $7f5b3005d0607e06$export$2e2bcd8739ae039)(hit._snippetResult, attribute) || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value; // cx is not used, since it would be bundled as a dependency for Vue & Angular
    var className = $a2695bd0541b6249$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $b85debef0921786f$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $b85debef0921786f$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}


function $5c2dddd5c5e753f8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5c2dddd5c5e753f8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5c2dddd5c5e753f8$var$ownKeys(Object(source), true).forEach(function(key) {
            $5c2dddd5c5e753f8$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5c2dddd5c5e753f8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5c2dddd5c5e753f8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5c2dddd5c5e753f8$export$2e2bcd8739ae039(_ref) {
    var numberLocale = _ref.numberLocale;
    return {
        formatNumber: function formatNumber(value, render) {
            return Number(render(value)).toLocaleString(numberLocale);
        },
        highlight: function highlight(options, render) {
            try {
                var highlightOptions = JSON.parse(options);
                return render((0, $9b3d6101ae46038b$export$2e2bcd8739ae039)($5c2dddd5c5e753f8$var$_objectSpread($5c2dddd5c5e753f8$var$_objectSpread({}, highlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe highlight helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseHighlight: function reverseHighlight(options, render) {
            try {
                var reverseHighlightOptions = JSON.parse(options);
                return render((0, $5fcd46e7a4c7b597$export$2e2bcd8739ae039)($5c2dddd5c5e753f8$var$_objectSpread($5c2dddd5c5e753f8$var$_objectSpread({}, reverseHighlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseHighlight helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        snippet: function snippet(options, render) {
            try {
                var snippetOptions = JSON.parse(options);
                return render((0, $a2695bd0541b6249$export$2e2bcd8739ae039)($5c2dddd5c5e753f8$var$_objectSpread($5c2dddd5c5e753f8$var$_objectSpread({}, snippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe snippet helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseSnippet: function reverseSnippet(options, render) {
            try {
                var reverseSnippetOptions = JSON.parse(options);
                return render((0, $444305048c174754$export$2e2bcd8739ae039)($5c2dddd5c5e753f8$var$_objectSpread($5c2dddd5c5e753f8$var$_objectSpread({}, reverseSnippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseSnippet helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        insights: function insights(options, render) {
            try {
                var _JSON$parse = JSON.parse(options), method = _JSON$parse.method, payload = _JSON$parse.payload;
                return render((0, $1df60413cb0e41e0$export$2e2bcd8739ae039)(method, $5c2dddd5c5e753f8$var$_objectSpread({
                    objectIDs: [
                        this.objectID
                    ]
                }, payload)));
            } catch (error) {
                throw new Error('\nThe insights helper expects a JSON object of the format:\n{ "method": "method-name", "payload": { "eventName": "name of the event" } }');
            }
        }
    };
}


var $c101129a938367ad$var$nextMicroTask = Promise.resolve();
var $c101129a938367ad$var$defer = function defer(callback) {
    var progress = null;
    var cancelled = false;
    var fn = function fn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (progress !== null) return;
        progress = $c101129a938367ad$var$nextMicroTask.then(function() {
            progress = null;
            if (cancelled) {
                cancelled = false;
                return;
            }
            callback.apply(void 0, args);
        });
    };
    fn.wait = function() {
        if (progress === null) throw new Error("The deferred function should be called before calling `wait()`");
        return progress;
    };
    fn.cancel = function() {
        if (progress === null) return;
        cancelled = true;
    };
    return fn;
};
var $c101129a938367ad$export$2e2bcd8739ae039 = $c101129a938367ad$var$defer;

function $0387abbfc54484f5$var$noop() {}
var $0387abbfc54484f5$export$2e2bcd8739ae039 = $0387abbfc54484f5$var$noop;


function $2c2fb11175687927$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2c2fb11175687927$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2c2fb11175687927$var$ownKeys(Object(source), true).forEach(function(key) {
            $2c2fb11175687927$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2c2fb11175687927$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2c2fb11175687927$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2c2fb11175687927$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2c2fb11175687927$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2c2fb11175687927$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2c2fb11175687927$var$getIndexStateWithoutConfigure(uiState) {
    var configure = uiState.configure, trackedUiState = $2c2fb11175687927$var$_objectWithoutProperties(uiState, [
        "configure"
    ]);
    return trackedUiState;
} // technically a URL could contain any key, since users provide it,
function $2c2fb11175687927$export$2e2bcd8739ae039() {
    return {
        stateToRoute: function stateToRoute(uiState) {
            return Object.keys(uiState).reduce(function(state, indexId) {
                return $2c2fb11175687927$var$_objectSpread($2c2fb11175687927$var$_objectSpread({}, state), {}, $2c2fb11175687927$var$_defineProperty({}, indexId, $2c2fb11175687927$var$getIndexStateWithoutConfigure(uiState[indexId])));
            }, {});
        },
        routeToState: function routeToState() {
            var routeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return Object.keys(routeState).reduce(function(state, indexId) {
                return $2c2fb11175687927$var$_objectSpread($2c2fb11175687927$var$_objectSpread({}, state), {}, $2c2fb11175687927$var$_defineProperty({}, indexId, $2c2fb11175687927$var$getIndexStateWithoutConfigure(routeState[indexId])));
            }, {});
        }
    };
}


var $1b1f5f76239e3564$exports = {};
"use strict";
var $69c10c524c780954$exports = {};
"use strict";
var $334d71f17e228cde$exports = {};
"use strict";
var $f4697d5648017da8$exports = {};
"use strict";
var $f4697d5648017da8$var$undefined1;
var $f4697d5648017da8$var$$SyntaxError = SyntaxError;
var $f4697d5648017da8$var$$Function = Function;
var $f4697d5648017da8$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $f4697d5648017da8$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $f4697d5648017da8$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $f4697d5648017da8$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($f4697d5648017da8$var$$gOPD) try {
    $f4697d5648017da8$var$$gOPD({}, "");
} catch (e) {
    $f4697d5648017da8$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $f4697d5648017da8$var$throwTypeError = function() {
    throw new $f4697d5648017da8$var$$TypeError();
};
var $f4697d5648017da8$var$ThrowTypeError = $f4697d5648017da8$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $f4697d5648017da8$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $f4697d5648017da8$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $f4697d5648017da8$var$throwTypeError;
        }
    }
}() : $f4697d5648017da8$var$throwTypeError;

var $f4697d5648017da8$var$hasSymbols = (parcelRequire("67d4r"))();
var $f4697d5648017da8$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $f4697d5648017da8$var$needsEval = {};
var $f4697d5648017da8$var$TypedArray = typeof Uint8Array === "undefined" ? undefined : $f4697d5648017da8$var$getProto(Uint8Array);
var $f4697d5648017da8$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $f4697d5648017da8$var$hasSymbols ? $f4697d5648017da8$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $f4697d5648017da8$var$needsEval,
    "%AsyncGenerator%": $f4697d5648017da8$var$needsEval,
    "%AsyncGeneratorFunction%": $f4697d5648017da8$var$needsEval,
    "%AsyncIteratorPrototype%": $f4697d5648017da8$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $f4697d5648017da8$var$$Function,
    "%GeneratorFunction%": $f4697d5648017da8$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $f4697d5648017da8$var$hasSymbols ? $f4697d5648017da8$var$getProto($f4697d5648017da8$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$f4697d5648017da8$var$hasSymbols ? undefined : $f4697d5648017da8$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$f4697d5648017da8$var$hasSymbols ? undefined : $f4697d5648017da8$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $f4697d5648017da8$var$hasSymbols ? $f4697d5648017da8$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $f4697d5648017da8$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $f4697d5648017da8$var$$SyntaxError,
    "%ThrowTypeError%": $f4697d5648017da8$var$ThrowTypeError,
    "%TypedArray%": $f4697d5648017da8$var$TypedArray,
    "%TypeError%": $f4697d5648017da8$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
var $f4697d5648017da8$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $f4697d5648017da8$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $f4697d5648017da8$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $f4697d5648017da8$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen) value = $f4697d5648017da8$var$getProto(gen.prototype);
    }
    $f4697d5648017da8$var$INTRINSICS[name] = value;
    return value;
};
var $f4697d5648017da8$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var $2e094a545a87f195$exports = {};
"use strict";
var $29f6be26c32c6dd3$exports = {};
"use strict";
/* eslint no-invalid-this: 1 */ var $29f6be26c32c6dd3$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $29f6be26c32c6dd3$var$slice = Array.prototype.slice;
var $29f6be26c32c6dd3$var$toStr = Object.prototype.toString;
var $29f6be26c32c6dd3$var$funcType = "[object Function]";
$29f6be26c32c6dd3$exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $29f6be26c32c6dd3$var$toStr.call(target) !== $29f6be26c32c6dd3$var$funcType) throw new TypeError($29f6be26c32c6dd3$var$ERROR_MESSAGE + target);
    var args = $29f6be26c32c6dd3$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($29f6be26c32c6dd3$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($29f6be26c32c6dd3$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};


$2e094a545a87f195$exports = Function.prototype.bind || $29f6be26c32c6dd3$exports;


var $c6a85e3184322681$exports = {};
"use strict";

$c6a85e3184322681$exports = $2e094a545a87f195$exports.call(Function.call, Object.prototype.hasOwnProperty);


var $f4697d5648017da8$var$$concat = $2e094a545a87f195$exports.call(Function.call, Array.prototype.concat);
var $f4697d5648017da8$var$$spliceApply = $2e094a545a87f195$exports.call(Function.apply, Array.prototype.splice);
var $f4697d5648017da8$var$$replace = $2e094a545a87f195$exports.call(Function.call, String.prototype.replace);
var $f4697d5648017da8$var$$strSlice = $2e094a545a87f195$exports.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $f4697d5648017da8$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $f4697d5648017da8$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $f4697d5648017da8$var$stringToPath = function stringToPath(string) {
    var first = $f4697d5648017da8$var$$strSlice(string, 0, 1);
    var last = $f4697d5648017da8$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $f4697d5648017da8$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $f4697d5648017da8$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $f4697d5648017da8$var$$replace(string, $f4697d5648017da8$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $f4697d5648017da8$var$$replace(subString, $f4697d5648017da8$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $f4697d5648017da8$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($c6a85e3184322681$exports($f4697d5648017da8$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $f4697d5648017da8$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($c6a85e3184322681$exports($f4697d5648017da8$var$INTRINSICS, intrinsicName)) {
        var value = $f4697d5648017da8$var$INTRINSICS[intrinsicName];
        if (value === $f4697d5648017da8$var$needsEval) value = $f4697d5648017da8$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $f4697d5648017da8$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $f4697d5648017da8$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
$f4697d5648017da8$exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $f4697d5648017da8$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $f4697d5648017da8$var$$TypeError('"allowMissing" argument must be a boolean');
    var parts = $f4697d5648017da8$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $f4697d5648017da8$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $f4697d5648017da8$var$$spliceApply(parts, $f4697d5648017da8$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $f4697d5648017da8$var$$strSlice(part, 0, 1);
        var last = $f4697d5648017da8$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $f4697d5648017da8$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($c6a85e3184322681$exports($f4697d5648017da8$var$INTRINSICS, intrinsicRealName)) value = $f4697d5648017da8$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $f4697d5648017da8$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($f4697d5648017da8$var$$gOPD && i + 1 >= parts.length) {
                var desc = $f4697d5648017da8$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $c6a85e3184322681$exports(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $f4697d5648017da8$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};


var $da5ebcf1ddae643d$exports = {};
"use strict";

var $cea4ee8c904e5d44$exports = {};
"use strict";


var $cea4ee8c904e5d44$var$$apply = $f4697d5648017da8$exports("%Function.prototype.apply%");
var $cea4ee8c904e5d44$var$$call = $f4697d5648017da8$exports("%Function.prototype.call%");
var $cea4ee8c904e5d44$var$$reflectApply = $f4697d5648017da8$exports("%Reflect.apply%", true) || $2e094a545a87f195$exports.call($cea4ee8c904e5d44$var$$call, $cea4ee8c904e5d44$var$$apply);
var $cea4ee8c904e5d44$var$$gOPD = $f4697d5648017da8$exports("%Object.getOwnPropertyDescriptor%", true);
var $cea4ee8c904e5d44$var$$defineProperty = $f4697d5648017da8$exports("%Object.defineProperty%", true);
var $cea4ee8c904e5d44$var$$max = $f4697d5648017da8$exports("%Math.max%");
if ($cea4ee8c904e5d44$var$$defineProperty) try {
    $cea4ee8c904e5d44$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $cea4ee8c904e5d44$var$$defineProperty = null;
}
$cea4ee8c904e5d44$exports = function callBind(originalFunction) {
    var func = $cea4ee8c904e5d44$var$$reflectApply($2e094a545a87f195$exports, $cea4ee8c904e5d44$var$$call, arguments);
    if ($cea4ee8c904e5d44$var$$gOPD && $cea4ee8c904e5d44$var$$defineProperty) {
        var desc = $cea4ee8c904e5d44$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $cea4ee8c904e5d44$var$$defineProperty(func, "length", {
            value: 1 + $cea4ee8c904e5d44$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $cea4ee8c904e5d44$var$applyBind = function applyBind() {
    return $cea4ee8c904e5d44$var$$reflectApply($2e094a545a87f195$exports, $cea4ee8c904e5d44$var$$apply, arguments);
};
if ($cea4ee8c904e5d44$var$$defineProperty) $cea4ee8c904e5d44$var$$defineProperty($cea4ee8c904e5d44$exports, "apply", {
    value: $cea4ee8c904e5d44$var$applyBind
});
else $cea4ee8c904e5d44$exports.apply = $cea4ee8c904e5d44$var$applyBind;


var $da5ebcf1ddae643d$var$$indexOf = $cea4ee8c904e5d44$exports($f4697d5648017da8$exports("String.prototype.indexOf"));
$da5ebcf1ddae643d$exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $f4697d5648017da8$exports(name, !!allowMissing);
    if (typeof intrinsic === "function" && $da5ebcf1ddae643d$var$$indexOf(name, ".prototype.") > -1) return $cea4ee8c904e5d44$exports(intrinsic);
    return intrinsic;
};


var $a76b6dece27907cd$exports = {};
var $a76b6dece27907cd$var$hasMap = typeof Map === "function" && Map.prototype;
var $a76b6dece27907cd$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a76b6dece27907cd$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $a76b6dece27907cd$var$mapSize = $a76b6dece27907cd$var$hasMap && $a76b6dece27907cd$var$mapSizeDescriptor && typeof $a76b6dece27907cd$var$mapSizeDescriptor.get === "function" ? $a76b6dece27907cd$var$mapSizeDescriptor.get : null;
var $a76b6dece27907cd$var$mapForEach = $a76b6dece27907cd$var$hasMap && Map.prototype.forEach;
var $a76b6dece27907cd$var$hasSet = typeof Set === "function" && Set.prototype;
var $a76b6dece27907cd$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a76b6dece27907cd$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $a76b6dece27907cd$var$setSize = $a76b6dece27907cd$var$hasSet && $a76b6dece27907cd$var$setSizeDescriptor && typeof $a76b6dece27907cd$var$setSizeDescriptor.get === "function" ? $a76b6dece27907cd$var$setSizeDescriptor.get : null;
var $a76b6dece27907cd$var$setForEach = $a76b6dece27907cd$var$hasSet && Set.prototype.forEach;
var $a76b6dece27907cd$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $a76b6dece27907cd$var$weakMapHas = $a76b6dece27907cd$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a76b6dece27907cd$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $a76b6dece27907cd$var$weakSetHas = $a76b6dece27907cd$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a76b6dece27907cd$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $a76b6dece27907cd$var$weakRefDeref = $a76b6dece27907cd$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a76b6dece27907cd$var$booleanValueOf = Boolean.prototype.valueOf;
var $a76b6dece27907cd$var$objectToString = Object.prototype.toString;
var $a76b6dece27907cd$var$functionToString = Function.prototype.toString;
var $a76b6dece27907cd$var$match = String.prototype.match;
var $a76b6dece27907cd$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $a76b6dece27907cd$var$gOPS = Object.getOwnPropertySymbols;
var $a76b6dece27907cd$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $a76b6dece27907cd$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a76b6dece27907cd$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
var $ab5e005cb90864fa$exports = {};
"use strict";


var $a76b6dece27907cd$require$inspectCustom = $ab5e005cb90864fa$exports.custom;
var $a76b6dece27907cd$var$inspectSymbol = $a76b6dece27907cd$require$inspectCustom && $a76b6dece27907cd$var$isSymbol($a76b6dece27907cd$require$inspectCustom) ? $a76b6dece27907cd$require$inspectCustom : null;
var $a76b6dece27907cd$var$toStringTag = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol" ? Symbol.toStringTag : null;
$a76b6dece27907cd$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a76b6dece27907cd$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a76b6dece27907cd$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a76b6dece27907cd$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean") throw new TypeError('option "customInspect", if provided, must be `true` or `false`');
    if ($a76b6dece27907cd$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $a76b6dece27907cd$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        return String(obj);
    }
    if (typeof obj === "bigint") return String(obj) + "n";
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $a76b6dece27907cd$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $a76b6dece27907cd$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($a76b6dece27907cd$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a76b6dece27907cd$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function") {
        var name = $a76b6dece27907cd$var$nameOf(obj);
        var keys = $a76b6dece27907cd$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + keys.join(", ") + " }" : "");
    }
    if ($a76b6dece27907cd$var$isSymbol(obj)) {
        var symString = $a76b6dece27907cd$var$symToString.call(obj);
        return typeof obj === "object" ? $a76b6dece27907cd$var$markBoxed(symString) : symString;
    }
    if ($a76b6dece27907cd$var$isElement(obj)) {
        var s = "<" + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $a76b6dece27907cd$var$wrapQuotes($a76b6dece27907cd$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + String(obj.nodeName).toLowerCase() + ">";
        return s;
    }
    if ($a76b6dece27907cd$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $a76b6dece27907cd$var$arrObjKeys(obj, inspect);
        if (indent && !$a76b6dece27907cd$var$singleLineValues(xs)) return "[" + $a76b6dece27907cd$var$indentedJoin(xs, indent) + "]";
        return "[ " + xs.join(", ") + " ]";
    }
    if ($a76b6dece27907cd$var$isError(obj)) {
        var parts = $a76b6dece27907cd$var$arrObjKeys(obj, inspect);
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + parts.join(", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($a76b6dece27907cd$var$inspectSymbol && typeof obj[$a76b6dece27907cd$var$inspectSymbol] === "function") return obj[$a76b6dece27907cd$var$inspectSymbol]();
        else if (typeof obj.inspect === "function") return obj.inspect();
    }
    if ($a76b6dece27907cd$var$isMap(obj)) {
        var mapParts = [];
        $a76b6dece27907cd$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $a76b6dece27907cd$var$collectionOf("Map", $a76b6dece27907cd$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a76b6dece27907cd$var$isSet(obj)) {
        var setParts = [];
        $a76b6dece27907cd$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a76b6dece27907cd$var$collectionOf("Set", $a76b6dece27907cd$var$setSize.call(obj), setParts, indent);
    }
    if ($a76b6dece27907cd$var$isWeakMap(obj)) return $a76b6dece27907cd$var$weakCollectionOf("WeakMap");
    if ($a76b6dece27907cd$var$isWeakSet(obj)) return $a76b6dece27907cd$var$weakCollectionOf("WeakSet");
    if ($a76b6dece27907cd$var$isWeakRef(obj)) return $a76b6dece27907cd$var$weakCollectionOf("WeakRef");
    if ($a76b6dece27907cd$var$isNumber(obj)) return $a76b6dece27907cd$var$markBoxed(inspect(Number(obj)));
    if ($a76b6dece27907cd$var$isBigInt(obj)) return $a76b6dece27907cd$var$markBoxed(inspect($a76b6dece27907cd$var$bigIntValueOf.call(obj)));
    if ($a76b6dece27907cd$var$isBoolean(obj)) return $a76b6dece27907cd$var$markBoxed($a76b6dece27907cd$var$booleanValueOf.call(obj));
    if ($a76b6dece27907cd$var$isString(obj)) return $a76b6dece27907cd$var$markBoxed(inspect(String(obj)));
    if (!$a76b6dece27907cd$var$isDate(obj) && !$a76b6dece27907cd$var$isRegExp(obj)) {
        var ys = $a76b6dece27907cd$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a76b6dece27907cd$var$gPO ? $a76b6dece27907cd$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $a76b6dece27907cd$var$toStringTag && Object(obj) === obj && $a76b6dece27907cd$var$toStringTag in obj ? $a76b6dece27907cd$var$toStr(obj).slice(8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + [].concat(stringTag || [], protoTag || []).join(": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $a76b6dece27907cd$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + ys.join(", ") + " }";
    }
    return String(obj);
};
function $a76b6dece27907cd$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $a76b6dece27907cd$var$quote(s) {
    return String(s).replace(/"/g, "&quot;");
}
function $a76b6dece27907cd$var$isArray(obj) {
    return $a76b6dece27907cd$var$toStr(obj) === "[object Array]" && (!$a76b6dece27907cd$var$toStringTag || !(typeof obj === "object" && $a76b6dece27907cd$var$toStringTag in obj));
}
function $a76b6dece27907cd$var$isDate(obj) {
    return $a76b6dece27907cd$var$toStr(obj) === "[object Date]" && (!$a76b6dece27907cd$var$toStringTag || !(typeof obj === "object" && $a76b6dece27907cd$var$toStringTag in obj));
}
function $a76b6dece27907cd$var$isRegExp(obj) {
    return $a76b6dece27907cd$var$toStr(obj) === "[object RegExp]" && (!$a76b6dece27907cd$var$toStringTag || !(typeof obj === "object" && $a76b6dece27907cd$var$toStringTag in obj));
}
function $a76b6dece27907cd$var$isError(obj) {
    return $a76b6dece27907cd$var$toStr(obj) === "[object Error]" && (!$a76b6dece27907cd$var$toStringTag || !(typeof obj === "object" && $a76b6dece27907cd$var$toStringTag in obj));
}
function $a76b6dece27907cd$var$isString(obj) {
    return $a76b6dece27907cd$var$toStr(obj) === "[object String]" && (!$a76b6dece27907cd$var$toStringTag || !(typeof obj === "object" && $a76b6dece27907cd$var$toStringTag in obj));
}
function $a76b6dece27907cd$var$isNumber(obj) {
    return $a76b6dece27907cd$var$toStr(obj) === "[object Number]" && (!$a76b6dece27907cd$var$toStringTag || !(typeof obj === "object" && $a76b6dece27907cd$var$toStringTag in obj));
}
function $a76b6dece27907cd$var$isBoolean(obj) {
    return $a76b6dece27907cd$var$toStr(obj) === "[object Boolean]" && (!$a76b6dece27907cd$var$toStringTag || !(typeof obj === "object" && $a76b6dece27907cd$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a76b6dece27907cd$var$isSymbol(obj) {
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$a76b6dece27907cd$var$symToString) return false;
    try {
        $a76b6dece27907cd$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a76b6dece27907cd$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$a76b6dece27907cd$var$bigIntValueOf) return false;
    try {
        $a76b6dece27907cd$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a76b6dece27907cd$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a76b6dece27907cd$var$has(obj, key) {
    return $a76b6dece27907cd$var$hasOwn.call(obj, key);
}
function $a76b6dece27907cd$var$toStr(obj) {
    return $a76b6dece27907cd$var$objectToString.call(obj);
}
function $a76b6dece27907cd$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a76b6dece27907cd$var$match.call($a76b6dece27907cd$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a76b6dece27907cd$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a76b6dece27907cd$var$isMap(x) {
    if (!$a76b6dece27907cd$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $a76b6dece27907cd$var$mapSize.call(x);
        try {
            $a76b6dece27907cd$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a76b6dece27907cd$var$isWeakMap(x) {
    if (!$a76b6dece27907cd$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $a76b6dece27907cd$var$weakMapHas.call(x, $a76b6dece27907cd$var$weakMapHas);
        try {
            $a76b6dece27907cd$var$weakSetHas.call(x, $a76b6dece27907cd$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a76b6dece27907cd$var$isWeakRef(x) {
    if (!$a76b6dece27907cd$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $a76b6dece27907cd$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a76b6dece27907cd$var$isSet(x) {
    if (!$a76b6dece27907cd$var$setSize || !x || typeof x !== "object") return false;
    try {
        $a76b6dece27907cd$var$setSize.call(x);
        try {
            $a76b6dece27907cd$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a76b6dece27907cd$var$isWeakSet(x) {
    if (!$a76b6dece27907cd$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $a76b6dece27907cd$var$weakSetHas.call(x, $a76b6dece27907cd$var$weakSetHas);
        try {
            $a76b6dece27907cd$var$weakMapHas.call(x, $a76b6dece27907cd$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a76b6dece27907cd$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $a76b6dece27907cd$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $a76b6dece27907cd$var$inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, "\\$1").replace(/[\x00-\x1f]/g, $a76b6dece27907cd$var$lowbyte);
    return $a76b6dece27907cd$var$wrapQuotes(s, "single", opts);
}
function $a76b6dece27907cd$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + n.toString(16).toUpperCase();
}
function $a76b6dece27907cd$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $a76b6dece27907cd$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $a76b6dece27907cd$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a76b6dece27907cd$var$indentedJoin(entries, indent) : entries.join(", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $a76b6dece27907cd$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a76b6dece27907cd$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $a76b6dece27907cd$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = Array(opts.indent + 1).join(" ");
    else return null;
    return {
        base: baseIndent,
        prev: Array(depth + 1).join(baseIndent)
    };
}
function $a76b6dece27907cd$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + xs.join("," + lineJoiner) + "\n" + indent.prev;
}
function $a76b6dece27907cd$var$arrObjKeys(obj, inspect) {
    var isArr = $a76b6dece27907cd$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a76b6dece27907cd$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    for(var key in obj){
        if (!$a76b6dece27907cd$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (/[^\w$]/.test(key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $a76b6dece27907cd$var$gOPS === "function") {
        var syms = $a76b6dece27907cd$var$gOPS(obj);
        for(var j = 0; j < syms.length; j++)if ($a76b6dece27907cd$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}


var $334d71f17e228cde$var$$TypeError = $f4697d5648017da8$exports("%TypeError%");
var $334d71f17e228cde$var$$WeakMap = $f4697d5648017da8$exports("%WeakMap%", true);
var $334d71f17e228cde$var$$Map = $f4697d5648017da8$exports("%Map%", true);
var $334d71f17e228cde$var$$weakMapGet = $da5ebcf1ddae643d$exports("WeakMap.prototype.get", true);
var $334d71f17e228cde$var$$weakMapSet = $da5ebcf1ddae643d$exports("WeakMap.prototype.set", true);
var $334d71f17e228cde$var$$weakMapHas = $da5ebcf1ddae643d$exports("WeakMap.prototype.has", true);
var $334d71f17e228cde$var$$mapGet = $da5ebcf1ddae643d$exports("Map.prototype.get", true);
var $334d71f17e228cde$var$$mapSet = $da5ebcf1ddae643d$exports("Map.prototype.set", true);
var $334d71f17e228cde$var$$mapHas = $da5ebcf1ddae643d$exports("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var $334d71f17e228cde$var$listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var $334d71f17e228cde$var$listGet = function(objects, key) {
    var node = $334d71f17e228cde$var$listGetNode(objects, key);
    return node && node.value;
};
var $334d71f17e228cde$var$listSet = function(objects, key, value) {
    var node = $334d71f17e228cde$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var $334d71f17e228cde$var$listHas = function(objects, key) {
    return !!$334d71f17e228cde$var$listGetNode(objects, key);
};
$334d71f17e228cde$exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $334d71f17e228cde$var$$TypeError("Side channel does not contain " + $a76b6dece27907cd$exports(key));
        },
        get: function(key) {
            if ($334d71f17e228cde$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $334d71f17e228cde$var$$weakMapGet($wm, key);
            } else if ($334d71f17e228cde$var$$Map) {
                if ($m) return $334d71f17e228cde$var$$mapGet($m, key);
            } else {
                if ($o) return $334d71f17e228cde$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($334d71f17e228cde$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $334d71f17e228cde$var$$weakMapHas($wm, key);
            } else if ($334d71f17e228cde$var$$Map) {
                if ($m) return $334d71f17e228cde$var$$mapHas($m, key);
            } else {
                if ($o) return $334d71f17e228cde$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($334d71f17e228cde$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $334d71f17e228cde$var$$WeakMap();
                $334d71f17e228cde$var$$weakMapSet($wm, key, value);
            } else if ($334d71f17e228cde$var$$Map) {
                if (!$m) $m = new $334d71f17e228cde$var$$Map();
                $334d71f17e228cde$var$$mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                $334d71f17e228cde$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};


var $0f3cbf68121fada0$exports = {};
"use strict";
var $226393a9e9b6c9c1$exports = {};
"use strict";
var $226393a9e9b6c9c1$var$replace = String.prototype.replace;
var $226393a9e9b6c9c1$var$percentTwenties = /%20/g;
var $226393a9e9b6c9c1$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$226393a9e9b6c9c1$exports = {
    "default": $226393a9e9b6c9c1$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $226393a9e9b6c9c1$var$replace.call(value, $226393a9e9b6c9c1$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $226393a9e9b6c9c1$var$Format.RFC1738,
    RFC3986: $226393a9e9b6c9c1$var$Format.RFC3986
};


var $0f3cbf68121fada0$var$has = Object.prototype.hasOwnProperty;
var $0f3cbf68121fada0$var$isArray = Array.isArray;
var $0f3cbf68121fada0$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $0f3cbf68121fada0$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($0f3cbf68121fada0$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $0f3cbf68121fada0$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $0f3cbf68121fada0$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($0f3cbf68121fada0$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$0f3cbf68121fada0$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($0f3cbf68121fada0$var$isArray(target) && !$0f3cbf68121fada0$var$isArray(source)) mergeTarget = $0f3cbf68121fada0$var$arrayToObject(target, options);
    if ($0f3cbf68121fada0$var$isArray(target) && $0f3cbf68121fada0$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($0f3cbf68121fada0$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($0f3cbf68121fada0$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $0f3cbf68121fada0$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $0f3cbf68121fada0$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $0f3cbf68121fada0$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $226393a9e9b6c9c1$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $0f3cbf68121fada0$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($0f3cbf68121fada0$var$hexTable[0xC0 | c >> 6] + $0f3cbf68121fada0$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($0f3cbf68121fada0$var$hexTable[0xE0 | c >> 12] + $0f3cbf68121fada0$var$hexTable[0x80 | c >> 6 & 0x3F] + $0f3cbf68121fada0$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        out += $0f3cbf68121fada0$var$hexTable[0xF0 | c >> 18] + $0f3cbf68121fada0$var$hexTable[0x80 | c >> 12 & 0x3F] + $0f3cbf68121fada0$var$hexTable[0x80 | c >> 6 & 0x3F] + $0f3cbf68121fada0$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $0f3cbf68121fada0$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $0f3cbf68121fada0$var$compactQueue(queue);
    return value;
};
var $0f3cbf68121fada0$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $0f3cbf68121fada0$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $0f3cbf68121fada0$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $0f3cbf68121fada0$var$maybeMap = function maybeMap(val, fn) {
    if ($0f3cbf68121fada0$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$0f3cbf68121fada0$exports = {
    arrayToObject: $0f3cbf68121fada0$var$arrayToObject,
    assign: $0f3cbf68121fada0$var$assign,
    combine: $0f3cbf68121fada0$var$combine,
    compact: $0f3cbf68121fada0$var$compact,
    decode: $0f3cbf68121fada0$var$decode,
    encode: $0f3cbf68121fada0$var$encode,
    isBuffer: $0f3cbf68121fada0$var$isBuffer,
    isRegExp: $0f3cbf68121fada0$var$isRegExp,
    maybeMap: $0f3cbf68121fada0$var$maybeMap,
    merge: $0f3cbf68121fada0$var$merge
};



var $69c10c524c780954$var$has = Object.prototype.hasOwnProperty;
var $69c10c524c780954$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $69c10c524c780954$var$isArray = Array.isArray;
var $69c10c524c780954$var$push = Array.prototype.push;
var $69c10c524c780954$var$pushToArray = function(arr, valueOrArray) {
    $69c10c524c780954$var$push.apply(arr, $69c10c524c780954$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $69c10c524c780954$var$toISO = Date.prototype.toISOString;
var $69c10c524c780954$var$defaultFormat = $226393a9e9b6c9c1$exports.default;
var $69c10c524c780954$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $0f3cbf68121fada0$exports.encode,
    encodeValuesOnly: false,
    format: $69c10c524c780954$var$defaultFormat,
    formatter: $226393a9e9b6c9c1$exports.formatters[$69c10c524c780954$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $69c10c524c780954$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $69c10c524c780954$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $69c10c524c780954$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    if (sideChannel.has(object)) throw new RangeError("Cyclic object value");
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $69c10c524c780954$var$isArray(obj)) obj = $0f3cbf68121fada0$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $69c10c524c780954$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($69c10c524c780954$var$isNonNullishPrimitive(obj) || $0f3cbf68121fada0$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $69c10c524c780954$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $69c10c524c780954$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $69c10c524c780954$var$isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : undefined
        }
    ];
    else if ($69c10c524c780954$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = typeof key === "object" && key.value !== undefined ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $69c10c524c780954$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, true);
        var valueSideChannel = $334d71f17e228cde$exports();
        $69c10c524c780954$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $69c10c524c780954$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $69c10c524c780954$var$defaults;
    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $69c10c524c780954$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $226393a9e9b6c9c1$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$69c10c524c780954$var$has.call($226393a9e9b6c9c1$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $226393a9e9b6c9c1$exports.formatters[format];
    var filter = $69c10c524c780954$var$defaults.filter;
    if (typeof opts.filter === "function" || $69c10c524c780954$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $69c10c524c780954$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $69c10c524c780954$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $69c10c524c780954$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $69c10c524c780954$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $69c10c524c780954$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $69c10c524c780954$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $69c10c524c780954$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $69c10c524c780954$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $69c10c524c780954$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $69c10c524c780954$var$defaults.strictNullHandling
    };
};
$69c10c524c780954$exports = function(object, opts) {
    var obj = object;
    var options = $69c10c524c780954$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($69c10c524c780954$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $69c10c524c780954$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $69c10c524c780954$var$arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $334d71f17e228cde$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $69c10c524c780954$var$pushToArray(keys, $69c10c524c780954$var$stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $5388d7918b368cb4$exports = {};
"use strict";

var $5388d7918b368cb4$var$has = Object.prototype.hasOwnProperty;
var $5388d7918b368cb4$var$isArray = Array.isArray;
var $5388d7918b368cb4$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $0f3cbf68121fada0$exports.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $5388d7918b368cb4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $5388d7918b368cb4$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $5388d7918b368cb4$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $5388d7918b368cb4$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $5388d7918b368cb4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $5388d7918b368cb4$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $5388d7918b368cb4$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $5388d7918b368cb4$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $5388d7918b368cb4$var$defaults.decoder, charset, "key");
            val = $0f3cbf68121fada0$exports.maybeMap($5388d7918b368cb4$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $5388d7918b368cb4$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $5388d7918b368cb4$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $5388d7918b368cb4$var$isArray(val) ? [
            val
        ] : val;
        if ($5388d7918b368cb4$var$has.call(obj, key)) obj[key] = $0f3cbf68121fada0$exports.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $5388d7918b368cb4$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $5388d7918b368cb4$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $5388d7918b368cb4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $5388d7918b368cb4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $5388d7918b368cb4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $5388d7918b368cb4$var$parseObject(keys, val, options, valuesParsed);
};
var $5388d7918b368cb4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $5388d7918b368cb4$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $5388d7918b368cb4$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $5388d7918b368cb4$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $5388d7918b368cb4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $5388d7918b368cb4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $5388d7918b368cb4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $5388d7918b368cb4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $5388d7918b368cb4$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $5388d7918b368cb4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $0f3cbf68121fada0$exports.isRegExp(opts.delimiter) ? opts.delimiter : $5388d7918b368cb4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $5388d7918b368cb4$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $5388d7918b368cb4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $5388d7918b368cb4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $5388d7918b368cb4$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $5388d7918b368cb4$var$defaults.strictNullHandling
    };
};
$5388d7918b368cb4$exports = function(str, opts) {
    var options = $5388d7918b368cb4$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $5388d7918b368cb4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $5388d7918b368cb4$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $0f3cbf68121fada0$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $0f3cbf68121fada0$exports.compact(obj);
};



$1b1f5f76239e3564$exports = {
    formats: $226393a9e9b6c9c1$exports,
    parse: $5388d7918b368cb4$exports,
    stringify: $69c10c524c780954$exports
};


function $51c556920f3ef05d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $51c556920f3ef05d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $51c556920f3ef05d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $51c556920f3ef05d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $51c556920f3ef05d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $51c556920f3ef05d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $51c556920f3ef05d$var$defaultCreateURL = function defaultCreateURL(_ref) {
    var qsModule = _ref.qsModule, routeState = _ref.routeState, location = _ref.location;
    var protocol = location.protocol, hostname = location.hostname, _location$port = location.port, port = _location$port === void 0 ? "" : _location$port, pathname = location.pathname, hash = location.hash;
    var queryString = qsModule.stringify(routeState);
    var portWithPrefix = port === "" ? "" : ":".concat(port); // IE <= 11 has no proper `location.origin` so we cannot rely on it.
    if (!queryString) return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname).concat(hash);
    return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname, "?").concat(queryString).concat(hash);
};
var $51c556920f3ef05d$var$defaultParseURL = function defaultParseURL(_ref2) {
    var qsModule = _ref2.qsModule, location = _ref2.location;
    // `qs` by default converts arrays with more than 20 items to an object.
    // We want to avoid this because the data structure manipulated can therefore vary.
    // Setting the limit to `100` seems a good number because the engine's default is 100
    // (it can go up to 1000 but it is very unlikely to select more than 100 items in the UI).
    //
    // Using an `arrayLimit` of `n` allows `n + 1` items.
    //
    // See:
    //   - https://github.com/ljharb/qs#parsing-arrays
    //   - https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/
    return qsModule.parse(location.search.slice(1), {
        arrayLimit: 99
    });
};
var $51c556920f3ef05d$var$setWindowTitle = function setWindowTitle(title) {
    if (title) window.document.title = title;
};
var $51c556920f3ef05d$var$BrowserHistory = /*#__PURE__*/ function() {
    /**
   * Initializes a new storage provider that syncs the search state to the URL
   * using web APIs (`window.location.pushState` and `onpopstate` event).
   */ function BrowserHistory() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, windowTitle = _ref3.windowTitle, _ref3$writeDelay = _ref3.writeDelay, writeDelay = _ref3$writeDelay === void 0 ? 400 : _ref3$writeDelay, _ref3$createURL = _ref3.createURL, createURL = _ref3$createURL === void 0 ? $51c556920f3ef05d$var$defaultCreateURL : _ref3$createURL, _ref3$parseURL = _ref3.parseURL, parseURL = _ref3$parseURL === void 0 ? $51c556920f3ef05d$var$defaultParseURL : _ref3$parseURL;
        $51c556920f3ef05d$var$_classCallCheck(this, BrowserHistory);
        $51c556920f3ef05d$var$_defineProperty(this, "windowTitle", void 0);
        $51c556920f3ef05d$var$_defineProperty(this, "writeDelay", void 0);
        $51c556920f3ef05d$var$_defineProperty(this, "_createURL", void 0);
        $51c556920f3ef05d$var$_defineProperty(this, "parseURL", void 0);
        $51c556920f3ef05d$var$_defineProperty(this, "writeTimer", void 0);
        this.windowTitle = windowTitle;
        this.writeTimer = undefined;
        this.writeDelay = writeDelay;
        this._createURL = createURL;
        this.parseURL = parseURL;
        var title = this.windowTitle && this.windowTitle(this.read());
        $51c556920f3ef05d$var$setWindowTitle(title);
    }
    /**
   * Reads the URL and returns a syncable UI search state.
   */ $51c556920f3ef05d$var$_createClass(BrowserHistory, [
        {
            key: "read",
            value: function read() {
                return this.parseURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($1b1f5f76239e3564$exports))),
                    location: window.location
                });
            }
        },
        {
            key: "write",
            value: function write(routeState) {
                var _this = this;
                var url = this.createURL(routeState);
                var title = this.windowTitle && this.windowTitle(routeState);
                if (this.writeTimer) window.clearTimeout(this.writeTimer);
                this.writeTimer = window.setTimeout(function() {
                    $51c556920f3ef05d$var$setWindowTitle(title);
                    window.history.pushState(routeState, title || "", url);
                    _this.writeTimer = undefined;
                }, this.writeDelay);
            }
        },
        {
            key: "onUpdate",
            value: function onUpdate(callback) {
                var _this2 = this;
                this._onPopState = function(event) {
                    if (_this2.writeTimer) {
                        window.clearTimeout(_this2.writeTimer);
                        _this2.writeTimer = undefined;
                    }
                    var routeState = event.state; // At initial load, the state is read from the URL without update.
                    // Therefore the state object is not available.
                    // In this case, we fallback and read the URL.
                    if (!routeState) callback(_this2.read());
                    else callback(routeState);
                };
                window.addEventListener("popstate", this._onPopState);
            }
        },
        {
            key: "createURL",
            value: function createURL(routeState) {
                return this._createURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($1b1f5f76239e3564$exports))),
                    routeState: routeState,
                    location: window.location
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._onPopState) window.removeEventListener("popstate", this._onPopState);
                if (this.writeTimer) window.clearTimeout(this.writeTimer);
                this.write({});
            }
        }
    ]);
    return BrowserHistory;
}();
function $51c556920f3ef05d$export$2e2bcd8739ae039(props) {
    return new $51c556920f3ef05d$var$BrowserHistory(props);
}


function $3d3b2841e1d9e29b$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $3d3b2841e1d9e29b$var$isEqual(first, second) {
    if (first === second) return true;
    if ($3d3b2841e1d9e29b$var$isPrimitive(first) || $3d3b2841e1d9e29b$var$isPrimitive(second) || typeof first === "function" || typeof second === "function") return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$3d3b2841e1d9e29b$var$isEqual(first[key], second[key])) return false;
    }
    return true;
}
var $3d3b2841e1d9e29b$export$2e2bcd8739ae039 = $3d3b2841e1d9e29b$var$isEqual;


function $56a7d1ba506dccc3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $56a7d1ba506dccc3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $56a7d1ba506dccc3$var$ownKeys(Object(source), true).forEach(function(key) {
            $56a7d1ba506dccc3$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $56a7d1ba506dccc3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $56a7d1ba506dccc3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $56a7d1ba506dccc3$export$1fe5128387816284 = function createRouterMiddleware() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$router = props.router, router = _props$router === void 0 ? (0, $51c556920f3ef05d$export$2e2bcd8739ae039)() : _props$router, _props$stateMapping = props.stateMapping, stateMapping = _props$stateMapping === void 0 ? (0, $2c2fb11175687927$export$2e2bcd8739ae039)() : _props$stateMapping;
    return function(_ref) {
        var instantSearchInstance = _ref.instantSearchInstance;
        function topLevelCreateURL(nextState) {
            var uiState = Object.keys(nextState).reduce(function(acc, indexId) {
                return $56a7d1ba506dccc3$var$_objectSpread($56a7d1ba506dccc3$var$_objectSpread({}, acc), {}, $56a7d1ba506dccc3$var$_defineProperty({}, indexId, nextState[indexId]));
            }, instantSearchInstance.mainIndex.getWidgetUiState({}));
            var route = stateMapping.stateToRoute(uiState);
            return router.createURL(route);
        }
        instantSearchInstance._createURL = topLevelCreateURL;
        instantSearchInstance._initialUiState = $56a7d1ba506dccc3$var$_objectSpread($56a7d1ba506dccc3$var$_objectSpread({}, instantSearchInstance._initialUiState), stateMapping.routeToState(router.read()));
        var lastRouteState = undefined;
        return {
            onStateChange: function onStateChange(_ref2) {
                var uiState = _ref2.uiState;
                var routeState = stateMapping.stateToRoute(uiState);
                if (lastRouteState === undefined || !(0, $3d3b2841e1d9e29b$export$2e2bcd8739ae039)(lastRouteState, routeState)) {
                    router.write(routeState);
                    lastRouteState = routeState;
                }
            },
            subscribe: function subscribe() {
                router.onUpdate(function(route) {
                    instantSearchInstance.setUiState(stateMapping.routeToState(route));
                });
            },
            unsubscribe: function unsubscribe() {
                router.dispose();
            }
        };
    };
};


function $7fc9a9e6bd387423$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7fc9a9e6bd387423$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7fc9a9e6bd387423$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7fc9a9e6bd387423$var$_typeof(obj);
}
function $7fc9a9e6bd387423$var$extractPayload(widgets, instantSearchInstance, payload) {
    var parent = instantSearchInstance.mainIndex;
    var initOptions = {
        instantSearchInstance: instantSearchInstance,
        parent: parent,
        scopedResults: [],
        state: parent.getHelper().state,
        helper: parent.getHelper(),
        createURL: parent.createURL,
        uiState: instantSearchInstance._initialUiState,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        searchMetadata: {
            isSearchStalled: instantSearchInstance._isSearchStalled
        }
    };
    widgets.forEach(function(widget) {
        var widgetParams = {};
        if (widget.getWidgetRenderState) {
            var renderState = widget.getWidgetRenderState(initOptions);
            if (renderState && $7fc9a9e6bd387423$var$_typeof(renderState.widgetParams) === "object") widgetParams = renderState.widgetParams;
        } // since we destructure in all widgets, the parameters with defaults are set to "undefined"
        var params = Object.keys(widgetParams).filter(function(key) {
            return widgetParams[key] !== undefined;
        });
        payload.widgets.push({
            type: widget.$$type,
            widgetType: widget.$$widgetType,
            params: params
        });
        if (widget.$$type === "ais.index") $7fc9a9e6bd387423$var$extractPayload(widget.getWidgets(), instantSearchInstance, payload);
    });
}
function $7fc9a9e6bd387423$export$4b4254890acf93e7() {
    return typeof window !== "undefined" && window.navigator.userAgent.indexOf("Algolia Crawler") > -1;
}
function $7fc9a9e6bd387423$export$8ee9d2447935ed96() {
    return function(_ref) {
        var instantSearchInstance = _ref.instantSearchInstance;
        var payload = {
            widgets: []
        };
        var payloadContainer = document.createElement("meta");
        var refNode = document.querySelector("head");
        payloadContainer.name = "instantsearch:widgets";
        return {
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                // using setTimeout here to delay extraction until widgets have been added in a tick (e.g. Vue)
                setTimeout(function() {
                    var client = instantSearchInstance.client;
                    payload.ua = client.transporter && client.transporter.userAgent ? client.transporter.userAgent.value : client._ua;
                    $7fc9a9e6bd387423$var$extractPayload(instantSearchInstance.mainIndex.getWidgets(), instantSearchInstance, payload);
                    payloadContainer.content = JSON.stringify(payload);
                    refNode.appendChild(payloadContainer);
                }, 0);
            },
            unsubscribe: function unsubscribe() {
                payloadContainer.remove();
            }
        };
    };
}


function $85025f93a09618fe$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $85025f93a09618fe$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $85025f93a09618fe$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $85025f93a09618fe$var$_typeof(obj);
}
function $85025f93a09618fe$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $85025f93a09618fe$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $85025f93a09618fe$var$ownKeys(Object(source), true).forEach(function(key) {
            $85025f93a09618fe$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $85025f93a09618fe$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $85025f93a09618fe$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $85025f93a09618fe$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $85025f93a09618fe$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $85025f93a09618fe$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $85025f93a09618fe$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $85025f93a09618fe$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $85025f93a09618fe$var$_setPrototypeOf(subClass, superClass);
}
function $85025f93a09618fe$var$_setPrototypeOf(o, p) {
    $85025f93a09618fe$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $85025f93a09618fe$var$_setPrototypeOf(o, p);
}
function $85025f93a09618fe$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $85025f93a09618fe$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $85025f93a09618fe$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $85025f93a09618fe$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $85025f93a09618fe$var$_possibleConstructorReturn(this, result);
    };
}
function $85025f93a09618fe$var$_possibleConstructorReturn(self, call) {
    if (call && ($85025f93a09618fe$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $85025f93a09618fe$var$_assertThisInitialized(self);
}
function $85025f93a09618fe$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $85025f93a09618fe$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $85025f93a09618fe$var$_getPrototypeOf(o) {
    $85025f93a09618fe$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $85025f93a09618fe$var$_getPrototypeOf(o);
}
function $85025f93a09618fe$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $85025f93a09618fe$var$withUsage = (0, $222bd44957f3ca8f$export$2fde5bffc340821e)({
    name: "instantsearch"
});
function $85025f93a09618fe$var$defaultCreateURL() {
    return "#";
}
/**
 * Global options for an InstantSearch instance.
 */ /**
 * The actual implementation of the InstantSearch. This is
 * created using the `instantsearch` factory function.
 * It emits the 'render' event every time a search is done
 */ var $85025f93a09618fe$var$InstantSearch = /*#__PURE__*/ function(_EventEmitter) {
    $85025f93a09618fe$var$_inherits(InstantSearch, _EventEmitter);
    var _super = $85025f93a09618fe$var$_createSuper(InstantSearch);
    function InstantSearch(options) {
        var _this;
        $85025f93a09618fe$var$_classCallCheck(this, InstantSearch);
        _this = _super.call(this);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "client", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "indexName", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "insightsClient", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "onStateChange", null);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "helper", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "mainHelper", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "mainIndex", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "started", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "templatesConfig", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "renderState", {});
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "_stalledSearchDelay", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "_searchStalledTimer", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "_isSearchStalled", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "_initialUiState", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "_createURL", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "_searchFunction", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "_mainHelperSearch", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "middleware", []);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "sendEventToInsights", void 0);
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "scheduleSearch", (0, $c101129a938367ad$export$2e2bcd8739ae039)(function() {
            if (_this.started) _this.mainHelper.search();
        }));
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "scheduleRender", (0, $c101129a938367ad$export$2e2bcd8739ae039)(function() {
            if (!_this.mainHelper.hasPendingRequests()) {
                clearTimeout(_this._searchStalledTimer);
                _this._searchStalledTimer = null;
                _this._isSearchStalled = false;
            }
            _this.mainIndex.render({
                instantSearchInstance: $85025f93a09618fe$var$_assertThisInitialized(_this)
            });
            _this.emit("render");
        }));
        $85025f93a09618fe$var$_defineProperty($85025f93a09618fe$var$_assertThisInitialized(_this), "onInternalStateChange", (0, $c101129a938367ad$export$2e2bcd8739ae039)(function() {
            var nextUiState = _this.mainIndex.getWidgetUiState({});
            _this.middleware.forEach(function(_ref) {
                var instance = _ref.instance;
                instance.onStateChange({
                    uiState: nextUiState
                });
            });
        }));
        var _options$indexName = options.indexName, indexName = _options$indexName === void 0 ? null : _options$indexName, numberLocale = options.numberLocale, _options$initialUiSta = options.initialUiState, initialUiState = _options$initialUiSta === void 0 ? {} : _options$initialUiSta, _options$routing = options.routing, routing = _options$routing === void 0 ? null : _options$routing, searchFunction = options.searchFunction, _options$stalledSearc = options.stalledSearchDelay, stalledSearchDelay = _options$stalledSearc === void 0 ? 200 : _options$stalledSearc, _options$searchClient = options.searchClient, searchClient = _options$searchClient === void 0 ? null : _options$searchClient, _options$insightsClie = options.insightsClient, insightsClient = _options$insightsClie === void 0 ? null : _options$insightsClie, _options$onStateChang = options.onStateChange, onStateChange = _options$onStateChang === void 0 ? null : _options$onStateChang;
        if (indexName === null) throw new Error($85025f93a09618fe$var$withUsage("The `indexName` option is required."));
        if (searchClient === null) throw new Error($85025f93a09618fe$var$withUsage("The `searchClient` option is required."));
        if (typeof searchClient.search !== "function") throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
        if (typeof searchClient.addAlgoliaAgent === "function") searchClient.addAlgoliaAgent("instantsearch.js (".concat((0, $4fbe7e4363b97af8$export$2e2bcd8739ae039), ")"));
        if (insightsClient && typeof insightsClient !== "function") throw new Error($85025f93a09618fe$var$withUsage("The `insightsClient` option should be a function."));
        _this.client = searchClient;
        _this.insightsClient = insightsClient;
        _this.indexName = indexName;
        _this.helper = null;
        _this.mainHelper = null;
        _this.mainIndex = (0, $6147dba0b024d6d3$export$2e2bcd8739ae039)({
            indexName: indexName
        });
        _this.onStateChange = onStateChange;
        _this.started = false;
        _this.templatesConfig = {
            helpers: (0, $5c2dddd5c5e753f8$export$2e2bcd8739ae039)({
                numberLocale: numberLocale
            }),
            compileOptions: {}
        };
        _this._stalledSearchDelay = stalledSearchDelay;
        _this._searchStalledTimer = null;
        _this._isSearchStalled = false;
        _this._createURL = $85025f93a09618fe$var$defaultCreateURL;
        _this._initialUiState = initialUiState;
        if (searchFunction) _this._searchFunction = searchFunction;
        _this.sendEventToInsights = (0, $0387abbfc54484f5$export$2e2bcd8739ae039);
        if (routing) {
            var routerOptions = typeof routing === "boolean" ? undefined : routing;
            _this.use((0, $56a7d1ba506dccc3$export$1fe5128387816284)(routerOptions));
        }
        if ((0, $7fc9a9e6bd387423$export$4b4254890acf93e7)()) _this.use((0, $7fc9a9e6bd387423$export$8ee9d2447935ed96)());
        return _this;
    }
    /**
   * Hooks a middleware into the InstantSearch lifecycle.
   */ $85025f93a09618fe$var$_createClass(InstantSearch, [
        {
            key: "use",
            value: function use() {
                var _this2 = this;
                for(var _len = arguments.length, middleware = new Array(_len), _key = 0; _key < _len; _key++)middleware[_key] = arguments[_key];
                var newMiddlewareList = middleware.map(function(fn) {
                    var newMiddleware = $85025f93a09618fe$var$_objectSpread({
                        subscribe: (0, $0387abbfc54484f5$export$2e2bcd8739ae039),
                        unsubscribe: (0, $0387abbfc54484f5$export$2e2bcd8739ae039),
                        onStateChange: (0, $0387abbfc54484f5$export$2e2bcd8739ae039)
                    }, fn({
                        instantSearchInstance: _this2
                    }));
                    _this2.middleware.push({
                        creator: fn,
                        instance: newMiddleware
                    });
                    return newMiddleware;
                }); // If the instance has already started, we directly subscribe the
                // middleware so they're notified of changes.
                if (this.started) newMiddlewareList.forEach(function(m) {
                    m.subscribe();
                });
                return this;
            }
        },
        {
            key: "unuse",
            value: function unuse() {
                for(var _len2 = arguments.length, middlewareToUnuse = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)middlewareToUnuse[_key2] = arguments[_key2];
                this.middleware.filter(function(m) {
                    return middlewareToUnuse.includes(m.creator);
                }).forEach(function(m) {
                    return m.instance.unsubscribe();
                });
                this.middleware = this.middleware.filter(function(m) {
                    return !middlewareToUnuse.includes(m.creator);
                });
                return this;
            } // @major we shipped with EXPERIMENTAL_use, but have changed that to just `use` now
        },
        {
            key: "EXPERIMENTAL_use",
            value: function EXPERIMENTAL_use() {
                return this.use.apply(this, arguments);
            }
        },
        {
            key: "addWidget",
            value: function addWidget(widget) {
                return this.addWidgets([
                    widget
                ]);
            }
        },
        {
            key: "addWidgets",
            value: function addWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($85025f93a09618fe$var$withUsage("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.init !== "function" && typeof widget.render !== "function";
                })) throw new Error($85025f93a09618fe$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
                this.mainIndex.addWidgets(widgets);
                return this;
            }
        },
        {
            key: "removeWidget",
            value: function removeWidget(widget) {
                return this.removeWidgets([
                    widget
                ]);
            }
        },
        {
            key: "removeWidgets",
            value: function removeWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($85025f93a09618fe$var$withUsage("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.dispose !== "function";
                })) throw new Error($85025f93a09618fe$var$withUsage("The widget definition expects a `dispose` method."));
                this.mainIndex.removeWidgets(widgets);
                return this;
            }
        },
        {
            key: "start",
            value: function start() {
                var _this3 = this;
                if (this.started) throw new Error($85025f93a09618fe$var$withUsage("The `start` method has already been called once."));
                 // This Helper is used for the queries, we don't care about its state. The
                // states are managed at the `index` level. We use this Helper to create
                // DerivedHelper scoped into the `index` widgets.
                // In Vue InstantSearch' hydrate, a main helper gets set before start, so
                // we need to respect this helper as a way to keep all listeners correct.
                var mainHelper = this.mainHelper || (0, (/*@__PURE__*/$parcel$interopDefault($ee3ec914d550de31$exports)))(this.client, this.indexName);
                mainHelper.search = function() {
                    // This solution allows us to keep the exact same API for the users but
                    // under the hood, we have a different implementation. It should be
                    // completely transparent for the rest of the codebase. Only this module
                    // is impacted.
                    return mainHelper.searchOnlyWithDerivedHelpers();
                };
                if (this._searchFunction) {
                    // this client isn't used to actually search, but required for the helper
                    // to not throw errors
                    var fakeClient = {
                        search: function search() {
                            return new Promise((0, $0387abbfc54484f5$export$2e2bcd8739ae039));
                        }
                    };
                    this._mainHelperSearch = mainHelper.search.bind(mainHelper);
                    mainHelper.search = function() {
                        var mainIndexHelper = _this3.mainIndex.getHelper();
                        var searchFunctionHelper = (0, (/*@__PURE__*/$parcel$interopDefault($ee3ec914d550de31$exports)))(fakeClient, mainIndexHelper.state.index, mainIndexHelper.state);
                        searchFunctionHelper.once("search", function(_ref2) {
                            var state = _ref2.state;
                            mainIndexHelper.overrideStateWithoutTriggeringChangeEvent(state);
                            _this3._mainHelperSearch();
                        }); // Forward state changes from `searchFunctionHelper` to `mainIndexHelper`
                        searchFunctionHelper.on("change", function(_ref3) {
                            var state = _ref3.state;
                            mainIndexHelper.setState(state);
                        });
                        _this3._searchFunction(searchFunctionHelper);
                        return mainHelper;
                    };
                } // Only the "main" Helper emits the `error` event vs the one for `search`
                // and `results` that are also emitted on the derived one.
                mainHelper.on("error", function(_ref4) {
                    var error = _ref4.error;
                    _this3.emit("error", {
                        error: error
                    });
                });
                this.mainHelper = mainHelper;
                this.mainIndex.init({
                    instantSearchInstance: this,
                    parent: null,
                    uiState: this._initialUiState
                });
                this.middleware.forEach(function(_ref5) {
                    var instance = _ref5.instance;
                    instance.subscribe();
                });
                mainHelper.search(); // Keep the previous reference for legacy purpose, some pattern use
                // the direct Helper access `search.helper` (e.g multi-index).
                this.helper = this.mainIndex.getHelper(); // track we started the search if we add more widgets,
                // to init them directly after add
                this.started = true;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this.scheduleSearch.cancel();
                this.scheduleRender.cancel();
                clearTimeout(this._searchStalledTimer);
                this.removeWidgets(this.mainIndex.getWidgets());
                this.mainIndex.dispose(); // You can not start an instance two times, therefore a disposed instance
                // needs to set started as false otherwise this can not be restarted at a
                // later point.
                this.started = false; // The helper needs to be reset to perform the next search from a fresh state.
                // If not reset, it would use the state stored before calling `dispose()`.
                this.removeAllListeners();
                this.mainHelper.removeAllListeners();
                this.mainHelper = null;
                this.helper = null;
                this.middleware.forEach(function(_ref6) {
                    var instance = _ref6.instance;
                    instance.unsubscribe();
                });
            }
        },
        {
            key: "scheduleStalledRender",
            value: function scheduleStalledRender() {
                var _this4 = this;
                if (!this._searchStalledTimer) this._searchStalledTimer = setTimeout(function() {
                    _this4._isSearchStalled = true;
                    _this4.scheduleRender();
                }, this._stalledSearchDelay);
            }
        },
        {
            key: "setUiState",
            value: function setUiState(uiState) {
                if (!this.mainHelper) throw new Error($85025f93a09618fe$var$withUsage("The `start` method needs to be called before `setUiState`."));
                 // We refresh the index UI state to update the local UI state that the
                // main index passes to the function form of `setUiState`.
                this.mainIndex.refreshUiState();
                var nextUiState = typeof uiState === "function" ? uiState(this.mainIndex.getWidgetUiState({})) : uiState;
                var setIndexHelperState = function setIndexHelperState(indexWidget) {
                    indexWidget.getHelper().setState(indexWidget.getWidgetSearchParameters(indexWidget.getHelper().state, {
                        uiState: nextUiState[indexWidget.getIndexId()]
                    }));
                    indexWidget.getWidgets().filter((0, $6147dba0b024d6d3$export$a9c9a0d43506297d)).forEach(setIndexHelperState);
                };
                setIndexHelperState(this.mainIndex);
                this.scheduleSearch();
            }
        },
        {
            key: "getUiState",
            value: function getUiState() {
                if (this.started) // We refresh the index UI state to make sure changes from `refine` are taken in account
                this.mainIndex.refreshUiState();
                return this.mainIndex.getWidgetUiState({});
            }
        },
        {
            key: "createURL",
            value: function createURL() {
                var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.started) throw new Error($85025f93a09618fe$var$withUsage("The `start` method needs to be called before `createURL`."));
                return this._createURL(nextState);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                if (!this.mainHelper) throw new Error($85025f93a09618fe$var$withUsage("The `start` method needs to be called before `refresh`."));
                this.mainHelper.clearCache().search();
            }
        }
    ]);
    return InstantSearch;
}((0, (/*@__PURE__*/$parcel$interopDefault($6e41fae856809c3e$exports))));
var $85025f93a09618fe$export$2e2bcd8739ae039 = $85025f93a09618fe$var$InstantSearch;




var $32f353b86252aeca$export$d900da7fa9a86f36 = "_ALGOLIA";
function $32f353b86252aeca$var$getCookie(name) {
    var prefix = "".concat(name, "=");
    var cookies = document.cookie.split(";");
    for(var i = 0; i < cookies.length; i++){
        var cookie = cookies[i];
        while(cookie.charAt(0) === " ")cookie = cookie.substring(1);
        if (cookie.indexOf(prefix) === 0) return cookie.substring(prefix.length, cookie.length);
    }
    return undefined;
}
function $32f353b86252aeca$export$61f1c6e9cd2ed687() {
    return $32f353b86252aeca$var$getCookie($32f353b86252aeca$export$d900da7fa9a86f36);
}
function $32f353b86252aeca$export$2e2bcd8739ae039() {
    return $32f353b86252aeca$export$61f1c6e9cd2ed687();
}



function $3b76b60877c0bd27$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3b76b60877c0bd27$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3b76b60877c0bd27$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3b76b60877c0bd27$var$getStateWithoutPage(state) {
    var _ref = state || {}, page = _ref.page, rest = $3b76b60877c0bd27$var$_objectWithoutProperties(_ref, [
        "page"
    ]);
    return rest;
}
var $3b76b60877c0bd27$var$KEY = "ais.infiniteHits";
function $3b76b60877c0bd27$var$hasSessionStorage() {
    return typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";
}
function $3b76b60877c0bd27$export$2e2bcd8739ae039() {
    return {
        read: function read(_ref2) {
            var state = _ref2.state;
            if (!$3b76b60877c0bd27$var$hasSessionStorage()) return null;
            try {
                var cache = JSON.parse(window.sessionStorage.getItem($3b76b60877c0bd27$var$KEY));
                return cache && (0, $3d3b2841e1d9e29b$export$2e2bcd8739ae039)(cache.state, $3b76b60877c0bd27$var$getStateWithoutPage(state)) ? cache.hits : null;
            } catch (error) {
                if (error instanceof SyntaxError) try {
                    window.sessionStorage.removeItem($3b76b60877c0bd27$var$KEY);
                } catch (err) {}
                return null;
            }
        },
        write: function write(_ref3) {
            var state = _ref3.state, hits = _ref3.hits;
            if (!$3b76b60877c0bd27$var$hasSessionStorage()) return;
            try {
                window.sessionStorage.setItem($3b76b60877c0bd27$var$KEY, JSON.stringify({
                    state: $3b76b60877c0bd27$var$getStateWithoutPage(state),
                    hits: hits
                }));
            } catch (error) {}
        }
    };
}


var $fc0971d2e4ca7c40$var$instantsearch = function instantsearch(options) {
    return new (0, $85025f93a09618fe$export$2e2bcd8739ae039)(options);
};
$fc0971d2e4ca7c40$var$instantsearch.version = (0, $4fbe7e4363b97af8$export$2e2bcd8739ae039);
$fc0971d2e4ca7c40$var$instantsearch.snippet = (0, $a2695bd0541b6249$export$2e2bcd8739ae039);
$fc0971d2e4ca7c40$var$instantsearch.reverseSnippet = (0, $444305048c174754$export$2e2bcd8739ae039);
$fc0971d2e4ca7c40$var$instantsearch.highlight = (0, $9b3d6101ae46038b$export$2e2bcd8739ae039);
$fc0971d2e4ca7c40$var$instantsearch.reverseHighlight = (0, $5fcd46e7a4c7b597$export$2e2bcd8739ae039);
$fc0971d2e4ca7c40$var$instantsearch.insights = (0, $1df60413cb0e41e0$export$2e2bcd8739ae039);
$fc0971d2e4ca7c40$var$instantsearch.getInsightsAnonymousUserToken = (0, $32f353b86252aeca$export$2e2bcd8739ae039);
$fc0971d2e4ca7c40$var$instantsearch.createInfiniteHitsSessionStorageCache = (0, $3b76b60877c0bd27$export$2e2bcd8739ae039);
Object.defineProperty($fc0971d2e4ca7c40$var$instantsearch, "widgets", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.widgets\" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from 'instantsearch.js/es/widgets'");
    }
});
Object.defineProperty($fc0971d2e4ca7c40$var$instantsearch, "connectors", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.connectors\" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from 'instantsearch.js/es/connectors'");
    }
});
var $fc0971d2e4ca7c40$export$2e2bcd8739ae039 = $fc0971d2e4ca7c40$var$instantsearch;


var $806372f2f9cb9e83$export$41c562ebe57d11e2, $806372f2f9cb9e83$export$a8257692ac88316c, $806372f2f9cb9e83$var$u, $806372f2f9cb9e83$var$i, $806372f2f9cb9e83$var$t, $806372f2f9cb9e83$var$o, $806372f2f9cb9e83$var$r = {}, $806372f2f9cb9e83$var$f = [], $806372f2f9cb9e83$var$e = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $806372f2f9cb9e83$var$c(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $806372f2f9cb9e83$var$s(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $806372f2f9cb9e83$export$c8a8987d4410bf2d(n, l, u) {
    var i, t, o, r = arguments, f = {};
    for(o in l)"key" == o ? i = l[o] : "ref" == o ? t = l[o] : f[o] = l[o];
    if (arguments.length > 3) for(u = [
        u
    ], o = 3; o < arguments.length; o++)u.push(r[o]);
    if (null != u && (f.children = u), "function" == typeof n && null != n.defaultProps) for(o in n.defaultProps)void 0 === f[o] && (f[o] = n.defaultProps[o]);
    return $806372f2f9cb9e83$var$v(n, f, i, t, null);
}
function $806372f2f9cb9e83$var$v(l, u, i, t, o) {
    var r = {
        type: l,
        props: u,
        key: i,
        ref: t,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == o ? ++$806372f2f9cb9e83$export$41c562ebe57d11e2.__v : o
    };
    return null != $806372f2f9cb9e83$export$41c562ebe57d11e2.vnode && $806372f2f9cb9e83$export$41c562ebe57d11e2.vnode(r), r;
}
function $806372f2f9cb9e83$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $806372f2f9cb9e83$export$ffb0004e005737fa(n) {
    return n.children;
}
function $806372f2f9cb9e83$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $806372f2f9cb9e83$var$d(n, l) {
    if (null == l) return n.__ ? $806372f2f9cb9e83$var$d(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $806372f2f9cb9e83$var$d(n) : null;
}
function $806372f2f9cb9e83$var$_(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $806372f2f9cb9e83$var$_(n);
    }
}
function $806372f2f9cb9e83$var$k(l) {
    (!l.__d && (l.__d = !0) && $806372f2f9cb9e83$var$u.push(l) && !$806372f2f9cb9e83$var$b.__r++ || $806372f2f9cb9e83$var$t !== $806372f2f9cb9e83$export$41c562ebe57d11e2.debounceRendering) && (($806372f2f9cb9e83$var$t = $806372f2f9cb9e83$export$41c562ebe57d11e2.debounceRendering) || $806372f2f9cb9e83$var$i)($806372f2f9cb9e83$var$b);
}
function $806372f2f9cb9e83$var$b() {
    for(var n; $806372f2f9cb9e83$var$b.__r = $806372f2f9cb9e83$var$u.length;)n = $806372f2f9cb9e83$var$u.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }), $806372f2f9cb9e83$var$u = [], n.some(function(n) {
        var l, u, i, t, o, r;
        n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = $806372f2f9cb9e83$var$c({}, t)).__v = t.__v + 1, $806372f2f9cb9e83$var$I(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [
            o
        ] : null, u, null == o ? $806372f2f9cb9e83$var$d(t) : o, t.__h), $806372f2f9cb9e83$var$T(u, t), t.__e != o && $806372f2f9cb9e83$var$_(t)));
    });
}
function $806372f2f9cb9e83$var$m(n, l, u, i, t, o, e, c, s, a) {
    var h, p, _, k, b, m, w, A = i && i.__k || $806372f2f9cb9e83$var$f, P = A.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (k = u.__k[h] = null == (k = l[h]) || "boolean" == typeof k ? null : "string" == typeof k || "number" == typeof k || "bigint" == typeof k ? $806372f2f9cb9e83$var$v(null, k, null, null, k) : Array.isArray(k) ? $806372f2f9cb9e83$var$v($806372f2f9cb9e83$export$ffb0004e005737fa, {
        children: k
    }, null, null, null) : k.__b > 0 ? $806372f2f9cb9e83$var$v(k.type, k.props, k.key, null, k.__v) : k)) {
        if (k.__ = u, k.__b = u.__b + 1, null === (_ = A[h]) || _ && k.key == _.key && k.type === _.type) A[h] = void 0;
        else for(p = 0; p < P; p++){
            if ((_ = A[p]) && k.key == _.key && k.type === _.type) {
                A[p] = void 0;
                break;
            }
            _ = null;
        }
        $806372f2f9cb9e83$var$I(n, k, _ = _ || $806372f2f9cb9e83$var$r, t, o, e, c, s, a), b = k.__e, (p = k.ref) && _.ref != p && (w || (w = []), _.ref && w.push(_.ref, null, k), w.push(p, k.__c || b, k)), null != b ? (null == m && (m = b), "function" == typeof k.type && null != k.__k && k.__k === _.__k ? k.__d = s = $806372f2f9cb9e83$var$g(k, s, n) : s = $806372f2f9cb9e83$var$x(n, k, _, A, b, s), a || "option" !== u.type ? "function" == typeof u.type && (u.__d = s) : n.value = "") : s && _.__e == s && s.parentNode != n && (s = $806372f2f9cb9e83$var$d(_));
    }
    for(u.__e = m, h = P; h--;)null != A[h] && ("function" == typeof u.type && null != A[h].__e && A[h].__e == u.__d && (u.__d = $806372f2f9cb9e83$var$d(i, h + 1)), $806372f2f9cb9e83$var$L(A[h], A[h]));
    if (w) for(h = 0; h < w.length; h++)$806372f2f9cb9e83$var$z(w[h], w[++h], w[++h]);
}
function $806372f2f9cb9e83$var$g(n, l, u) {
    var i, t;
    for(i = 0; i < n.__k.length; i++)(t = n.__k[i]) && (t.__ = n, l = "function" == typeof t.type ? $806372f2f9cb9e83$var$g(t, l, u) : $806372f2f9cb9e83$var$x(u, t, t, n.__k, t.__e, l));
    return l;
}
function $806372f2f9cb9e83$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (Array.isArray(n) ? n.some(function(n) {
        $806372f2f9cb9e83$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $806372f2f9cb9e83$var$x(n, l, u, i, t, o) {
    var r, f, e;
    if (void 0 !== l.__d) r = l.__d, l.__d = void 0;
    else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;
    else {
        for(f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 2)if (f == t) break n;
        n.insertBefore(t, o), r = o;
    }
    return void 0 !== r ? r : t.nextSibling;
}
function $806372f2f9cb9e83$var$A(n, l, u, i, t) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $806372f2f9cb9e83$var$C(n, o, null, u[o], i);
    for(o in l)t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $806372f2f9cb9e83$var$C(n, o, l[o], u[o], i);
}
function $806372f2f9cb9e83$var$P(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || $806372f2f9cb9e83$var$e.test(l) ? u : u + "px";
}
function $806372f2f9cb9e83$var$C(n, l, u, i, t) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $806372f2f9cb9e83$var$P(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $806372f2f9cb9e83$var$P(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? $806372f2f9cb9e83$var$H : $806372f2f9cb9e83$var$$, o) : n.removeEventListener(l, o ? $806372f2f9cb9e83$var$H : $806372f2f9cb9e83$var$$, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
        else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
    }
}
function $806372f2f9cb9e83$var$$(l) {
    this.l[l.type + !1]($806372f2f9cb9e83$export$41c562ebe57d11e2.event ? $806372f2f9cb9e83$export$41c562ebe57d11e2.event(l) : l);
}
function $806372f2f9cb9e83$var$H(l) {
    this.l[l.type + !0]($806372f2f9cb9e83$export$41c562ebe57d11e2.event ? $806372f2f9cb9e83$export$41c562ebe57d11e2.event(l) : l);
}
function $806372f2f9cb9e83$var$I(l, u, i, t, o, r, f, e, s) {
    var a, v, h, d, _, k, b, g, w, x, A, P = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (s = i.__h, e = u.__e = i.__e, u.__h = null, r = [
        e
    ]), (a = $806372f2f9cb9e83$export$41c562ebe57d11e2.__b) && a(u);
    try {
        n: if ("function" == typeof P) {
            if (g = u.props, w = (a = P.contextType) && t[a.__c], x = a ? w ? w.props.value : a.__ : t, i.__c ? b = (v = u.__c = i.__c).__ = v.__E : ("prototype" in P && P.prototype.render ? u.__c = v = new P(g, x) : (u.__c = v = new $806372f2f9cb9e83$export$16fa2f45be04daa8(g, x), v.constructor = P, v.render = $806372f2f9cb9e83$var$M), w && w.sub(v), v.props = g, v.state || (v.state = {}), v.context = x, v.__n = t, h = v.__d = !0, v.__h = []), null == v.__s && (v.__s = v.state), null != P.getDerivedStateFromProps && (v.__s == v.state && (v.__s = $806372f2f9cb9e83$var$c({}, v.__s)), $806372f2f9cb9e83$var$c(v.__s, P.getDerivedStateFromProps(g, v.__s))), d = v.props, _ = v.state, h) null == P.getDerivedStateFromProps && null != v.componentWillMount && v.componentWillMount(), null != v.componentDidMount && v.__h.push(v.componentDidMount);
            else {
                if (null == P.getDerivedStateFromProps && g !== d && null != v.componentWillReceiveProps && v.componentWillReceiveProps(g, x), !v.__e && null != v.shouldComponentUpdate && !1 === v.shouldComponentUpdate(g, v.__s, x) || u.__v === i.__v) {
                    v.props = g, v.state = v.__s, u.__v !== i.__v && (v.__d = !1), v.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), v.__h.length && f.push(v);
                    break n;
                }
                null != v.componentWillUpdate && v.componentWillUpdate(g, v.__s, x), null != v.componentDidUpdate && v.__h.push(function() {
                    v.componentDidUpdate(d, _, k);
                });
            }
            v.context = x, v.props = g, v.state = v.__s, (a = $806372f2f9cb9e83$export$41c562ebe57d11e2.__r) && a(u), v.__d = !1, v.__v = u, v.__P = l, a = v.render(v.props, v.state, v.context), v.state = v.__s, null != v.getChildContext && (t = $806372f2f9cb9e83$var$c($806372f2f9cb9e83$var$c({}, t), v.getChildContext())), h || null == v.getSnapshotBeforeUpdate || (k = v.getSnapshotBeforeUpdate(d, _)), A = null != a && a.type === $806372f2f9cb9e83$export$ffb0004e005737fa && null == a.key ? a.props.children : a, $806372f2f9cb9e83$var$m(l, Array.isArray(A) ? A : [
                A
            ], u, i, t, o, r, f, e, s), v.base = u.__e, u.__h = null, v.__h.length && f.push(v), b && (v.__E = v.__ = null), v.__e = !1;
        } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $806372f2f9cb9e83$var$j(i.__e, u, i, t, o, r, f, s);
        (a = $806372f2f9cb9e83$export$41c562ebe57d11e2.diffed) && a(u);
    } catch (l) {
        u.__v = null, (s || null != r) && (u.__e = e, u.__h = !!s, r[r.indexOf(e)] = null), $806372f2f9cb9e83$export$41c562ebe57d11e2.__e(l, u, i);
    }
}
function $806372f2f9cb9e83$var$T(l, u) {
    $806372f2f9cb9e83$export$41c562ebe57d11e2.__c && $806372f2f9cb9e83$export$41c562ebe57d11e2.__c(u, l), l.some(function(u) {
        try {
            l = u.__h, u.__h = [], l.some(function(n) {
                n.call(u);
            });
        } catch (l) {
            $806372f2f9cb9e83$export$41c562ebe57d11e2.__e(l, u.__v);
        }
    });
}
function $806372f2f9cb9e83$var$j(n, l, u, i, t, o, e, c) {
    var a, v, h, y, p = u.props, d = l.props, _ = l.type, k = 0;
    if ("svg" === _ && (t = !0), null != o) {
        for(; k < o.length; k++)if ((a = o[k]) && (a === n || (_ ? a.localName == _ : 3 == a.nodeType))) {
            n = a, o[k] = null;
            break;
        }
    }
    if (null == n) {
        if (null === _) return document.createTextNode(d);
        n = t ? document.createElementNS("http://www.w3.org/2000/svg", _) : document.createElement(_, d.is && d), o = null, c = !1;
    }
    if (null === _) p === d || c && n.data === d || (n.data = d);
    else {
        if (o = o && $806372f2f9cb9e83$var$f.slice.call(n.childNodes), v = (p = u.props || $806372f2f9cb9e83$var$r).dangerouslySetInnerHTML, h = d.dangerouslySetInnerHTML, !c) {
            if (null != o) for(p = {}, y = 0; y < n.attributes.length; y++)p[n.attributes[y].name] = n.attributes[y].value;
            (h || v) && (h && (v && h.__html == v.__html || h.__html === n.innerHTML) || (n.innerHTML = h && h.__html || ""));
        }
        if ($806372f2f9cb9e83$var$A(n, d, p, t, c), h) l.__k = [];
        else if (k = l.props.children, $806372f2f9cb9e83$var$m(n, Array.isArray(k) ? k : [
            k
        ], l, u, i, t && "foreignObject" !== _, o, e, n.firstChild, c), null != o) for(k = o.length; k--;)null != o[k] && $806372f2f9cb9e83$var$s(o[k]);
        c || ("value" in d && void 0 !== (k = d.value) && (k !== n.value || "progress" === _ && !k) && $806372f2f9cb9e83$var$C(n, "value", k, p.value, !1), "checked" in d && void 0 !== (k = d.checked) && k !== n.checked && $806372f2f9cb9e83$var$C(n, "checked", k, p.checked, !1));
    }
    return n;
}
function $806372f2f9cb9e83$var$z(l, u, i) {
    try {
        "function" == typeof l ? l(u) : l.current = u;
    } catch (l) {
        $806372f2f9cb9e83$export$41c562ebe57d11e2.__e(l, i);
    }
}
function $806372f2f9cb9e83$var$L(l, u, i) {
    var t, o, r;
    if ($806372f2f9cb9e83$export$41c562ebe57d11e2.unmount && $806372f2f9cb9e83$export$41c562ebe57d11e2.unmount(l), (t = l.ref) && (t.current && t.current !== l.__e || $806372f2f9cb9e83$var$z(t, null, u)), i || "function" == typeof l.type || (i = null != (o = l.__e)), l.__e = l.__d = void 0, null != (t = l.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (l) {
            $806372f2f9cb9e83$export$41c562ebe57d11e2.__e(l, u);
        }
        t.base = t.__P = null;
    }
    if (t = l.__k) for(r = 0; r < t.length; r++)t[r] && $806372f2f9cb9e83$var$L(t[r], u, i);
    null != o && $806372f2f9cb9e83$var$s(o);
}
function $806372f2f9cb9e83$var$M(n, l, u) {
    return this.constructor(n, u);
}
function $806372f2f9cb9e83$export$b3890eb0ae9dca99(l, u, i) {
    var t, o, e;
    $806372f2f9cb9e83$export$41c562ebe57d11e2.__ && $806372f2f9cb9e83$export$41c562ebe57d11e2.__(l, u), o = (t = "function" == typeof i) ? null : i && i.__k || u.__k, e = [], $806372f2f9cb9e83$var$I(u, l = (!t && i || u).__k = $806372f2f9cb9e83$export$c8a8987d4410bf2d($806372f2f9cb9e83$export$ffb0004e005737fa, null, [
        l
    ]), o || $806372f2f9cb9e83$var$r, $806372f2f9cb9e83$var$r, void 0 !== u.ownerSVGElement, !t && i ? [
        i
    ] : o ? null : u.firstChild ? $806372f2f9cb9e83$var$f.slice.call(u.childNodes) : null, e, !t && i ? i : o ? o.__e : u.firstChild, t), $806372f2f9cb9e83$var$T(e, l);
}
function $806372f2f9cb9e83$export$fa8d919ba61d84db(n, l) {
    $806372f2f9cb9e83$export$b3890eb0ae9dca99(n, l, $806372f2f9cb9e83$export$fa8d919ba61d84db);
}
function $806372f2f9cb9e83$export$e530037191fcd5d7(n, l, u) {
    var i, t, o, r = arguments, f = $806372f2f9cb9e83$var$c({}, n.props);
    for(o in l)"key" == o ? i = l[o] : "ref" == o ? t = l[o] : f[o] = l[o];
    if (arguments.length > 3) for(u = [
        u
    ], o = 3; o < arguments.length; o++)u.push(r[o]);
    return null != u && (f.children = u), $806372f2f9cb9e83$var$v(n.type, f, i || n.key, t || n.ref, null);
}
function $806372f2f9cb9e83$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $806372f2f9cb9e83$var$o++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some($806372f2f9cb9e83$var$k);
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$806372f2f9cb9e83$export$41c562ebe57d11e2 = {
    __e: function(n, l) {
        for(var u, i, t; l = l.__;)if ((u = l.__c) && !u.__) try {
            if ((i = u.constructor) && null != i.getDerivedStateFromError && (u.setState(i.getDerivedStateFromError(n)), t = u.__d), null != u.componentDidCatch && (u.componentDidCatch(n), t = u.__d), t) return u.__E = u;
        } catch (l) {
            n = l;
        }
        throw n;
    },
    __v: 0
}, $806372f2f9cb9e83$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $806372f2f9cb9e83$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $806372f2f9cb9e83$var$c({}, this.state), "function" == typeof n && (n = n($806372f2f9cb9e83$var$c({}, u), this.props)), n && $806372f2f9cb9e83$var$c(u, n), null != n && this.__v && (l && this.__h.push(l), $806372f2f9cb9e83$var$k(this));
}, $806372f2f9cb9e83$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $806372f2f9cb9e83$var$k(this));
}, $806372f2f9cb9e83$export$16fa2f45be04daa8.prototype.render = $806372f2f9cb9e83$export$ffb0004e005737fa, $806372f2f9cb9e83$var$u = [], $806372f2f9cb9e83$var$i = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $806372f2f9cb9e83$var$b.__r = 0, $806372f2f9cb9e83$var$o = 0;


var $54ef7be12d5d63e7$exports = {};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, $54ef7be12d5d63e7$exports) {
        classNames.default = classNames;
        $54ef7be12d5d63e7$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


function $25ea6e28dd3afdde$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $25ea6e28dd3afdde$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $25ea6e28dd3afdde$var$ownKeys(Object(source), true).forEach(function(key) {
            $25ea6e28dd3afdde$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $25ea6e28dd3afdde$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $25ea6e28dd3afdde$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25ea6e28dd3afdde$export$33d742d8ee5a4609(hits, page, hitsPerPage) {
    return hits.map(function(hit, idx) {
        return $25ea6e28dd3afdde$var$_objectSpread($25ea6e28dd3afdde$var$_objectSpread({}, hit), {}, {
            __position: hitsPerPage * page + idx + 1
        });
    });
}

function $d6fdc647dc8892cb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d6fdc647dc8892cb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d6fdc647dc8892cb$var$ownKeys(Object(source), true).forEach(function(key) {
            $d6fdc647dc8892cb$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d6fdc647dc8892cb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d6fdc647dc8892cb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d6fdc647dc8892cb$export$b8f834386ea30952(hits, queryID) {
    if (!queryID) return hits;
    return hits.map(function(hit) {
        return $d6fdc647dc8892cb$var$_objectSpread($d6fdc647dc8892cb$var$_objectSpread({}, hit), {}, {
            __queryID: queryID
        });
    });
}

function $56dde5d7af234315$var$getObjectType(object) {
    return Object.prototype.toString.call(object).slice(8, -1);
}
var $56dde5d7af234315$export$2e2bcd8739ae039 = $56dde5d7af234315$var$getObjectType;


function $5ea0f33637ed3157$var$checkRendering(rendering, usage) {
    if (rendering === undefined || typeof rendering !== "function") throw new Error("The render function is not valid (received type ".concat((0, $56dde5d7af234315$export$2e2bcd8739ae039)(rendering), ").\n\n").concat(usage));
}
var $5ea0f33637ed3157$export$2e2bcd8739ae039 = $5ea0f33637ed3157$var$checkRendering;


function $fa1165307d3f044d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fa1165307d3f044d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fa1165307d3f044d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fa1165307d3f044d$var$_typeof(obj);
}
var $fa1165307d3f044d$var$buildPayload = function buildPayload(_ref) {
    var index = _ref.index, widgetType = _ref.widgetType, methodName = _ref.methodName, args = _ref.args;
    if (args.length === 1 && $fa1165307d3f044d$var$_typeof(args[0]) === "object") return args[0];
    var eventType = args[0];
    var hits = args[1];
    var eventName = args[2];
    if (!hits) return null;
    if ((eventType === "click" || eventType === "conversion") && !eventName) return null;
    var hitsArray = Array.isArray(hits) ? $fa1165307d3f044d$var$removeEscapedFromHits(hits) : [
        hits
    ];
    if (hitsArray.length === 0) return null;
    var queryID = hitsArray[0].__queryID;
    var objectIDs = hitsArray.map(function(hit) {
        return hit.objectID;
    });
    var positions = hitsArray.map(function(hit) {
        return hit.__position;
    });
    if (eventType === "view") return {
        insightsMethod: "viewedObjectIDs",
        widgetType: widgetType,
        eventType: eventType,
        payload: {
            eventName: eventName || "Hits Viewed",
            index: index,
            objectIDs: objectIDs
        },
        hits: hitsArray
    };
    else if (eventType === "click") return {
        insightsMethod: "clickedObjectIDsAfterSearch",
        widgetType: widgetType,
        eventType: eventType,
        payload: {
            eventName: eventName,
            index: index,
            queryID: queryID,
            objectIDs: objectIDs,
            positions: positions
        },
        hits: hitsArray
    };
    else if (eventType === "conversion") return {
        insightsMethod: "convertedObjectIDsAfterSearch",
        widgetType: widgetType,
        eventType: eventType,
        payload: {
            eventName: eventName,
            index: index,
            queryID: queryID,
            objectIDs: objectIDs
        },
        hits: hitsArray
    };
    else return null;
};
function $fa1165307d3f044d$var$removeEscapedFromHits(hits) {
    // this returns without `hits.__escaped`
    // and this way it doesn't mutate the original `hits`
    return hits.map(function(hit) {
        return hit;
    });
}
function $fa1165307d3f044d$export$4139f3a7130239e3(_ref2) {
    var instantSearchInstance = _ref2.instantSearchInstance, index = _ref2.index, widgetType = _ref2.widgetType;
    var sendEventForHits = function sendEventForHits() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var payload = $fa1165307d3f044d$var$buildPayload({
            widgetType: widgetType,
            index: index,
            methodName: "sendEvent",
            args: args
        });
        if (payload) instantSearchInstance.sendEventToInsights(payload);
    };
    return sendEventForHits;
}
function $fa1165307d3f044d$export$5a3d9973824d9b76(_ref3) {
    var index = _ref3.index, widgetType = _ref3.widgetType;
    var bindEventForHits = function bindEventForHits() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var payload = $fa1165307d3f044d$var$buildPayload({
            widgetType: widgetType,
            index: index,
            methodName: "bindEvent",
            args: args
        });
        return payload ? "data-insights-event=".concat((0, $3fe0a367fb335f83$export$44b4521aa38272f2)(payload)) : "";
    };
    return bindEventForHits;
}


function $a77e9a517cc7366e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a77e9a517cc7366e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a77e9a517cc7366e$var$ownKeys(Object(source), true).forEach(function(key) {
            $a77e9a517cc7366e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a77e9a517cc7366e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a77e9a517cc7366e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a77e9a517cc7366e$var$withUsage = (0, $222bd44957f3ca8f$export$2fde5bffc340821e)({
    name: "hits",
    connector: true
});
var $a77e9a517cc7366e$var$connectHits = function connectHits(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $0387abbfc54484f5$export$2e2bcd8739ae039);
    (0, $5ea0f33637ed3157$export$2e2bcd8739ae039)(renderFn, $a77e9a517cc7366e$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$escapeHTML = _ref.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        var sendEvent;
        var bindEvent;
        return {
            $$type: "ais.hits",
            init: function init(initOptions) {
                renderFn($a77e9a517cc7366e$var$_objectSpread($a77e9a517cc7366e$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var renderState = this.getWidgetRenderState(renderOptions);
                renderState.sendEvent("view", renderState.hits);
                renderFn($a77e9a517cc7366e$var$_objectSpread($a77e9a517cc7366e$var$_objectSpread({}, renderState), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $a77e9a517cc7366e$var$_objectSpread($a77e9a517cc7366e$var$_objectSpread({}, renderState), {}, {
                    hits: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var results = _ref2.results, helper = _ref2.helper, instantSearchInstance = _ref2.instantSearchInstance;
                if (!sendEvent) sendEvent = (0, $fa1165307d3f044d$export$4139f3a7130239e3)({
                    instantSearchInstance: instantSearchInstance,
                    index: helper.getIndex(),
                    widgetType: this.$$type
                });
                if (!bindEvent) bindEvent = (0, $fa1165307d3f044d$export$5a3d9973824d9b76)({
                    index: helper.getIndex(),
                    widgetType: this.$$type
                });
                if (!results) return {
                    hits: [],
                    results: undefined,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
                if (escapeHTML && results.hits.length > 0) results.hits = (0, $b85debef0921786f$export$9adb036445aab889)(results.hits);
                var initialEscaped = results.hits.__escaped;
                results.hits = (0, $25ea6e28dd3afdde$export$33d742d8ee5a4609)(results.hits, results.page, results.hitsPerPage);
                results.hits = (0, $d6fdc647dc8892cb$export$b8f834386ea30952)(results.hits, results.queryID);
                results.hits = transformItems(results.hits); // Make sure the escaped tag stays, even after mapping over the hits.
                // This prevents the hits from being double-escaped if there are multiple
                // hits widgets mounted on the page.
                results.hits.__escaped = initialEscaped;
                return {
                    hits: results.hits,
                    results: results,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                if (!escapeHTML) return state;
                return state.setQueryParameters(Object.keys((0, $b85debef0921786f$export$1e7338a8952eaf35)).reduce(function(acc, key) {
                    return $a77e9a517cc7366e$var$_objectSpread($a77e9a517cc7366e$var$_objectSpread({}, acc), {}, $a77e9a517cc7366e$var$_defineProperty({}, key, undefined));
                }, {}));
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state) {
                if (!escapeHTML) return state;
                return state.setQueryParameters((0, $b85debef0921786f$export$1e7338a8952eaf35));
            }
        };
    };
};
var $a77e9a517cc7366e$export$2e2bcd8739ae039 = $a77e9a517cc7366e$var$connectHits;





var $af835f9ae2b964f1$exports = {};
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ // This file is for use with Node.js. See dist/ for browser files.
var $4553eef7ca42bda4$exports = {};
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ (function(Hogan) {
    // Setup regex  assignments
    // remove whitespace according to Mustache spec
    var rIsWhitespace = /\S/, rQuot = /\"/g, rNewline = /\n/g, rCr = /\r/g, rSlash = /\\/g, rLineSep = /\u2028/, rParagraphSep = /\u2029/;
    Hogan.tags = {
        "#": 1,
        "^": 2,
        "<": 3,
        "$": 4,
        "/": 5,
        "!": 6,
        ">": 7,
        "=": 8,
        "_v": 9,
        "{": 10,
        "&": 11,
        "_t": 12
    };
    Hogan.scan = function scan(text, delimiters) {
        var len = text.length, IN_TEXT = 0, IN_TAG_TYPE = 1, IN_TAG = 2, state = IN_TEXT, tagType = null, tag = null, buf = "", tokens = [], seenTag = false, i = 0, lineStart = 0, otag = "{{", ctag = "}}";
        function addBuf() {
            if (buf.length > 0) {
                tokens.push({
                    tag: "_t",
                    text: new String(buf)
                });
                buf = "";
            }
        }
        function lineIsWhitespace() {
            var isAllWhitespace = true;
            for(var j = lineStart; j < tokens.length; j++){
                isAllWhitespace = Hogan.tags[tokens[j].tag] < Hogan.tags["_v"] || tokens[j].tag == "_t" && tokens[j].text.match(rIsWhitespace) === null;
                if (!isAllWhitespace) return false;
            }
            return isAllWhitespace;
        }
        function filterLine(haveSeenTag, noNewLine) {
            addBuf();
            if (haveSeenTag && lineIsWhitespace()) {
                for(var j = lineStart, next; j < tokens.length; j++)if (tokens[j].text) {
                    if ((next = tokens[j + 1]) && next.tag == ">") // set indent to token value
                    next.indent = tokens[j].text.toString();
                    tokens.splice(j, 1);
                }
            } else if (!noNewLine) tokens.push({
                tag: "\n"
            });
            seenTag = false;
            lineStart = tokens.length;
        }
        function changeDelimiters(text, index) {
            var close = "=" + ctag, closeIndex = text.indexOf(close, index), delimiters = trim(text.substring(text.indexOf("=", index) + 1, closeIndex)).split(" ");
            otag = delimiters[0];
            ctag = delimiters[delimiters.length - 1];
            return closeIndex + close.length - 1;
        }
        if (delimiters) {
            delimiters = delimiters.split(" ");
            otag = delimiters[0];
            ctag = delimiters[1];
        }
        for(i = 0; i < len; i++){
            if (state == IN_TEXT) {
                if (tagChange(otag, text, i)) {
                    --i;
                    addBuf();
                    state = IN_TAG_TYPE;
                } else if (text.charAt(i) == "\n") filterLine(seenTag);
                else buf += text.charAt(i);
            } else if (state == IN_TAG_TYPE) {
                i += otag.length - 1;
                tag = Hogan.tags[text.charAt(i + 1)];
                tagType = tag ? text.charAt(i + 1) : "_v";
                if (tagType == "=") {
                    i = changeDelimiters(text, i);
                    state = IN_TEXT;
                } else {
                    if (tag) i++;
                    state = IN_TAG;
                }
                seenTag = i;
            } else if (tagChange(ctag, text, i)) {
                tokens.push({
                    tag: tagType,
                    n: trim(buf),
                    otag: otag,
                    ctag: ctag,
                    i: tagType == "/" ? seenTag - otag.length : i + ctag.length
                });
                buf = "";
                i += ctag.length - 1;
                state = IN_TEXT;
                if (tagType == "{") {
                    if (ctag == "}}") i++;
                    else cleanTripleStache(tokens[tokens.length - 1]);
                }
            } else buf += text.charAt(i);
        }
        filterLine(seenTag, true);
        return tokens;
    };
    function cleanTripleStache(token) {
        if (token.n.substr(token.n.length - 1) === "}") token.n = token.n.substring(0, token.n.length - 1);
    }
    function trim(s) {
        if (s.trim) return s.trim();
        return s.replace(/^\s*|\s*$/g, "");
    }
    function tagChange(tag, text, index) {
        if (text.charAt(index) != tag.charAt(0)) return false;
        for(var i = 1, l = tag.length; i < l; i++){
            if (text.charAt(index + i) != tag.charAt(i)) return false;
        }
        return true;
    }
    // the tags allowed inside super templates
    var allowedInSuper = {
        "_t": true,
        "\n": true,
        "$": true,
        "/": true
    };
    function buildTree(tokens, kind, stack, customTags) {
        var instructions = [], opener = null, tail = null, token = null;
        tail = stack[stack.length - 1];
        while(tokens.length > 0){
            token = tokens.shift();
            if (tail && tail.tag == "<" && !(token.tag in allowedInSuper)) throw new Error("Illegal content in < super tag.");
            if (Hogan.tags[token.tag] <= Hogan.tags["$"] || isOpener(token, customTags)) {
                stack.push(token);
                token.nodes = buildTree(tokens, token.tag, stack, customTags);
            } else if (token.tag == "/") {
                if (stack.length === 0) throw new Error("Closing tag without opener: /" + token.n);
                opener = stack.pop();
                if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) throw new Error("Nesting error: " + opener.n + " vs. " + token.n);
                opener.end = token.i;
                return instructions;
            } else if (token.tag == "\n") token.last = tokens.length == 0 || tokens[0].tag == "\n";
            instructions.push(token);
        }
        if (stack.length > 0) throw new Error("missing closing tag: " + stack.pop().n);
        return instructions;
    }
    function isOpener(token, tags) {
        for(var i = 0, l = tags.length; i < l; i++)if (tags[i].o == token.n) {
            token.tag = "#";
            return true;
        }
    }
    function isCloser(close, open, tags) {
        for(var i = 0, l = tags.length; i < l; i++){
            if (tags[i].c == close && tags[i].o == open) return true;
        }
    }
    function stringifySubstitutions(obj) {
        var items = [];
        for(var key in obj)items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + "}");
        return "{ " + items.join(",") + " }";
    }
    function stringifyPartials(codeObj) {
        var partials = [];
        for(var key in codeObj.partials)partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
        return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
    }
    Hogan.stringify = function(codeObj, text, options) {
        return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) + "}";
    };
    var serialNo = 0;
    Hogan.generate = function(tree, text, options) {
        serialNo = 0;
        var context = {
            code: "",
            subs: {},
            partials: {}
        };
        Hogan.walk(tree, context);
        if (options.asString) return this.stringify(context, text, options);
        return this.makeTemplate(context, text, options);
    };
    Hogan.wrapMain = function(code) {
        return 'var t=this;t.b(i=i||"");' + code + "return t.fl();";
    };
    Hogan.template = Hogan.Template;
    Hogan.makeTemplate = function(codeObj, text, options) {
        var template = this.makePartials(codeObj);
        template.code = new Function("c", "p", "i", this.wrapMain(codeObj.code));
        return new this.template(template, text, this, options);
    };
    Hogan.makePartials = function(codeObj) {
        var key, template = {
            subs: {},
            partials: codeObj.partials,
            name: codeObj.name
        };
        for(key in template.partials)template.partials[key] = this.makePartials(template.partials[key]);
        for(key in codeObj.subs)template.subs[key] = new Function("c", "p", "t", "i", codeObj.subs[key]);
        return template;
    };
    function esc(s) {
        return s.replace(rSlash, "\\\\").replace(rQuot, '\\"').replace(rNewline, "\\n").replace(rCr, "\\r").replace(rLineSep, "\\u2028").replace(rParagraphSep, "\\u2029");
    }
    function chooseMethod(s) {
        return ~s.indexOf(".") ? "d" : "f";
    }
    function createPartial(node, context) {
        var prefix = "<" + (context.prefix || "");
        var sym = prefix + node.n + serialNo++;
        context.partials[sym] = {
            name: node.n,
            partials: {}
        };
        context.code += 't.b(t.rp("' + esc(sym) + '",c,p,"' + (node.indent || "") + '"));';
        return sym;
    }
    Hogan.codegen = {
        "#": function(node, context) {
            context.code += "if(t.s(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' + "c,p,0," + node.i + "," + node.end + ',"' + node.otag + " " + node.ctag + '")){' + "t.rs(c,p," + "function(c,p,t){";
            Hogan.walk(node.nodes, context);
            context.code += "});c.pop();}";
        },
        "^": function(node, context) {
            context.code += "if(!t.s(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
            Hogan.walk(node.nodes, context);
            context.code += "};";
        },
        ">": createPartial,
        "<": function(node, context) {
            var ctx = {
                partials: {},
                code: "",
                subs: {},
                inPartial: true
            };
            Hogan.walk(node.nodes, ctx);
            var template = context.partials[createPartial(node, context)];
            template.subs = ctx.subs;
            template.partials = ctx.partials;
        },
        "$": function(node, context) {
            var ctx = {
                subs: {},
                code: "",
                partials: context.partials,
                prefix: node.n
            };
            Hogan.walk(node.nodes, ctx);
            context.subs[node.n] = ctx.code;
            if (!context.inPartial) context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
        },
        "\n": function(node, context) {
            context.code += write('"\\n"' + (node.last ? "" : " + i"));
        },
        "_v": function(node, context) {
            context.code += "t.b(t.v(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
        },
        "_t": function(node, context) {
            context.code += write('"' + esc(node.text) + '"');
        },
        "{": tripleStache,
        "&": tripleStache
    };
    function tripleStache(node, context) {
        context.code += "t.b(t.t(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    }
    function write(s) {
        return "t.b(" + s + ");";
    }
    Hogan.walk = function(nodelist, context) {
        var func;
        for(var i = 0, l = nodelist.length; i < l; i++){
            func = Hogan.codegen[nodelist[i].tag];
            func && func(nodelist[i], context);
        }
        return context;
    };
    Hogan.parse = function(tokens, text, options) {
        options = options || {};
        return buildTree(tokens, "", [], options.sectionTags || []);
    };
    Hogan.cache = {};
    Hogan.cacheKey = function(text, options) {
        return [
            text,
            !!options.asString,
            !!options.disableLambda,
            options.delimiters,
            !!options.modelGet
        ].join("||");
    };
    Hogan.compile = function(text, options) {
        options = options || {};
        var key = Hogan.cacheKey(text, options);
        var template = this.cache[key];
        if (template) {
            var partials = template.partials;
            for(var name in partials)delete partials[name].instance;
            return template;
        }
        template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
        return this.cache[key] = template;
    };
})($4553eef7ca42bda4$exports);



$4553eef7ca42bda4$exports.Template = (parcelRequire("gc35z")).Template;
$4553eef7ca42bda4$exports.template = $4553eef7ca42bda4$exports.Template;
$af835f9ae2b964f1$exports = $4553eef7ca42bda4$exports;


function $692fa0772dff2da9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $692fa0772dff2da9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $692fa0772dff2da9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $692fa0772dff2da9$var$_typeof(obj);
}
function $692fa0772dff2da9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $692fa0772dff2da9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $692fa0772dff2da9$var$ownKeys(Object(source), true).forEach(function(key) {
            $692fa0772dff2da9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $692fa0772dff2da9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $692fa0772dff2da9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// We add all our template helper methods to the template as lambdas. Note
// that lambdas in Mustache are supposed to accept a second argument of
// `render` to get the rendered value, not the literal `{{value}}`. But
// this is currently broken (see https://github.com/twitter/hogan.js/issues/222).
function $692fa0772dff2da9$var$transformHelpersToHogan() {
    var helpers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var compileOptions = arguments.length > 1 ? arguments[1] : undefined;
    var data = arguments.length > 2 ? arguments[2] : undefined;
    return Object.keys(helpers).reduce(function(acc, helperKey) {
        return $692fa0772dff2da9$var$_objectSpread($692fa0772dff2da9$var$_objectSpread({}, acc), {}, $692fa0772dff2da9$var$_defineProperty({}, helperKey, function() {
            var _this = this;
            return function(text) {
                var render = function render(value) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($af835f9ae2b964f1$exports))).compile(value, compileOptions).render(_this);
                };
                return helpers[helperKey].call(data, text, render);
            };
        }));
    }, {});
}
function $692fa0772dff2da9$var$renderTemplate(_ref) {
    var templates = _ref.templates, templateKey = _ref.templateKey, compileOptions = _ref.compileOptions, helpers = _ref.helpers, data = _ref.data, bindEvent = _ref.bindEvent;
    var template = templates[templateKey];
    if (typeof template !== "string" && typeof template !== "function") throw new Error("Template must be 'string' or 'function', was '".concat($692fa0772dff2da9$var$_typeof(template), "' (key: ").concat(templateKey, ")"));
    if (typeof template === "function") return template(data, bindEvent);
    var transformedHelpers = $692fa0772dff2da9$var$transformHelpersToHogan(helpers, compileOptions, data);
    return (0, (/*@__PURE__*/$parcel$interopDefault($af835f9ae2b964f1$exports))).compile(template, compileOptions).render($692fa0772dff2da9$var$_objectSpread($692fa0772dff2da9$var$_objectSpread({}, data), {}, {
        helpers: transformedHelpers
    })).replace(/[ \n\r\t\f\xA0]+/g, function(spaces) {
        return spaces.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ");
    }).trim();
}
var $692fa0772dff2da9$export$2e2bcd8739ae039 = $692fa0772dff2da9$var$renderTemplate;


function $6a090c16bfb08a92$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6a090c16bfb08a92$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6a090c16bfb08a92$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6a090c16bfb08a92$var$_typeof(obj);
}
function $6a090c16bfb08a92$var$_extends() {
    $6a090c16bfb08a92$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a090c16bfb08a92$var$_extends.apply(this, arguments);
}
function $6a090c16bfb08a92$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6a090c16bfb08a92$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6a090c16bfb08a92$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6a090c16bfb08a92$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6a090c16bfb08a92$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6a090c16bfb08a92$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6a090c16bfb08a92$var$_setPrototypeOf(subClass, superClass);
}
function $6a090c16bfb08a92$var$_setPrototypeOf(o, p) {
    $6a090c16bfb08a92$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6a090c16bfb08a92$var$_setPrototypeOf(o, p);
}
function $6a090c16bfb08a92$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6a090c16bfb08a92$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6a090c16bfb08a92$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6a090c16bfb08a92$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6a090c16bfb08a92$var$_possibleConstructorReturn(this, result);
    };
}
function $6a090c16bfb08a92$var$_possibleConstructorReturn(self, call) {
    if (call && ($6a090c16bfb08a92$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6a090c16bfb08a92$var$_assertThisInitialized(self);
}
function $6a090c16bfb08a92$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6a090c16bfb08a92$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6a090c16bfb08a92$var$_getPrototypeOf(o) {
    $6a090c16bfb08a92$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6a090c16bfb08a92$var$_getPrototypeOf(o);
}
function $6a090c16bfb08a92$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6a090c16bfb08a92$var$defaultProps = {
    data: {},
    rootTagName: "div",
    useCustomCompileOptions: {},
    templates: {},
    templatesConfig: {}
};
// @TODO: Template should be a generic and receive TData to pass to Templates (to avoid TTemplateData to be set as `any`)
var $6a090c16bfb08a92$var$Template = /*#__PURE__*/ function(_Component) {
    $6a090c16bfb08a92$var$_inherits(Template, _Component);
    var _super = $6a090c16bfb08a92$var$_createSuper(Template);
    function Template() {
        $6a090c16bfb08a92$var$_classCallCheck(this, Template);
        return _super.apply(this, arguments);
    }
    $6a090c16bfb08a92$var$_createClass(Template, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, $3d3b2841e1d9e29b$export$2e2bcd8739ae039)(this.props.data, nextProps.data) || this.props.templateKey !== nextProps.templateKey || !(0, $3d3b2841e1d9e29b$export$2e2bcd8739ae039)(this.props.rootProps, nextProps.rootProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var RootTagName = this.props.rootTagName;
                var useCustomCompileOptions = this.props.useCustomCompileOptions[this.props.templateKey];
                var compileOptions = useCustomCompileOptions ? this.props.templatesConfig.compileOptions : {};
                var content = (0, $692fa0772dff2da9$export$2e2bcd8739ae039)({
                    templates: this.props.templates,
                    templateKey: this.props.templateKey,
                    compileOptions: compileOptions,
                    helpers: this.props.templatesConfig.helpers,
                    data: this.props.data,
                    bindEvent: this.props.bindEvent
                });
                if (content === null) // Adds a noscript to the DOM but virtual DOM is null
                // See http://facebook.github.io/react/docs/component-specs.html#render
                return null;
                return (0, $806372f2f9cb9e83$export$c8a8987d4410bf2d)(RootTagName, $6a090c16bfb08a92$var$_extends({}, this.props.rootProps, {
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                }));
            }
        }
    ]);
    return Template;
}((0, $806372f2f9cb9e83$export$16fa2f45be04daa8));
$6a090c16bfb08a92$var$_defineProperty($6a090c16bfb08a92$var$Template, "defaultProps", $6a090c16bfb08a92$var$defaultProps);
var $6a090c16bfb08a92$export$2e2bcd8739ae039 = $6a090c16bfb08a92$var$Template;


function $74e53deaa39b7aad$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $74e53deaa39b7aad$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $74e53deaa39b7aad$var$ownKeys(Object(source), true).forEach(function(key) {
            $74e53deaa39b7aad$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $74e53deaa39b7aad$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $74e53deaa39b7aad$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $74e53deaa39b7aad$var$_extends() {
    $74e53deaa39b7aad$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $74e53deaa39b7aad$var$_extends.apply(this, arguments);
}
var $74e53deaa39b7aad$var$Hits = function Hits(_ref) {
    var results = _ref.results, hits = _ref.hits, bindEvent = _ref.bindEvent, cssClasses = _ref.cssClasses, templateProps = _ref.templateProps;
    if (results.hits.length === 0) return (0, $806372f2f9cb9e83$export$c8a8987d4410bf2d)((0, $6a090c16bfb08a92$export$2e2bcd8739ae039), $74e53deaa39b7aad$var$_extends({}, templateProps, {
        templateKey: "empty",
        rootProps: {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($54ef7be12d5d63e7$exports)))(cssClasses.root, cssClasses.emptyRoot)
        },
        data: results
    }));
    return (0, $806372f2f9cb9e83$export$c8a8987d4410bf2d)("div", {
        className: cssClasses.root
    }, (0, $806372f2f9cb9e83$export$c8a8987d4410bf2d)("ol", {
        className: cssClasses.list
    }, hits.map(function(hit, index) {
        return (0, $806372f2f9cb9e83$export$c8a8987d4410bf2d)((0, $6a090c16bfb08a92$export$2e2bcd8739ae039), $74e53deaa39b7aad$var$_extends({}, templateProps, {
            templateKey: "item",
            rootTagName: "li",
            rootProps: {
                className: cssClasses.item
            },
            key: hit.objectID,
            data: $74e53deaa39b7aad$var$_objectSpread($74e53deaa39b7aad$var$_objectSpread({}, hit), {}, {
                __hitIndex: index
            }),
            bindEvent: bindEvent
        }));
    })));
};
$74e53deaa39b7aad$var$Hits.defaultProps = {
    results: {
        hits: []
    },
    hits: []
};
var $74e53deaa39b7aad$export$2e2bcd8739ae039 = $74e53deaa39b7aad$var$Hits;


var $cfc25ba7b6d73167$export$2e2bcd8739ae039 = {
    empty: "No results",
    item: function item(data) {
        return JSON.stringify(data, null, 2);
    }
};


function $d1c6525bd1a9ce28$var$isDomElement(object) {
    return object instanceof HTMLElement || Boolean(object) && object.nodeType > 0;
}
var $d1c6525bd1a9ce28$export$2e2bcd8739ae039 = $d1c6525bd1a9ce28$var$isDomElement;


/**
 * Return the container. If it's a string, it is considered a
 * css selector and retrieves the first matching element. Otherwise
 * test if it validates that it's a correct DOMElement.
 *
 * @param {string|HTMLElement} selectorOrHTMLElement CSS Selector or container node.
 * @return {HTMLElement} Container node
 * @throws Error when the type is not correct
 */ function $becc0ebef8d50019$var$getContainerNode(selectorOrHTMLElement) {
    var isSelectorString = typeof selectorOrHTMLElement === "string";
    var domElement = isSelectorString ? document.querySelector(selectorOrHTMLElement) : selectorOrHTMLElement;
    if (!(0, $d1c6525bd1a9ce28$export$2e2bcd8739ae039)(domElement)) {
        var errorMessage = "Container must be `string` or `HTMLElement`.";
        if (isSelectorString) errorMessage += " Unable to find ".concat(selectorOrHTMLElement);
        throw new Error(errorMessage);
    }
    return domElement;
}
var $becc0ebef8d50019$export$2e2bcd8739ae039 = $becc0ebef8d50019$var$getContainerNode;


function $40de1f5e3df163b2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $40de1f5e3df163b2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $40de1f5e3df163b2$var$ownKeys(Object(source), true).forEach(function(key) {
            $40de1f5e3df163b2$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $40de1f5e3df163b2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $40de1f5e3df163b2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $40de1f5e3df163b2$var$_toConsumableArray(arr) {
    return $40de1f5e3df163b2$var$_arrayWithoutHoles(arr) || $40de1f5e3df163b2$var$_iterableToArray(arr) || $40de1f5e3df163b2$var$_unsupportedIterableToArray(arr) || $40de1f5e3df163b2$var$_nonIterableSpread();
}
function $40de1f5e3df163b2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $40de1f5e3df163b2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $40de1f5e3df163b2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $40de1f5e3df163b2$var$_arrayLikeToArray(o, minLen);
}
function $40de1f5e3df163b2$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $40de1f5e3df163b2$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $40de1f5e3df163b2$var$_arrayLikeToArray(arr);
}
function $40de1f5e3df163b2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $40de1f5e3df163b2$var$prepareTemplates(defaultTemplates) {
    var templates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allKeys = (0, $23f14a556c3a59a3$export$2e2bcd8739ae039)([].concat($40de1f5e3df163b2$var$_toConsumableArray(Object.keys(defaultTemplates || {})), $40de1f5e3df163b2$var$_toConsumableArray(Object.keys(templates))));
    return allKeys.reduce(function(config, key) {
        var defaultTemplate = defaultTemplates ? defaultTemplates[key] : undefined;
        var customTemplate = templates[key];
        var isCustomTemplate = customTemplate !== undefined && customTemplate !== defaultTemplate;
        config.templates[key] = isCustomTemplate ? customTemplate // typescript doesn't recognize that this condition asserts customTemplate is defined
         : defaultTemplate;
        config.useCustomCompileOptions[key] = isCustomTemplate;
        return config;
    }, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        templates: {},
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        useCustomCompileOptions: {}
    });
}
/**
 * Prepares an object to be passed to the Template widget
 */ function $40de1f5e3df163b2$var$prepareTemplateProps(_ref) {
    var defaultTemplates = _ref.defaultTemplates, templates = _ref.templates, templatesConfig = _ref.templatesConfig;
    var preparedTemplates = $40de1f5e3df163b2$var$prepareTemplates(defaultTemplates, templates);
    return $40de1f5e3df163b2$var$_objectSpread({
        templatesConfig: templatesConfig
    }, preparedTemplates);
}
var $40de1f5e3df163b2$export$2e2bcd8739ae039 = $40de1f5e3df163b2$var$prepareTemplateProps;



// We aren't using the native `Array.prototype.find` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `find` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.find` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
function $db538cb02b31f06e$var$find(items, predicate) {
    var value;
    for(var i = 0; i < items.length; i++){
        value = items[i]; // inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
        if (predicate(value, i, items)) return value;
    }
    return undefined;
}
var $db538cb02b31f06e$export$2e2bcd8739ae039 = $db538cb02b31f06e$var$find;


function $041f7f08b7e5601a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $041f7f08b7e5601a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $041f7f08b7e5601a$var$ownKeys(Object(source), true).forEach(function(key) {
            $041f7f08b7e5601a$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $041f7f08b7e5601a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $041f7f08b7e5601a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $041f7f08b7e5601a$var$getSelectedHits = function getSelectedHits(hits, selectedObjectIDs) {
    return selectedObjectIDs.map(function(objectID) {
        var hit = (0, $db538cb02b31f06e$export$2e2bcd8739ae039)(hits, function(h) {
            return h.objectID === objectID;
        });
        if (typeof hit === "undefined") throw new Error('Could not find objectID "'.concat(objectID, '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'));
        return hit;
    });
};
var $041f7f08b7e5601a$var$getQueryID = function getQueryID(selectedHits) {
    var queryIDs = (0, $23f14a556c3a59a3$export$2e2bcd8739ae039)(selectedHits.map(function(hit) {
        return hit.__queryID;
    }));
    if (queryIDs.length > 1) throw new Error("Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.");
    var queryID = queryIDs[0];
    if (typeof queryID !== "string") throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
    return queryID;
};
var $041f7f08b7e5601a$var$getPositions = function getPositions(selectedHits) {
    return selectedHits.map(function(hit) {
        return hit.__position;
    });
};
var $041f7f08b7e5601a$export$24bd91850d68b36c = function inferPayload(_ref) {
    var method = _ref.method, results = _ref.results, hits = _ref.hits, objectIDs = _ref.objectIDs;
    var index = results.index;
    var selectedHits = $041f7f08b7e5601a$var$getSelectedHits(hits, objectIDs);
    var queryID = $041f7f08b7e5601a$var$getQueryID(selectedHits);
    switch(method){
        case "clickedObjectIDsAfterSearch":
            var positions = $041f7f08b7e5601a$var$getPositions(selectedHits);
            return {
                index: index,
                queryID: queryID,
                objectIDs: objectIDs,
                positions: positions
            };
        case "convertedObjectIDsAfterSearch":
            return {
                index: index,
                queryID: queryID,
                objectIDs: objectIDs
            };
        default:
            throw new Error('Unsupported method passed to insights: "'.concat(method, '".'));
    }
};
var $041f7f08b7e5601a$var$wrapInsightsClient = function wrapInsightsClient(aa, results, hits) {
    return function(method, payload) {
        if (!aa) {
            var withInstantSearchUsage = (0, $222bd44957f3ca8f$export$2fde5bffc340821e)({
                name: "instantsearch"
            });
            throw new Error(withInstantSearchUsage("The `insightsClient` option has not been provided to `instantsearch`."));
        }
        if (!Array.isArray(payload.objectIDs)) throw new TypeError("Expected `objectIDs` to be an array.");
        var inferredPayload = $041f7f08b7e5601a$export$24bd91850d68b36c({
            method: method,
            results: results,
            hits: hits,
            objectIDs: payload.objectIDs
        });
        aa(method, $041f7f08b7e5601a$var$_objectSpread($041f7f08b7e5601a$var$_objectSpread({}, inferredPayload), payload));
    };
};
function $041f7f08b7e5601a$export$2e2bcd8739ae039(connector) {
    return function(renderFn, unmountFn) {
        return connector(function(renderOptions, isFirstRender) {
            var results = renderOptions.results, hits = renderOptions.hits, instantSearchInstance = renderOptions.instantSearchInstance;
            if (results && hits && instantSearchInstance) {
                var insights = $041f7f08b7e5601a$var$wrapInsightsClient(instantSearchInstance.insightsClient, results, hits);
                return renderFn($041f7f08b7e5601a$var$_objectSpread($041f7f08b7e5601a$var$_objectSpread({}, renderOptions), {}, {
                    insights: insights
                }), isFirstRender);
            }
            return renderFn(renderOptions, isFirstRender);
        }, unmountFn);
    };
}

/** @jsx h */ 


var $16698bd1a89ea5f4$var$findInsightsTarget = function findInsightsTarget(startElement, endElement, validator) {
    var element = startElement;
    while(element && !validator(element)){
        if (element === endElement) return null;
        element = element.parentElement;
    }
    return element;
};
var $16698bd1a89ea5f4$var$parseInsightsEvent = function parseInsightsEvent(element) {
    var serializedPayload = element.getAttribute("data-insights-event");
    if (typeof serializedPayload !== "string") throw new Error("The insights middleware expects `data-insights-event` to be a base64-encoded JSON string.");
    try {
        return (0, $3fe0a367fb335f83$export$706ea24b0964bee9)(serializedPayload);
    } catch (error) {
        throw new Error("The insights middleware was unable to parse `data-insights-event`.");
    }
};
var $16698bd1a89ea5f4$var$insightsListener = function insightsListener(BaseComponent) {
    function WithInsightsListener(props) {
        var handleClick = function handleClick(event) {
            if (props.sendEvent) {
                // new way with insights middleware
                var targetWithEvent = $16698bd1a89ea5f4$var$findInsightsTarget(event.target, event.currentTarget, function(element) {
                    return element.hasAttribute("data-insights-event");
                });
                if (targetWithEvent) {
                    var payload = $16698bd1a89ea5f4$var$parseInsightsEvent(targetWithEvent);
                    props.sendEvent(payload);
                }
            } // old way, e.g. instantsearch.insights("clickedObjectIDsAfterSearch", { .. })
            var insightsTarget = $16698bd1a89ea5f4$var$findInsightsTarget(event.target, event.currentTarget, function(element) {
                return (0, $1df60413cb0e41e0$export$75ec42bbd0a5e7d6)(element);
            });
            if (insightsTarget) {
                var _readDataAttributes = (0, $1df60413cb0e41e0$export$cbcfede36ce7ab2e)(insightsTarget), method = _readDataAttributes.method, _payload = _readDataAttributes.payload;
                props.insights(method, _payload);
            }
        };
        return (0, $806372f2f9cb9e83$export$c8a8987d4410bf2d)("div", {
            onClick: handleClick
        }, (0, $806372f2f9cb9e83$export$c8a8987d4410bf2d)(BaseComponent, props));
    }
    return WithInsightsListener;
};
var $16698bd1a89ea5f4$export$2e2bcd8739ae039 = $16698bd1a89ea5f4$var$insightsListener;


function $4bd35db871e1ecbb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4bd35db871e1ecbb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4bd35db871e1ecbb$var$ownKeys(Object(source), true).forEach(function(key) {
            $4bd35db871e1ecbb$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4bd35db871e1ecbb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4bd35db871e1ecbb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $4bd35db871e1ecbb$var$withUsage = (0, $222bd44957f3ca8f$export$2fde5bffc340821e)({
    name: "hits"
});
var $4bd35db871e1ecbb$var$suit = (0, $9426e41dc741124c$export$d8556a2a8f973135)("Hits");
var $4bd35db871e1ecbb$var$HitsWithInsightsListener = (0, $16698bd1a89ea5f4$export$2e2bcd8739ae039)((0, $74e53deaa39b7aad$export$2e2bcd8739ae039));
var $4bd35db871e1ecbb$var$renderer = function renderer(_ref) {
    var renderState = _ref.renderState, cssClasses = _ref.cssClasses, containerNode = _ref.containerNode, templates = _ref.templates;
    return function(_ref2, isFirstRendering) {
        var receivedHits = _ref2.hits, results = _ref2.results, instantSearchInstance = _ref2.instantSearchInstance, insights = _ref2.insights, bindEvent = _ref2.bindEvent;
        if (isFirstRendering) {
            renderState.templateProps = (0, $40de1f5e3df163b2$export$2e2bcd8739ae039)({
                defaultTemplates: (0, $cfc25ba7b6d73167$export$2e2bcd8739ae039),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            return;
        }
        (0, $806372f2f9cb9e83$export$b3890eb0ae9dca99)((0, $806372f2f9cb9e83$export$c8a8987d4410bf2d)($4bd35db871e1ecbb$var$HitsWithInsightsListener, {
            cssClasses: cssClasses,
            hits: receivedHits,
            results: results,
            templateProps: renderState.templateProps,
            insights: insights,
            sendEvent: function sendEvent(event) {
                instantSearchInstance.sendEventToInsights(event);
            },
            bindEvent: bindEvent
        }), containerNode);
    };
};
var $4bd35db871e1ecbb$var$hits = function hits(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, escapeHTML = _ref3.escapeHTML, transformItems = _ref3.transformItems, _ref3$templates = _ref3.templates, templates = _ref3$templates === void 0 ? (0, $cfc25ba7b6d73167$export$2e2bcd8739ae039) : _ref3$templates, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses;
    if (!container) throw new Error($4bd35db871e1ecbb$var$withUsage("The `container` option is required."));
    var containerNode = (0, $becc0ebef8d50019$export$2e2bcd8739ae039)(container);
    var cssClasses = {
        root: (0, (/*@__PURE__*/$parcel$interopDefault($54ef7be12d5d63e7$exports)))($4bd35db871e1ecbb$var$suit(), userCssClasses.root),
        emptyRoot: (0, (/*@__PURE__*/$parcel$interopDefault($54ef7be12d5d63e7$exports)))($4bd35db871e1ecbb$var$suit({
            modifierName: "empty"
        }), userCssClasses.emptyRoot),
        list: (0, (/*@__PURE__*/$parcel$interopDefault($54ef7be12d5d63e7$exports)))($4bd35db871e1ecbb$var$suit({
            descendantName: "list"
        }), userCssClasses.list),
        item: (0, (/*@__PURE__*/$parcel$interopDefault($54ef7be12d5d63e7$exports)))($4bd35db871e1ecbb$var$suit({
            descendantName: "item"
        }), userCssClasses.item)
    };
    var specializedRenderer = $4bd35db871e1ecbb$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        renderState: {},
        templates: templates
    });
    var makeWidget = (0, $041f7f08b7e5601a$export$2e2bcd8739ae039)((0, $a77e9a517cc7366e$export$2e2bcd8739ae039))(specializedRenderer, function() {
        return (0, $806372f2f9cb9e83$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $4bd35db871e1ecbb$var$_objectSpread($4bd35db871e1ecbb$var$_objectSpread({}, makeWidget({
        escapeHTML: escapeHTML,
        transformItems: transformItems
    })), {}, {
        $$widgetType: "ais.hits"
    });
};
var $4bd35db871e1ecbb$export$2e2bcd8739ae039 = $4bd35db871e1ecbb$var$hits;



function $654a5f2c29f6b01d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $654a5f2c29f6b01d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $654a5f2c29f6b01d$var$ownKeys(Object(source), true).forEach(function(key) {
            $654a5f2c29f6b01d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $654a5f2c29f6b01d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $654a5f2c29f6b01d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $654a5f2c29f6b01d$var$withUsage = (0, $222bd44957f3ca8f$export$2fde5bffc340821e)({
    name: "search-box",
    connector: true
});
/**
 * **SearchBox** connector provides the logic to build a widget that will let the user search for a query.
 *
 * The connector provides to the rendering: `refine()` to set the query. The behaviour of this function
 * may be impacted by the `queryHook` widget parameter.
 */ var $654a5f2c29f6b01d$var$connectSearchBox = function connectSearchBox(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $0387abbfc54484f5$export$2e2bcd8739ae039);
    (0, $5ea0f33637ed3157$export$2e2bcd8739ae039)(renderFn, $654a5f2c29f6b01d$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, queryHook = _ref.queryHook;
        function clear(helper) {
            return function() {
                helper.setQuery("").search();
            };
        }
        var _refine;
        var _clear = function _clear() {};
        function _cachedClear() {
            _clear();
        }
        return {
            $$type: "ais.searchBox",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($654a5f2c29f6b01d$var$_objectSpread($654a5f2c29f6b01d$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($654a5f2c29f6b01d$var$_objectSpread($654a5f2c29f6b01d$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return state.setQueryParameter("query", undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $654a5f2c29f6b01d$var$_objectSpread($654a5f2c29f6b01d$var$_objectSpread({}, renderState), {}, {
                    searchBox: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref3) {
                var helper = _ref3.helper, searchMetadata = _ref3.searchMetadata;
                if (!_refine) {
                    var setQueryAndSearch = function setQueryAndSearch(query) {
                        if (query !== helper.state.query) helper.setQuery(query).search();
                    };
                    _refine = function _refine(query) {
                        if (queryHook) {
                            queryHook(query, setQueryAndSearch);
                            return;
                        }
                        setQueryAndSearch(query);
                    };
                }
                _clear = clear(helper);
                return {
                    query: helper.state.query || "",
                    refine: _refine,
                    clear: _cachedClear,
                    widgetParams: widgetParams,
                    isSearchStalled: searchMetadata.isSearchStalled
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var query = searchParameters.query || "";
                if (query === "" || uiState && uiState.query === query) return uiState;
                return $654a5f2c29f6b01d$var$_objectSpread($654a5f2c29f6b01d$var$_objectSpread({}, uiState), {}, {
                    query: query
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                return searchParameters.setQueryParameter("query", uiState.query || "");
            }
        };
    };
};
var $654a5f2c29f6b01d$export$2e2bcd8739ae039 = $654a5f2c29f6b01d$var$connectSearchBox;



const $e62a608a458afe46$var$search = (0, $fc0971d2e4ca7c40$export$2e2bcd8739ae039)({
    indexName: undefined,
    searchClient: (0, (/*@__PURE__*/$parcel$interopDefault($fda0a82cede31420$exports)))(undefined, undefined),
    numberLocale: "fr"
});
const $e62a608a458afe46$var$getSearchBox = function() {
    const isHidden = (el)=>{
        const style = window.getComputedStyle(el);
        return style.display === "none" || style.visibility === "hidden";
    };
    const all = document.getElementsByTagName("*");
    for (const el of all){
        if (!isHidden(el) && el.querySelector(".searchbox")) return el.querySelector(".searchbox");
    }
};
const $e62a608a458afe46$var$renderSearchBox = (renderOptions, isFirstRender)=>{
    const { query: query, refine: refine, widgetParams: widgetParams } = renderOptions;
    const container = document.querySelector(widgetParams.container);
    const tpl = document.querySelector(widgetParams.tpl);
    if (isFirstRender) {
        const form = tpl.content.firstElementChild.cloneNode(true);
        const input = form.querySelector("input");
        input.addEventListener("input", (event)=>{
            refine(event.target.value);
        });
        container.appendChild(form);
        const params = new window.URLSearchParams(window.location.search);
        input.value = params.get("q");
        input.focus();
        refine(input.value);
    }
};
const $e62a608a458afe46$var$customSearchBox = (0, $654a5f2c29f6b01d$export$2e2bcd8739ae039)($e62a608a458afe46$var$renderSearchBox);
$e62a608a458afe46$var$search.addWidgets([
    $e62a608a458afe46$var$customSearchBox({
        container: "#searchbox-sidebar",
        tpl: "#searchbox-sidebar-tpl"
    }),
    $e62a608a458afe46$var$customSearchBox({
        container: "#searchbox-mobile",
        tpl: "#searchbox-sidebar-mobile"
    }),
    (0, $4bd35db871e1ecbb$export$2e2bcd8739ae039)({
        container: "#hits",
        templates: {
            item (item) {
                const results = [];
                results.push(`<div class="article py-4">`);
                results.push(`<h3 class="px-3 article__title"><a class="text-decoration-none" href="${item.url}">${item._highlightResult.title.value}</a></h3>`);
                results.push(`<div class="px-3 article__info">${item.infos}</div>`);
                if (item._highlightResult.authors) {
                    results.push(`<div class="px-3 article__authors">`);
                    const authors = item._highlightResult.authors;
                    for(let i = 0; i < authors.length; i++){
                        results.push(`<span>${authors[i].value}</span>`);
                        if (i != authors.length - 1) results.push(`,&nbsp;`);
                    }
                }
                results.push(`
          <div class="px-3 article__content">${item._snippetResult.content.value}</div>
          </div>
          `);
                return results.join("");
            }
        }
    })
]);
$e62a608a458afe46$var$search.start();

})();
//# sourceMappingURL=search.js.map
